export const customSchemaInfo = {
  "alk-deteccion-del-reordenamiento-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "ALK detección del reordenamiento por FISH",
    description:
      "Ensayo cualitativo que se utiliza para detectar reordenamientos en el gen ALK a través de FISH.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/alk-deteccion-del-reordenamiento-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "4982 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "4483.80 MXN",
      },
    ],
  },
  "bcl6-deteccion-del-reordenamiento-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "BCL6 detección del reordenamiento por FISH",
    description:
      "Esta prueba está diseñada para detectar reordenamientos cromosómicos de la región 3q27 del cromosoma 3 de pacientes con sospecha o diagnóstico de linfoma no hodgkiniano. El conocimiento del estado de reordenamiento del gen BCL6 es relevante para el tratamiento clínico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/bcl6-deteccion-del-reordenamiento-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "4300 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "3870 MXN",
      },
    ],
  },
  "c-kit-y-pdgfra-gist-deteccion-por-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "c-kit y PDGFRA-GIST detección por qPCR",
    description:
      "Esta prueba ayuda a determinar si los pacientes son candidatos a tratamiento con imatinib (puede haber resistencia), sunitinib, ripretinib.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/c-kit-y-pdgfra-gist-deteccion-por-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido FFPE.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14310 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "12879 MXN",
      },
    ],
  },
  "cdkn2a-deteccion-de-delecion-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "CDKN2A detección de deleción por FISH",
    description:
      "Esta prueba permite detectar deleción en el gen CDKN2A, el cual está frecuentemente inactivado en diversos tumores primarios, por ejemplo, carcinoma de vejiga y de células renales, adenocarcinoma de próstata y ovario, cáncer de pulmón no microcítico, sarcoma, mesotelioma y melanoma. Además, deleciones del gen CDKN2A se observan en hasta el 80 % de los casos de leucemia linfocítica aguda de linfocitos T, asociadas con un pronóstico desfavorable y recaída de la enfermedad. La pérdida de secuencias de este gen provoca una excesiva proliferación celular y una regulación incorrecta de las vías proapoptóticas, lo cual se asocia a una evolución maligna, haciéndola un marcador de mal pronóstico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/cdkn2a-deteccion-de-delecion-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido FFPE.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2226 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2003.40 MXN",
      },
    ],
  },
  "citomegalovirus-deteccion-por-pcr-tiempo-real": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citomegalovirus detección por PCR tiempo real",
    description:
      "Esta prueba está diseñada para la detección de citomegalovirus por PCR en tiempo real, es especialmente importante en neonatos y pacientes con inmunocompromiso celular y humoral, especialmente SIDA y pacientes con cáncer hematológico o de tumores sólidos, donadores y receptores de trasplante de médula ósea y órganos sólidos, pacientes bajo esquemas de quimioterapia.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citomegalovirus-deteccion-por-pcr-tiempo-real",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre total, Plasma.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "No requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3074 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2766.60 MXN",
      },
    ],
  },
  "deteccion-de-amplificacion-de-her2-neu-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Detección de amplificación de HER2/NEU por FISH",
    description:
      "Esta prueba está diseñada para detectar la amplificación del gen HER-2/NEU en muestras de tejido con cáncer de mama humano. Se indica cómo ayuda para pronosticar la supervivencia libre de enfermedad y global en pacientes con cáncer de mama con ganglios positivos en fase II tratadas con quimioterapia adyuvante de ciclofosfamida, doxorubicina y 5-fluorouracilo (CAF). Así como, en la evaluación de pacientes para las que se esté considerando el tratamiento con trastuzumab.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/deteccion-de-amplificacion-de-her2-neu-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Tejido tumoral fijado en formalina y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Entregar muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "7420 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "6678.00 MXN",
      },
    ],
  },
  "deteccion-de-amplificacion-del-gen-egfr-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Detección de amplificación del gen EGFR por FISH",
    description:
      "Esta prueba está diseñada para detectar la amplificación del gen HER-2/NEU en muestras de tejido con cáncer de mama humano. Se indica cómo ayuda para pronosticar la supervivencia libre de enfermedad y global en pacientes con cáncer de mama con ganglios positivos en fase II tratadas con quimioterapia adyuvante de ciclofosfamida, doxorubicina y 5-fluorouracilo (CAF). Así como, en la evaluación de pacientes para las que se esté considerando el tratamiento con trastuzumab.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/deteccion-de-amplificacion-del-gen-egfr-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Tejido tumoral fijado en formalina y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Entregar muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Hibridación fluorescente in situ (FISH).",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "5406 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "4865.40 MXN",
      },
    ],
  },
  "deteccion-de-amplificacion-del-gen-mdm2-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Detección de amplificación del gen MDM2 por FISH",
    description:
      "Esta prueba detecta el número de copias del gen MDM2 localizado en la región cromosómica 12q-q15. En esta región se producen a menudo translocaciones y amplificaciones relacionadas con sarcomas de tejidos blandos y leucemia linfocítica crónica. El gen MDM2 reprime la actividad transcripcional de p53, esto tiene como consecuencia la inactivación del supresor tumoral, la formación de tumores y en último término deriva en cáncer.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/deteccion-de-amplificacion-del-gen-mdm2-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "4558 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "4102.20 MXN",
      },
    ],
  },
  "deteccion-de-chlamydia-trachomatis-y-neisseria-gonorrhoeae": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Detección de Chlamydia trachomatis y Neisseria gonorrhoeae (STI-CT_NG)",
    description:
      "Prueba cualitativa para la detección de las bacterias Chlamydia trachomatis y Neisseria gonorrhoeae.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/deteccion-de-chlamydia-trachomatis-y-neisseria-gonorrhoeae",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2-3 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "-Orina, hisopado de cérvix/vaginal, hisopado uretral",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "-No se debe orinar por al menos dos horas antes de la recolección de las muestras.\n-Recolectar 10~30 mL de la primera orina de la mañana en un contenedor de polipropileno estéril.\n-Para mujeres evitar el uso de cremas y medicamentos en la vagina durante los dos días previos al examen.\n-No realizar duchas vaginales. Si se toma antibióticos, terminar el tratamiento una semana antes de la toma de la muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Esta nos permite detectar los principales agentes causantes de enfermedad de transmisión sexual y para guiar el tratamiento. En caso de salir positivas en cualquiera de estas se sugiere prueba de VIH. Se recomienda en embarazo durante la primera visita prenatal (en el primer trimestre) y en último trimestre, especialmente cuando existen factores de riesgo.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2500 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2250.00 MXN",
      },
    ],
  },
  "deteccion-de-la-fusion-de-bcl2-igh-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Detección de la fusión de BCL2-IGH por FISH",
    description:
      "Esta prueba permite detectar la translocación t(14;18)(q32;q21) que involucra la cadena pesada de las inmunoglobulinas con el gen bcl2 lo cual permite diagnosticar la leucemia y linfoma de células B.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/deteccion-de-la-fusion-de-bcl2-igh-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "7420 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "6678.00 MXN",
      },
    ],
  },
  "deteccion-de-la-fusion-myc-igh-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Detección de la fusión MyC-IGH por FISH",
    description:
      "Esta prueba se utiliza para detectar la translocación que afecta a las regiones de los genes IGH y MYC. Esta translocación es característica del linfoma de Burkitt y se produce en aproximadamente en el 80% de los casos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/deteccion-de-la-fusion-myc-igh-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3604 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "3243.60 MXN",
      },
    ],
  },
  "deteccion-de-las-deleciones-1p36-1q25-y-19q13-19p13-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Detección de las deleciones 1p36/1q25 y 19q13/19p13 por FISH",
    description:
      "Esta prueba permite detectar deleciones en las regiones cromosómicas 1p36 y 19q13, la cual es una característica molecular frecuente de los tumores oligodendriogliales. Los pacientes con esta alteración tienen una mayor tasa de supervivencia en comparación con los pacientes que no la presentan. Esta mutación puede ser usada en la práctica clínica para el diagnóstico, pronóstico y como un importante biomarcador predictivo de los tumores oligodendriogliales.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/deteccion-de-las-deleciones-1p36-1q25-y-19q13-19p13-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "5830 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "5247.00 MXN",
      },
    ],
  },
  "deteccion-de-mutaciones-en-los-exones-12-13-de-kras-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Detección de mutaciones en los exones 12-13 de KRAS por PCR",
    description:
      "Esta prueba está diseñada para detectar mutaciones en el gen KRAS, estas mutaciones conducen a la falta de efectividad a ciertos fármacos, importante en cáncer colorrectal, pancreático, cáncer pulmonar de células no pequeñas, LMA y otros tipos de tumores. Esta prueba permite direccionar el tratamiento de los pacientes.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/deteccion-de-mutaciones-en-los-exones-12-13-de-kras-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "7950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "7155.00 MXN",
      },
    ],
  },
  "deteccion-de-mutaciones-en-los-exones-18-21-de-egfr-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Detección de mutaciones en los Exones 18-21 de EGFR por PCR",
    description:
      "Esta prueba se puede utilizar como parte del abordaje terapéutico en pacientes con cáncer pulmonar de células no pequeñas. Los resultados indican que pacientes se pueden beneficiar con terapias como afatinib y erlotinib, también hay estudios corriendo en glioblastoma.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/deteccion-de-mutaciones-en-los-exones-18-21-de-egfr-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido FFPE, Tejido fresco.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "9010 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "8109.00 MXN",
      },
    ],
  },
  "deteccion-de-ureaplasma-parvum-ureaplasma-urealyticum-mycoplasma-genitalium-mycoplasma-hominis":
    {
      "@context": "https://schema.org",
      "@type": "MedicalTest",
      name: "Detección de Ureaplasma parvum, Ureaplasma urealyticum, Mycoplasma genitalium, Mycoplasma hominis (STI-UM)",
      description:
        "Prueba cualitativa para la detección de las bacterias Ureaplasma parvum, Ureaplasma urealyticum, Mycoplasma genitalium, Mycoplasma hominis.",
      recognizingAuthority: {
        "@type": "Organization",
        name: "Labopat",
        url: "https://www.labopat.mx/estudio/deteccion-de-ureaplasma-parvum,-ureaplasma-urealyticum,-mycoplasma-genitalium,-mycoplasma-hominis",
      },
      additionalProperty: [
        {
          "@type": "PropertyValue",
          name: "Tiempo de entrega",
          value: "2-3 días hábiles",
        },
        {
          "@type": "PropertyValue",
          name: "Tipo de muestra",
          value: "-Orina, hisopado de cérvix/vaginal, hisopado uretral.",
        },
        {
          "@type": "PropertyValue",
          name: "Indicaciones",
          value:
            "-No se debe orinar por al menos dos horas antes de la recolección de las muestras.\n-Recolectar 10~30 mL de la primera orina de la mañana en un contenedor de polipropileno estéril. Para mujeres evitar el uso de cremas y medicamentos en la vagina durante los dos días previos al examen.\n-No realizar duchas vaginales. Si se toma antibióticos, terminar el tratamiento una semana antes de la toma de la muestra.",
        },
        {
          "@type": "PropertyValue",
          name: "Información",
          value:
            "Esta nos permite detectar los principales agentes causantes de enfermedad de transmisión sexual y guiar el tratamiento. En caso de salir positivas en cualquiera de estas se sugiere prueba de VIH. Se recomienda en embarazo durante la primera visita prenatal (en el primer trimestre) y en último trimestre, especialmente cuando existen factores de riesgo.",
        },
        {
          "@type": "PropertyValue",
          name: "Precio en sucursal",
          value: "2500 MXN",
        },
        {
          "@type": "PropertyValue",
          name: "Pago en línea",
          value: "2250.00 MXN",
        },
      ],
    },
  "deteccion-del-reordenamiento-de-myc-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Detección del reordenamiento de MyC por FISH",
    description:
      "Esta prueba se utiliza para la detección de reordenamientos cromosómicos que afectan a la región del gen MYC en el cromosoma 8q24. Estos reordenamientos tienen importancia diagnóstica y pronóstica en las neoplasias de los linfocitos B.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/deteccion-del-reordenamiento-de-myc-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "4346 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "3911.40 MXN",
      },
    ],
  },
  "deteccion-del-virus-herpes-simple-1-y-2": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Detección del Virus Herpes simple 1 y 2 (STI-VHS)",
    description:
      "Prueba cualitativa para la detección de los virus Herpes simple 1 y 2.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/deteccion-del-virus-herpes-simple-1-y-2",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2-3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Orina, hisopado de cérvix/vaginal, hisopado uretral.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "-No se debe orinar por al menos dos horas antes de la recolección de las muestras.\n-Recolectar 10~30 mL de la primera orina de la mañana en un contenedor de polipropileno estéril. Para mujeres evitar el uso de cremas y medicamentos en la vagina durante los dos días previos al examen.\n-No realizar duchas vaginales. Si se toma antibióticos, terminar el tratamiento una semana antes de la toma de la muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Esta nos permite detectar los principales agentes causantes de enfermedad de transmisión sexual y guiar el tratamiento. En caso de salir positivas en cualquiera de estas se sugiere prueba de VIH. Se recomienda en embarazo durante la primera visita prenatal (en el primer trimestre) y en último trimestre, especialmente cuando existen factores de riesgo.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2500 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2250.00 MXN",
      },
    ],
  },
  "eber-deteccion-por-cish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "EBER detección por CISH",
    description:
      "Esta prueba permite detectar material del virus de Epstein Barr y ayuda al diagnóstico diferencial en linfomas (LH, LNH, carcinoma nasofaríngeo, carcinoma gástrico).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/eber-deteccion-por-cish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido FFPE.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "CISH. Virus Epstein Barr",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2728.27 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2250.00 MXN",
      },
    ],
  },
  "epstein-barr-cuantificacion-de-la-carga-viral-por-pcr-tiempo-real": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Epstein Barr cuantificación de la carga viral por PCR tiempo real",
    description:
      "La determinación de la carga viral de VEB es necesaria para el seguimiento de pacientes infectados y ayuda a determinar el grado de afectación fetal en gestantes afectados con el virus. Debido a que los resultados de la cuantificación de carga viral se relacionan con el diagnóstico, vigilancia y seguimiento de la infección, se puede utilizar como guía para cambios en el plan de tratamiento.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/epstein-barr-cuantificacion-de-la-carga-viral-por-pcr-tiempo-real",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre total, Plasma.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "PCR tiempo real.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3074.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2766.60 MXN",
      },
    ],
  },
  "epstein-barr-deteccion-por-pcr-tiempo-real": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Epstein Barr detección por PCR tiempo real",
    description:
      "Con esta prueba se puede confirmar diagnóstico y determinar tratamiento.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/epstein-barr-deteccion-por-pcr-tiempo-real",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre total, Plasma.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "PCR tiempo real.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2650.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2385.00 MXN",
      },
    ],
  },
  "hepatitis-b-cuantificacion-de-la-carga-viral-por-pcr-tiempo-real": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Hepatitis B cuantificación de la carga viral por PCR tiempo real",
    description:
      "La determinación de la carga viral de VHB es necesaria para el seguimiento de pacientes infectados y ayuda a determinar el grado de afectación fetal en gestantes afectados con el virus. Debido a que los resultados de la cuantificación de carga viral se relacionan con el diagnóstico, vigilancia y seguimiento de la infección, se puede utilizar como guía para cambios en el plan de tratamiento.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/hepatitis-b-cuantificacion-de-la-carga-viral-por-pcr-tiempo-real",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre total, Plasma.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Virus de la hepatitis B.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3074.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2766.60 MXN",
      },
    ],
  },
  "hepatitis-b-deteccion-por-pcr-tiempo-real": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Hepatitis B detección por PCR tiempo real",
    description:
      "Con esta prueba se puede confirmar diagnóstico y determinar tratamiento.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/hepatitis-b-deteccion-por-pcr-tiempo-real",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre total, Plasma.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Virus de la hepatitis B.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2650.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2385.00 MXN",
      },
    ],
  },
  "hepatitis-c-cuantificacion-de-la-carga-viral-por-pcr-tiempo-real": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Hepatitis C cuantificación de la carga viral por PCR tiempo real",
    description:
      "La determinación de la carga viral de VHC es necesaria para el seguimiento de pacientes infectados y ayuda a determinar el grado de afectación fetal en gestantes afectados con el virus. Debido a que los resultados de la cuantificación de carga viral se relacionan con el diagnóstico, vigilancia y seguimiento de la infección, se puede utilizar como guía para cambios en el plan de tratamiento.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/hepatitis-c-cuantificacion-de-la-carga-viral-por-pcr-tiempo-real",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre total, Plasma.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Virus de la hepatitis C.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3074.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2766.60 MXN",
      },
    ],
  },
  "hepatitis-c-deteccion-por-pcr-tiempo-real": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Hepatitis C detección por PCR tiempo real",
    description:
      "Con esta prueba se puede confirmar diagnóstico y determinar tratamiento.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/hepatitis-c-deteccion-por-pcr-tiempo-real",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre total, Plasma.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Virus de la hepatitis C.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2650.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2385.00 MXN",
      },
    ],
  },
  "idh1-2-deteccion-por-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "IDH1/2 detección por qPCR",
    description:
      "Esta prueba tiene valor diagnóstico, pronósitco y terapias blanco. Diagnóstico en tumores SNC: glioblastomas, astrocitoma anaplásico, oligodendrogliomas, leucemia mieloide aguda, síndrome mielodisplásico para determinar riesgo de transformación a LAM, raro en mieloproliferativos pero no tan infrecuente en fase blástica, linfoma de células T angioinmunoblástico, colangiocarcinoma, osteocondromas, tumores mesenquimales, con menor frecuencia en carcinoma tiroideo, próstata, colorrectal. Pueden funcionar los inhibidores PARP en tumores que contengan estas mutaciones. Ayuda a determinar si son candidatos a terapia o no.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/idh1-2-deteccion-por-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Entregar muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Metodología: PCR tiempo real.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "10812.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "9730.80 MXN",
      },
    ],
  },
  "jak2-deteccion-de-mutaciones-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "JAK2 detección de mutaciones por PCR",
    description:
      "Esta prueba permite diagnosticar y tipificar neoplasias mieloproliferativas.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/jak2-deteccion-de-mutaciones-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre total, médula ósea o tejido PFFE.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Metodología: PCR punto final.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "4770.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "4293.00 MXN",
      },
    ],
  },
  "melanoma-panel-diagnostico-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Melanoma Panel Diagnóstico por FISH",
    description:
      "Esta prueba permite determinar el número de copias de los genes RREB1 (6p25), MYB (6q23) y CCND1 (11q13) con la finalidad de facilitar el diagnóstico diferencial de melanoma.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/melanoma-panel-diagnostico-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido FFPE.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "RREB1, MYB, CCND1.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "13780.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "12402.00 MXN",
      },
    ],
  },
  "mgmt-deteccion-y-cuantificacion-por-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "MGMT detección y cuantificación por qPCR",
    description:
      "Esta prueba nos permite detectar y cuantificar la metilación del gen O-6-Metilguanina-DNA-metiltransferasa (MGMT) mediante PCR en tiempo real. El grado de metilación de este gen tiene un valor pronóstico y predictivo de respuesta a temozolomida en los pacientes diagnosticados con glioblastoma multiforme.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/mgmt-deteccion-y-cuantificacion-por-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Método: PCR tiempo real.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "6890.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "6201.00 MXN",
      },
    ],
  },
  "mtb-mntb-deteccion-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "MTB/MNTB detección por PCR",
    description:
      "Esta prueba permite detectar si un paciente está infectado con algún tipo de micobacteria ya sea que cause o no tuberculosis.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/mtb-mntb-deteccion-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Tejido FFPE, tejido fresco, citología en base líquida, orina, esputo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "-Para la muestra de esputo los pacientes deben recolectar la muestra ya sea al aire libre o alejado de otras personas. Enjuagar la boca con agua, sin lavar los dientes antes de la recolección del esputo.\n-Para las muestras de orina se deberá avisar al paciente de no orinar por al menos dos horas antes de la recolección de las muestras.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "PCR punto final.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2650.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2385.00 MXN",
      },
    ],
  },
  "nras-deteccion-mut.-exon-12,13,-61-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "NRAS detección Mut. Exon 12,13, 61 qPCR",
    description:
      "Esta prueba detecta mutaciones en el gen NRAS, la presencia de dichas mutaciones tiene un valor diagnóstico, pronóstico y terapéutico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/nras-deteccion-mut.-exon-12,13,-61-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido FFPE.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "8544.45 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "7690.00 MXN",
      },
    ],
  },
  "panel-ampliado-de-deteccion-de-patogenos-de-transmision-sexual": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel ampliado de detección de patógenos de transmisión sexual (STI-13)",
    description:
      "Prueba cualitativa para la detección de 13 patógenos de transmisión sexual.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-ampliado-de-deteccion-de-patogenos-de-transmision-sexual",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2-3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Orina, hisopado de cérvix/vaginal, hisopado uretral.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "-El paciente no debe orinar por al menos dos horas antes de la recolección de las muestras.\n-Recolectar 10~30 mL de la primera orina de la mañana en un contenedor de polipropileno estéril. Para mujeres evitar el uso de cremas y medicamentos en la vagina durante los dos días previos al examen. \n-No realizar duchas vaginales. Si se toma antibióticos, terminar el tratamiento una semana antes de la toma de la muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Permite detectar los principales agentes causantes de enfermedad de transmisión sexual y guiar el tratamiento. En caso de salir positivas en cualquiera de estas se sugiere prueba de VIH. Se recomienda en embarazo durante la primera visita prenatal (en el primer trimestre) y en último trimestre, especialmente cuando existen factores de riesgo.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2700.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2430.00 MXN",
      },
    ],
  },
  "panel-de-tiroides-por-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel de Tiroides por qPCR",
    description:
      "Esta prueba se puede utilizar como parte de abordaje terapéutico, ayuda a determinar candidatos para inhibidores de kinasas tienen actividad anti-RET, ej: sorafenib, sunitinib, cabazantinib, vandetanib, ponatinib, lenvatinib.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-de-tiroides-por-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido FFPE.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "RET, PTC1, PETC3, PAX8 y PPARY.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "6678.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "6010.20 MXN",
      },
    ],
  },
  "panel-gastrointestinal--bacteriano-1-deteccion-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel Gastrointestinal Bacteriano 1 detección qPCR",
    description:
      "Detección e identificación de 7 bacterias causantes de infecciones gastrointestinales.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-gastrointestinal--bacteriano-1-deteccion-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Heces fecales.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Aeromonas spp. Campylobacter spp. Clostridium difficile toxina B Salmonella Shigella spp /E. coli enteroinvasiva Vibrio spp. Yersinia enterocolítica.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3300.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2970.00 MXN",
      },
    ],
  },
  "panel-gastrointestinal-bacteriano-2-deteccion-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel Gastrointestinal Bacteriano 2 detección qPCR",
    description:
      "Detección e identificación de 6 bacterias causantes de infecciones gastrointestinales.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-gastrointestinal-bacteriano-2-deteccion-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Heces fecales.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Enteroagregativa Enteropatogénica E. coli 02157 Enterotoxigénica Clostridium difficile hipervirulenta E. coli Productora de toxina shig.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3300.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2970.00 MXN",
      },
    ],
  },
  "panel-gastrointestinal-bacteriano-completo": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel Gastrointestinal Bacteriano Completo",
    description:
      "Detección e identificación de 13 bacterias causantes de infecciones gastrointestinales.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-gastrointestinal-bacteriano-completo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Heces fecales.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Aeromonas spp. Campylobacter spp. Clostridium difficile toxina B Salmonella Shigella spp /E. coli enteroinvasiva Vibrio spp. Yersinia enterocolítica. Enteroagregativa. Enteropatogénica. E. coli 02157. Enterotoxigénica. Clostridium difficile hipervirulenta. E. coli Productora de toxina shig.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "6000.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "5400.00 MXN",
      },
    ],
  },
  "panel-gastrointestinal-viral-deteccion-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel Gastrointestinal Viral detección qPCR",
    description:
      "Detección e identificación de 6 virus causantes de infecciones gastrointestinales.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-gastrointestinal-viral-deteccion-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Heces fecales.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Adenovirus, Astrovirus, Norovirus GI, Norovirus GII, Rotavirus, Sapovirus.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3300.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2970.00 MXN",
      },
    ],
  },
  "panel-gastrointestinal-viral-y-bacteriano-1": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel Gastrointestinal Viral y Bacteriano 1",
    description:
      "Detección e identificación de 7 bacterias y 6 virus causantes de infecciones gastrointestinales.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-gastrointestinal-viral-y-bacteriano-1",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Heces fecales.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Adenovirus, Astrovirus, Norovirus GI, Norovirus GII, Rotavirus, Sapovirus, Aeromonas spp., Campylobacter spp., Clostridium difficile toxina B, Salmonella, Shigella spp / E. coli enteroinvasiva, Vibrio spp., Yersinia enterocolítica.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "6000.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "5400.00 MXN",
      },
    ],
  },
  "panel-gastrointestinal-viral-y-bacteriano-2": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel Gastrointestinal Viral y Bacteriano 2",
    description:
      "Detección e identificación de 6 bacterias y 6 virus causantes de infecciones gastrointestinales.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-gastrointestinal-viral-y-bacteriano-2",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Heces fecales.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Adenovirus, Astrovirus, Norovirus GI, Norovirus GII, Rotavirus, Sapovirus, Enteroagregativa, Enteropatogénica, E. coli 02157, Enterotoxigénica, Clostridium difficile hipervirulenta, E. coli Productora de toxina shig.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "6000.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "5400.00 MXN",
      },
    ],
  },
  "panel-gastrointestinal-viral-y-bacteriano-completo": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel Gastrointestinal Viral y Bacteriano Completo",
    description:
      "Detección e identificación de 13 bacterias y 6 virus causantes de infecciones gastrointestinales.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-gastrointestinal-viral-y-bacteriano-completo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Heces fecales.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Aeromonas spp. Campylobacter spp. Clostridium difficile toxina B Salmonella Shigella spp /E. coli enteroinvasiva Vibrio spp. Yersinia enterocolítica. Enteroagregativa. Enteropatogénica. E. coli 02157. Enterotoxigénica. Clostridium difficile hipervirulenta. Adenovirus Astrovirus Norovirus GI Norovirus GII Rotavirus Sapovirus.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "8700.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "7830.00 MXN",
      },
    ],
  },
  "pik3ca-deteccion-mutaciones-por-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "PIK3CA detección Mutaciones por qPCR",
    description:
      "Esta prueba está diseñada para la detección de las mutaciones somáticas E542K, E545K, E545Q, H1047R y H1047L del gen PIK3CA mediante PCR en tiempo real, permitiendo identificar pacientes que pueden beneficiarse con terapias de inhibidores específicos de PI3K.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/pik3ca-deteccion-mutaciones-por-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "15158.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "13642.20 MXN",
      },
    ],
  },
  "ret-ptc1-y-ret-petc3-deteccion-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "RET/PTC1 y RET/PETC3 detección por PCR",
    description:
      "Esta prueba se puede utilizar como parte de abordaje terapéutico, ayuda a determinar candidatos para inhibidores de kinasas tienen actividad anti-RET, ej: sorafenib, sunitinib, cabazantinib, vandetanib, ponatinib, lenvatinib.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ret-ptc1-y-ret-petc3-deteccion-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "4770.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "4293.00 MXN",
      },
    ],
  },
  "ros1-reordenamiento-deteccion-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "ROS1 reordenamiento detección por FISH",
    description:
      "Esta prueba está diseñada para detectar reordenamientos del gen ROS1 que se han descrito en entre el 0,2 % y el 2,4 % de los pacientes con cáncer colorrectal (CRC) y en entre el 1 % y 2 % de los pacientes con cáncer pulmonar no microcítico (NSCLC). También se detectan en adenocarcinomas gástricos, varios tipos de melanomas, en tumores miofibroblásticos inflamatorios, angiosarcomas y en hemangioendoteliomas epitelioides. Los pacientes que presentan estos reordenamientos se pueden beneficiar con los tratamientos existentes, como crizotinib, ceritinib, brigatinib, lorlatinib, carbozatinib y entrectinib, y aumentar su tasa de supervivencia.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ros1-reordenamiento-deteccion-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "7526.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "6773.00 MXN",
      },
    ],
  },
  "syt-ssx-deteccion-de-fusiones-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "SYT-SSX detección de fusiones por PCR",
    description:
      "Esta prueba tiene una utilidad diagnóstica en sarcomas sinoviales en sitios inusuales (pulmón, pericardio), tejidos blandos y utilidad pronóstica desfavorable para los pacientes que presenten la traslocación.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/syt-ssx-deteccion-de-fusiones-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "4770.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "4293.00 MXN",
      },
    ],
  },
  "t(11:22)-gen-ewrs1-deteccion-por-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "T(11:22) gen EWRS1 detección por FISH",
    description:
      "Prueba cualitativa diseñada para identificar alteraciones patogenéticas en la región 6q22 del gen ROS1. Los reordenamientos del gen ROS1 se han descrito en pacientes con cáncer colorrectal, cáncer pulmonar no microcítico (NSCLC), principalmente. Los pacientes con alteraciones en este gen se pueden beneficiar con inhibidores como crizotinib, ceritinib, brigatinib, lorlatinib, carbozatinib y entrectinib.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/t(11:22)-gen-ewrs1-deteccion-por-fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "4028.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "3625.20 MXN",
      },
    ],
  },
  "transmision-sexual-7-patogenos-por-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Transmisión sexual 7 patógenos por qPCR",
    description:
      "Esta prueba está diseñada para la detección de los principales agentes causantes de enfermedad de transmisión sexual, para guiar el tratamiento. En caso de salir positivas en cualquiera de estas se sugiere prueba de VIH. Se recomienda en embarazo durante la primera visita prenatal (en el primer trimestre) y en último trimestre, especialmente cuando existen factores de riesgo.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/transmision-sexual-7-patogenos-por-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Orina, hisopados (uretrales, vaginales, cervicales) y citología en base líquida.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Chlamydia trachomatis, Neisseria gonorrhoeae, Mycoplasma genitalium, Trichomonas vaginalis, Ureaplasma urealyticum/parvum, Gardnerella vaginalis.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3074.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2766.60 MXN",
      },
    ],
  },
  "urovysion-det-cr3-7-17-del-9p21-fish": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "UROVYSION det. CR3-7-17 DEL 9p21- FISH",
    description:
      "Esta prueba está diseñada para detectar aneuploidía en los cromosomas 3, 7 y 17 y pérdida del locus 9p21, en muestras de orina de personas con hematuria, con sospecha de cáncer de vejiga. Los resultados de esta prueba se pueden utilizar como ayuda en el diagnóstico inicial del cáncer de vejiga en pacientes con hematuria y para el seguimiento posterior de recidiva tumoral en pacientes anteriormente diagnosticados de cáncer de vejiga.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/urovysion-det.-cr3-7-17-del-9p21--fish",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Orina.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Primera orina del día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Cromosomas 3, 7, 17 y 9p21.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "4206.50 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "3785.85 MXN",
      },
    ],
  },
  "v600e-del-gen-braf-deteccion-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "V600E del gen BRAF detección por PCR",
    description:
      "Esta prueba detecta una mutación que se puede expresar en melanoma, cáncer colorrectal, cáncer papilar de tiroides, cáncer de pulmón de células no pequeñas, colangiocarcinoma, astrocitoma pilocítico, algunos síndromes de células germinales como síndrome de Noonan, LEOPARD, cardiofasciocutáneo. y Sirve como guía para determinar si los pacientes son o no candidatos a quimioterapias y radioterapia.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/v600e-del-gen-braf-deteccion-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido FFPE, BAAF o BAFF extendido.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar muestra en recepción de la sucursal seleccionada. Si la muestra es tejido, se requieren 4 cortes de 4 um. Si la muestra es BAFF se requieren 15 mL totales que incluyen la cantidad de etanol y si es BAFF extendido se requieren dos laminillas.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Metodología: PCR punto final.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "4770.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "4293.00 MXN",
      },
    ],
  },
  "vih-cuantificacion-de-la-carga-viral-por-pcr-tiempo-real": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "VIH cuantificación de la carga viral por PCR tiempo real",
    description:
      "La determinación de la carga viral de VIH es imprescindible en el diagnóstico y seguimiento de pacientes infectados por este virus desde su diagnóstico inicial y durante el tratamiento antirretroviral. Esta prueba está diseñada para la cuantificación de la carga viral del Virus de la Inmunodeficiencia Humana (VIH).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/vih-cuantificacion-de-la-carga-viral-por-pcr-tiempo-real",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre total, Plasma.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Metodología: PCR tiempo real.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3074.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2766.60 MXN",
      },
    ],
  },
  "vph-deteccion-y-genotipificacion-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "VPH Detección y genotipificación por PCR",
    description:
      "Esta prueba comprende un abordaje diagnóstico y para tratamiento de pacientes infectados con el virus. Permite determinar si una paciente está infectado con genotipos de alto riesgo de cáncer cervicouterino o de bajo riesgo.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/vph-deteccion-y-genotipificacion-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Citología en base líquida, tejido PFFE o tejido fresco.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "En caso de toma de muestra  para citología en sucursal dos días antes de la prueba evitar mantener relaciones sexuales, realizar lavados vaginales o usar medicamentos vaginales o espermicidas, cremas o geles . Evitar programar la prueba durante el período menstrual.\n\nEn caso de tener la muestra o tejido, entregar en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Metodología: PCR en punto final.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2332.00 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2098.80 MXN",
      },
    ],
  },
  "panel-respiratorio-viral-tipo-1-por-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral tipo 1 por qPCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-viral-tipo-1-por-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1500 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1500 MXN",
      },
    ],
  },
  "panel-respiratorio-viral-tipo-3": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral tipo 3",
    description:
      "Detección viral de Bocavirus Humano 1/2/3/4, Rhinovirus Humano A/B/C, Coronavirus Humano 229E, Coronavirus Human NL63, y Coronavirus Humano OC43.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-viral-tipo-3",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y/o lavado broncoalveolar.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Bocavirus Humano 1/2/3/4, rhinovirus Humano A/B/C, coronavirus Humano 229E, coronavirus Human NL63, y coronavirus Humano OC43 Metodología: PCR.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1400 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1400 MXN",
      },
    ],
  },
  "panel-respiratorio-bacteriano-por-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio bacteriano por qPCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de bacterias causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-bacteriano-por-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo, lavado broncoalveolar y esputo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Analitos: Chlamydophila pneumoniae, Mycoplasma pneumoniae, Legionella pneumophila, Bordetella pertussis, Bordetella parapertussis, Streptococcus pneumoniae, y Haemophilus influenzae.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1500 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1500 MXN",
      },
    ],
  },
  "panel-respiratorio-total": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio total",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus y bacterias causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-total",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, Exudado nasofaríngeo o Lavado broncoalveolar.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Requerimos una hora de ayuno absoluto, nada de bebidas, alimentos higiene bucal, chicle, etc. Evitar uso de antibioticos a excepción de las recomendaciones de su médico.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "SARSCOV-2 (COVID-19), Virus de influenza tipo A y B, Virus Sincicial Respiratorio en Humano del tipo A, Virus Sincicial Respiratorio en Humano del tipo B, subtipos del virus de la influenza tipo A (Virus de la influenza tipo A en humanos subtipos H1, H3 y H1pdm09), Adenovirus, metapneumovirus, enterovirus, parainfluenza tipo 1, 2, 3 y 4, Bocavirus Humano 1/2/3/4, rhinovirus Humano A/B/C, coronavirus Humano 229E, coronavirus Human NL63, y coronavirus Humano OC43, Chlamydophila pneumoniae, Mycoplasma pneumoniae, Legionella pneumophila, Bordetella pertussis, Bordetella parapertussis, Streptococcus pneumoniae, and Haemophilus influenzae.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3500 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "3500 MXN",
      },
    ],
  },
  "paquete-dual-ag-de-influenza-a-y-b-+-ag-covid-19": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Paquete dual: Ag de Influenza A y B + Ag COVID-19",
    description:
      "La prueba dual de antígenos se utiliza como auxiliar en el diagnóstico rápido y simultáneo de COVID-19 e Influenza tipo A o B.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/paquete-dual:-ag-de-influenza-a-y-b-+-ag-covid-19",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "30 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Hisopado nasofaríngeo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "No aplicar ungüentos, medicamentos o soluciones de lavado en la zona nasal previo a la toma de muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "350 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "350 MXN",
      },
    ],
  },
  "panel-respiratorio-viral-tipo-2-por-qpcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral tipo 2 por qPCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-viral-tipo-2-por-qpcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar. Método: PCR tiempo real.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1400 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1400 MXN",
      },
    ],
  },
  "virus-sincicial-respiratorio-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Virus Sincicial Respiratorio por PCR",
    description:
      "Prueba de PCR para la detección del Virus Sincicial Respiratorio A y B.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/virus-sincicial-respiratorio-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar, esputo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Virus Sincitial Respiratorio A y Virus Sincitial Respiratorio B PCR tiempo real.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1200 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1200 MXN",
      },
    ],
  },
  "triple-antigeno-influenza-+-vsr-+-covid19": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Triple antígeno: Influenza + VSR + Covid19",
    description: "Diagnóstico de infecciones respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/triple-antigeno:-influenza-+-vsr-+-covid19",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "30 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Hisopado nasofaríngeo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "No aplicar sprays nasales media hora antes de la prueba.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "750 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "750 MXN",
      },
    ],
  },
  "panel-respiratorio-viral-tipo-1-+-bacteriano-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral Tipo 1 + Bacteriano por PCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus y bacterias causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-viral-tipo-1-+-bacteriano-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar, esputo.PCR tiempo real.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "SARS-CoV-2, Virus de influenza tipo A y B, Virus Sincicial Respiratorio en Humano del tipo A, Virus Sincicial Respiratorio en Humano del tipo B, subtipos del virus de la influenza tipo A (Virus de la influenza tipo A en humanos subtipos H1, H3 y H1pdm09), Chlamydophila pneumoniae, Mycoplasma pneumoniae, Legionella pneumophila, Bordetella pertussis, Bordetella parapertussis, Streptococcus pneumoniae, and Haemophilus influenzae.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1900 MXN",
      },
    ],
  },
  "antigeno-de-influenza-a-y-b": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Antígeno de Influenza A y B",
    description:
      "Útil para la detección cualitativa rápida de los antígenos A y B de la influenza mediante hisopado nasal. Está diseñada para utilizarse como ayuda en el diagnóstico diferencial rápido de una infección aguda con el virus de la influenza tipo A o B.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/antigeno-de-influenza-a-y-b",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "30 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Hisopado nasal.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "No aplicar ungüentos, medicamentos o soluciones de lavado en la zona nasal previo a la toma de muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "300 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "300 MXN",
      },
    ],
  },
  "antigeno-para-covid-19-(prueba-rapida)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Antígeno para COVID-19 (prueba rápida)",
    description:
      "Ensayo rápido que confirma la presencia del virus causante de COVID-19 en pacientes con síntomas. Si el resultado es negativo y la sospecha alta se sugiere realizar una prueba PCR para descartar COVID-19.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/antigeno-para-covid-19-(prueba-rapida)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "30 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Hisopado nasofaríngeo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "No aplicar ungüentos ni medicamentos en la zona nasal previo a la toma de muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "250 MXN",
      },
    ],
  },
  "antigeno-virus-sincicial-respiratorio": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Antígeno Virus Sincicial Respiratorio",
    description: "Diagnóstico de infecciones respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/antigeno-virus-sincicial-respiratorio",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "30 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Hisopado nasofaríngeo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "No aplicar sprays nasales media hora antes de la prueba.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "450 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "450 MXN",
      },
    ],
  },
  "igg-sars-cov-2-(anti-s)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "IgG SARS COV-2 (Anti S)",
    description:
      "Detecta anticuerpos neutralizantes. Puede emplearse para evaluar anticuerpos posterior a vacunación o infección, después de 15 días.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/igg-sars-cov-2-(anti-s)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "1 día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "4 horas de ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "620 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "620 MXN",
      },
    ],
  },
  "influenza-a-y-b-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Influenza A y B por PCR",
    description:
      "Prueba de PCR para la detección del virus de Influenza A y B.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/influenza-a-y-b-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas antes de las 11:00 hrs los resultados se entregarán después de las 17:00 hrs del mismo día. Muestras después de las 11:00 hrs los resultados se entregaran a partir de las 12:00 hrs del día siguiente.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar, esputo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Influenza A virus (Virus de la influenza tipo A en humanos subtipos H1, H3 y H1pdm09) y Influenza B virus. PCR tiempo real",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1200 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1200 MXN",
      },
    ],
  },
  "panel-respiratorio-viral-completo-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral completo por PCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-viral-completo-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar, esputo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "SARS-CoV-2, Virus de influenza tipo A, Virus Sincicial Respiratorio en Humano del tipo A, Virus Sincicial Respiratorio en Humano del tipo B, subtipos del virus de la influenza tipo A (Virus de la influenza tipo A en humanos subtipos H1, H3 y H1pdm09) Adenovirus, metapneumovirus, enterovirus, parainfluenza tipo 1, 2, 3 y 4 Bocavirus Humano 1/2/3/4, rhinovirus Humano A/B/C, coronavirus Humano 229E, coronavirus Human NL63, y coronavirus Humano OC43.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2700 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2700 MXN",
      },
    ],
  },
  "panel-respiratorio-viral-tipo-1-+-3-+-bacteriano-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral Tipo 1 + 3 + Bacteriano por PCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus y bacterias causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-viral-tipo-1-+-3-+-bacteriano-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar, esputo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "SARS-CoV-2, Virus de influenza tipo A, Virus Sincicial Respiratorio en Humano del tipo A, Virus Sincicial Respiratorio en Humano del tipo B, subtipos del virus de la influenza tipo A (Virus de la influenza tipo A en humanos subtipos H1, H3 y H1pdm09) Bocavirus Humano 1/2/3/4, rhinovirus Humano A/B/C, coronavirus Humano 229E, coronavirus Human NL63, y coronavirus Humano OC43 Chlamydophila pneumoniae, Mycoplasma pneumoniae, Legionella pneumophila, Bordetella pertussis, Bordetella parapertussis, Streptococcus pneumoniae, and Haemophilus influenzae.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2700 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2700 MXN",
      },
    ],
  },
  "panel-respiratorio-viral-tipo-1+-2-+-bacteriano-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral Tipo 1+ 2 + bacteriano por PCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus y bacterias causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-viral-tipo-1+-2-+-bacteriano-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar, esputo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "SARS-CoV-2, Virus de influenza tipo A, Virus Sincicial Respiratorio en Humano del tipo A, Virus Sincicial Respiratorio en Humano del tipo B, subtipos del virus de la influenza tipo A (Virus de la influenza tipo A en humanos subtipos H1, H3 y H1pdm09) Adenovirus, metapneumovirus, enterovirus, parainfluenza tipo 1, 2, 3 y 4 Chlamydophila pneumoniae, Mycoplasma pneumoniae, Legionella pneumophila, Bordetella pertussis, Bordetella parapertussis, Streptococcus pneumoniae, and Haemophilus influenzae.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2700 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2700 MXN",
      },
    ],
  },
  "panel-respiratorio-viral-tipo-2-+-3-+-bacteriano-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral Tipo 2 + 3 + Bacteriano por PCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus y bacterias causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-viral-tipo-2-+-3-+-bacteriano-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas antes de las 11:00 hrs los resultados se entregarán después de las 17:00 hrs del mismo día. Muestras después de las 11:00 hrs los resultados se entregaran a partir de las 16:00 hrs del día siguiente.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar, esputo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Adenovirus, metapneumovirus, enterovirus, parainfluenza tipo 1, 2, 3 y 4 Bocavirus Humano 1/2/3/4, rhinovirus Humano A/B/C, coronavirus Humano 229E, coronavirus Human NL63, y coronavirus Humano OC43 Chlamydophila pneumoniae, Mycoplasma pneumoniae, Legionella pneumophila, Bordetella pertussis, Bordetella parapertussis, Streptococcus pneumoniae, and Haemophilus influenzae.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2700 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2700 MXN",
      },
    ],
  },
  "panel-respiratorio-viral-tipo-2-+-bacteriano-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral Tipo 2 + Bacteriano por PCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus y bacterias causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-viral-tipo-2-+-bacteriano-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas antes de las 11:00 hrs los resultados se entregarán después de las 17:00 hrs del mismo día. Muestras después de las 11:00 hrs los resultados se entregaran a partir de las 16:00 hrs del día siguiente.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar, esputo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Adenovirus, metapneumovirus, enterovirus, parainfluenza tipo 1, 2, 3 y 4 Chlamydophila pneumoniae, Mycoplasma pneumoniae, Legionella pneumophila, Bordetella pertussis, Bordetella parapertussis, Streptococcus pneumoniae, and Haemophilus influenzae.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1900 MXN",
      },
    ],
  },
  "panel-respiratorio-viral-tipo-2-+-tipo-3-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral Tipo 2 + Tipo 3 por PCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-viral-tipo-2-+-tipo-3-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas antes de las 11:00 hrs los resultados se entregarán después de las 17:00 hrs del mismo día. Muestras después de las 11:00 hrs los resultados se entregaran a partir de las 16:00 hrs del día siguiente.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Hisopos de nylon floqueado y medio de transporte universal.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Adenovirus, metapneumovirus, enterovirus, parainfluenza tipo 1, 2, 3 y 4 Bocavirus Humano 1/2/3/4, rhinovirus Humano A/B/C, coronavirus Humano 229E, coronavirus Human NL63, y coronavirus Humano OC43.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1900 MXN",
      },
    ],
  },
  "panel-respiratorio-viral-tipo-3-+-bacteriano-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral Tipo 3 + Bacteriano por PCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus y bacterias causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-viral-tipo-2-+-tipo-3-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar, esputo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Bocavirus Humano 1/2/3/4, rhinovirus Humano A/B/C, coronavirus Humano 229E, coronavirus Human NL63, y coronavirus Humano OC43 Chlamydophila pneumoniae, Mycoplasma pneumoniae, Legionella pneumophila, Bordetella pertussis, Bordetella parapertussis, Streptococcus pneumoniae, and Haemophilus influenzae.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1900 MXN",
      },
    ],
  },
  "panel-respitatorio-viral-tipo-1-+-tipo-2-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral Tipo 1 + Tipo 2 por PCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respitatorio-viral-tipo-1-+-tipo-2-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas antes de las 11:00 hrs los resultados se entregarán después de las 17:00 hrs del mismo día. Muestras después de las 11:00 hrs los resultados se entregarán a partir de las 12:00 hrs del día siguiente.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar, esputo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "SARS-CoV-2, Virus de influenza tipo A, Virus Sincicial Respiratorio en Humano del tipo A, Virus Sincicial Respiratorio en Humano del tipo B, subtipos del virus de la influenza tipo A (Virus de la influenza tipo A en humanos subtipos H1, H3 y H1pdm09) Adenovirus, metapneumovirus, enterovirus, parainfluenza tipo 1, 2, 3 y 4.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1900 MXN",
      },
    ],
  },
  "paquete-dual:-ag-de-influenza-a-y-b-+-ag-covid-19": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Paquete dual: Ag de Influenza A y B + Ag COVID-19",
    description:
      "La prueba dual de antígenos se utiliza como auxiliar en el diagnóstico rápido y simultáneo de COVID-19 e Influenza tipo A o B.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/paquete-dual:-ag-de-influenza-a-y-b-+-ag-covid-19",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "30 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Hisopado nasofaríngeo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "No aplicar ungüentos, medicamentos o soluciones de lavado en la zona nasal previo a la toma de muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "350 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "350 MXN",
      },
    ],
  },
  "sars-cov-2-(covid-19)-deteccion-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "SARS-CoV-2 (COVID-19) detección por PCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos del virus SARS- CoV2.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/sars-cov-2-(covid-19)-deteccion-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaringeo, exudado nasofaríngeo y lavado broncoalveolar. PCR tiempo real",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1300 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1300 MXN",
      },
    ],
  },
  "panel-respiratorio-viral-tipo-1-+-tipo-3-por-pcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Panel respiratorio viral Tipo 1 + Tipo 3 por PCR",
    description:
      "Esta prueba permite la amplificación y detección simultánea de ácidos nucleicos de virus causantes de enfermedades respiratorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-respiratorio-viral-tipo-1-+-tipo-3-por-pcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las muestras tomadas de lunes a viernes antes de las 11:00 h, los resultados se entregarán después de las 17:00 h del mismo día. Muestras después de las 11:00 h los resultados se entregarán a partir de las 16:00 h del día siguiente. Sábados y días festivos la hora límite de recepción es a las 10:00 h.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Aspirado nasofaríngeo, exudado nasofaríngeo y lavado broncoalveolar, esputo.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos en los últimos 60 minutos antes de la toma orofaríngea. No se requiere ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "SARS-CoV-2, Virus de influenza tipo A, Virus Sincicial Respiratorio en Humano del tipo A, Virus Sincicial Respiratorio en Humano del tipo B, subtipos del virus de la influenza tipo A (Virus de la influenza tipo A en humanos subtipos H1, H3 y H1pdm09) Bocavirus Humano 1/2/3/4, rhinovirus Humano A/B/C, coronavirus Humano 229E, coronavirus Human NL63, y coronavirus Humano OC43.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1900 MXN",
      },
    ],
  },
  "17-hidroxi-progesterona": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "17 Hidroxi-Progesterona",
    description:
      "De utilidad en el diagnóstico de hiperplasia suprarrenal congénita así como en la vigilancia y monitoreo del tratamiento para la enfermedad.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/17-hidroxi-progesterona",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Recomendable pero no indispensable ayuno de 4 horas. Se sugiere realizar la toma de muestra antes de las 9.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "350 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "315 MXN",
      },
    ],
  },
  "ac-adrenales": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac Adrenales",
    description:
      "De utilidad en enfermedad autoinmune adrenal por ejemplo; enfermedad de Addison.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-adrenales",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "724 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "652 MXN",
      },
    ],
  },
  "ac-anti-adn-nativo": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac anti ADN nativo",
    description: "De utilidad en el diagnóstico de enfermedades autoinmunes.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-adn-nativo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 8 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "493 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "444 MXN",
      },
    ],
  },
  "ac-anti-amiba": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac anti Amiba",
    description:
      "De utilidad para determinar Amibiasis extraintestinal. En absceso hepático de origen amibiano y en amibiasis aguda.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-amiba",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "1 día hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "426 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "383 MXN",
      },
    ],
  },
  "ac-anti-beta-2-gp-1-iga": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac anti Beta 2 GP-1 IgA",
    description:
      "Evaluación de los casos sugestivos del síndrome Antifosfolípidos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-beta-2-gp-1-iga",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles. Se procesa Jueves.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "769 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "692 MXN",
      },
    ],
  },
  "ac-anti-beta-2-gp-1-igg": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac anti Beta 2 GP-1 IgG",
    description:
      "Evaluación de los casos sugestivos de síndrome Antifosfolípidos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-beta-2-gp-1-igg",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "733 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "660 MXN",
      },
    ],
  },
  "ac-anti-beta-2-gp-1-igm": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac anti Beta 2 GP-1 IgM",
    description:
      "Evaluación de los casos sugestivos de síndrome Antifosfolípidos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-beta-2-gp-1-igm",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles.Se procesa los Jueves",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "769 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "692 MXN",
      },
    ],
  },
  "ac-anti-beta-2gp-1-(igg,-iga,-igm)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac anti Beta 2GP-1 (IgG, IgA, IgM)",
    description:
      "De utilidad cuando se ha presentado uno o varios episodios trombóticos arteriales o venosos inexplicables; cuando se ha tenido abortos recurrentes, especialmente durante los trimestres segundo y tercero del embarazo, o como parte de la evaluación del Síndrome Antifosfolípidos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-beta-2gp-1-(igg,-iga,-igm)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1860 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1674 MXN",
      },
    ],
  },
  "ac-anti-bordetella-pertussis": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac anti Bordetella pertussis",
    description:
      "Establecer evidencia de infección/exposición a Bordetella Pertussis, el agente causante de la Tosferina.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-bordetella-pertussis",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1238 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1114 MXN",
      },
    ],
  },

  "ac-anti-brucella-igg": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "AC Anti Brucella IgG",
    description: "Cuantificar anticuerpos IgG contra brucella abortus.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-brucella-igg",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "489 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "440 MXN",
      },
    ],
  },

  "ac-anti-brucella-igm": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac Anti Brucella IgM",
    description: "Cuantificar anticuerpos IgG contra brucella abortus.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-brucella-igm",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "Día de proceso despues de 5pm. Se Procesa Martes.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "489 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "440 MXN",
      },
    ],
  },

  "ac-anti-c.-trachomatis": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac anti C. trachomatis",
    description: "Auxiliar en el diagnóstico de infecciones por Chlamydia.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-c.-trachomatis",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "699 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "629 MXN",
      },
    ],
  },

  "ac-anti-cardiolipina-igg": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac anti cardiolipina IgG",
    description:
      "De utilidad cuando se ha presentado uno o varios episodios trombóticos arteriales o venosos inexplicables; cuando se ha tenido abortos recurrentes, especialmente durante los trimestres segundo y tercero del embarazo, o como parte de la evaluación del Síndrome Antifosfolípidos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-cardiolipina-igg",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 8 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "850 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "765 MXN",
      },
    ],
  },

  "ac-anti-cardiolipina-igm": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac anti cardiolipina IgG",
    description:
      "De utilidad cuando se ha presentado uno o varios episodios trombóticos arteriales o venosos inexplicables; cuando se ha tenido abortos recurrentes, especialmente durante los trimestres segundo y tercero del embarazo, o como parte de la evaluación del Síndrome Antifosfolípidos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-cardiolipina-igm",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 8 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "850 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "765 MXN",
      },
    ],
  },

  "ac-anti-cisticerco-en-lcr": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac anti Cisticerco en LCR",
    description: "De utilidad en el diagnóstico de Cisticercosis.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-cisticerco-en-lcr",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "LCR.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "383 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "345 MXN",
      },
    ],
  },

  "ac-anti-cisticerco-en-suero": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac anti Cisticerco en suero",
    description: "De utilidad en el diagnóstico de Cisticercosis.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-cisticerco-en-suero",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "383 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "345 MXN",
      },
    ],
  },

  "ac-anti-citomegalovirus": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac Anti Citomegalovirus",
    description:
      "Útil para diagnosticar la presencia de una infección por citomegalovirus presentes, pasada o reactiva.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-citomegalovirus",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 8 a 12 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "514 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "463 MXN",
      },
    ],
  },

  "ac-anti-citomegalovirus-igg": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac anti citomegalovirus IgG",
    description:
      "Útil para diagnosticar la presencia de una infección por citomegalovirus presentes, pasada o reactiva.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-citomegalovirus-igg",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 8 a 12 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "343 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "309 MXN",
      },
    ],
  },

  "ac-anti-citomegalovirus-igm": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac Anti Citomegalovirus IgM",
    description:
      "Útil para el diagnóstico de una infección por citomegalovirus presente.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-citomegalovirus-igm",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 8 a 12 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "195 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "176 MXN",
      },
    ],
  },

  "ac-anti-dnasa-b-strepto": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac anti DNAsa B strepto",
    description:
      "El anticuerpo antideoxirribonucleasa-B (Anti-DNasa B) es uno de los anticuerpos más comúnmente producidos por el sistema inmunitario del organismo, como respuesta a una infección por la bacteria conocida como Streptococcus del grupo A. Esta prueba mide la cantidad de anticuerpo dirigido contra alguno de los antígenos estreptocócicos (anti-DNasa B) en sangre.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-dnasa-b-strepto",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 12 a 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "315 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "284 MXN",
      },
    ],
  },

  "ac-anti-ena": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac anti ENA",
    description:
      "De utilidad en pacientes con enfermedad mixta del tejido conectivo.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-ena",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "866 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "779 MXN",
      },
    ],
  },

  "ac-anti-esperma": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac anti esperma",
    description:
      "De utilidad en la investigación de las causas de infertilidad.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-esperma",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "1 día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Esperma / Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Ayuno de 4 horas. En caso de búsqueda de anticuerpos autólogos, se requiere suero y semen del paciente. En el caso de búsqueda de anticuerpos alogénicos, se requiere suero de la pareja sexual y semen del paciente. Para pacientes vasectomizados enviar solo suero de la pareja sexual. El paciente deberá tener entre 3 y 7 días de abstinencia sexual.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "814 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "733 MXN",
      },
    ],
  },

  "ac-anti-factor-intrinseco": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac anti factor intrínseco",
    description:
      "Es producido por las células que recubren el estómago, el factor intrínseco se une a la vitamina B12 (Cianocobalamina) para facilitarla absorción de la vitamina. Los anticuerpos anti factor intrínseco están presentes en aproximadamente la mitad de los pacientes con anemia perniciosa.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-factor-intrinseco",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "8 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "656 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "590 MXN",
      },
    ],
  },

  "ac-anti-gad": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "AC Anti GAD",
    description:
      "Los anticuerpos contra la GAD son marcadores de diagnóstico de diabetes mellitus tipo I.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-gad",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "Se procesa martes. 7 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Recomendable pero no indispensable ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "880 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "792 MXN",
      },
    ],
  },

  "ac-anti-gliadina": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "AC Anti Gliadina",
    description:
      "Para ayudar a diagnosticar la enfermedad celíaca y controlar el cumplimiento y la efectividad de una dieta sin gluten.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-gliadina",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Recomendable pero no indispensable ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "548 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "493 MXN",
      },
    ],
  },

  "ac-anti-herpes": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac anti Herpes",
    description:
      "Diagnóstico de una infección presente o pasada causada por el virus del herpes tipo 1 o 2.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://labopat.mx/estudio/ac-anti-herpes",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 8 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "825 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "743 MXN",
      },
    ],
  },

  "ac-anti-herpes-1-igg": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac anti Herpes 1 IgG",
    description:
      "Cuando se presentan síntomas de una infección por el virus Herpes simple, como vesículas o ampollas al rededor del área genital, úlceras en la cavidad oral o síntomas de meningitis vírica.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-herpes-1-igg",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 8 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "239 MXN",
      },
    ],
  },

  "ac-anti-herpes-1-igm": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac anti Herpes 1 IgM",
    description:
      "Cuando se presentan síntomas de una infección por el virus herpes simple, como vesículas o ampollas alrededor del área genital, úlceras en la cavidad oral o síntomas de meningitis vírica.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-herpes-1-igm",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 8 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "270 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "243 MXN",
      },
    ],
  },

  "ac-anti-herpes-2-igg": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac anti Herpes 2 IgG",
    description:
      "Cuando se presentan síntomas de una infección por el virus herpes simple, como vesículas o ampollas alrededor del área genital, úlceras en la cavidad oral o síntomas de meningitis vírica.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-herpes-2-igg",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 8 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "286 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "257 MXN",
      },
    ],
  },

  "ac-anti-herpes-2-igm": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Ac anti Herpes 2 IgM",
    description:
      "Cuando se presentan síntomas de una infección por el virus herpes simple, como vesículas o ampollas alrededor del área genital, úlceras en la cavidad oral o síntomas de meningitis vírica.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-herpes-2-igm",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre (Suero).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 8 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "249 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "224 MXN",
      },
    ],
  },
  "ac-anti-histonas": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Ac anti Histonas",
    description:
      "De utilidad en el diagnóstico de Lupus Eritematoso Sistémico inducido por fármacos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ac-anti-histonas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Suero.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno de 4 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "646 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "581 MXN",
      },
    ],
  },
  "analisis-inbody": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Análisis InBody",
    description:
      "Análisis para conocer la composición desglosando el peso en términos de músculo, grasa y agua, con duración de 15 segundos, más interpretación y entrega de reporte.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/analisis-inbody",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "15 minutos",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "1. Uso de cubrebocas: obligatorio en todo momento 2. Ropa cómoda . 3. Puntualidad: Asistir a su consulta en el horario agendado 4. Objetos personales: Se pide que el paciente lleve la menor cantidad de objetos personales.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "225 MXN",
      },
    ],
  },
  "check-up-hepatico": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "CHECK UP HEPATICO",
    description:
      "Check up para conocer el riesgo a presentar hígado graso no alcohólico y conocer la opción médica adecuada de acuerdo a la variante genética presentada.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/check-up-hepatico",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "8 horas de ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2800 MXN",
      },
    ],
  },
  "check-up-hepatico-plus": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "CHECK UP HEPATICO PLUS",
    description:
      "Check up heático para conocer tu riesgo o estado de hígado graso no alcohólico, incluye prueba genética, elastografía hepática y doppler de vena porta y arteria hepática.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/check-up-hepatico-plus",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "8 horas de ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3700 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "3700 MXN",
      },
    ],
  },
  "checkup-nutricio": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Check Up nutricio",
    description:
      "Chequeo de 30 minutos para conocer tus hábitos saludables, composición corporal y signos vitales.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/checkup-nutricio",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "30 minutos",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "1.Contestar breve encuesta https://forms.gle/SAZpPK1C2ExYJNMY8  2. Ropa cómoda y holgada 3. Puntualidad 4. El paciente debe llevar la menor cantidad de objetos posibles.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "350 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "315 MXN",
      },
    ],
  },

  "consulta-de-nutricion": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Consulta de nutrición",
    description:
      "Consulta con metodología integral: Historia clínica-nutricia-deportiva, signos vitales, medición en InBody 270 y plan alimenticio.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/consulta-de-nutricion",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "650 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "585 MXN",
      },
    ],
  },

  "paquete-de-2-consultas-de-nutricion": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Paquete de 2 consultas de nutrición",
    description:
      "Consulta con metodología integral: Historia clínica-nutricia-deportiva, signos vitales, medición en InBody 270 y plan alimenticio.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/paquete-de-2-consultas-de-nutricion",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Presión arterial, glucosa capilar, saturación de oxígeno, temperatura corporal, medición de composición corporal con InBody 270, evaluación básica del estado de nutrición.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1200 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1080 MXN",
      },
    ],
  },

  "paquete-de-3-consultas-de-nutricion": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Paquete de 3 consultas de nutrición",
    description:
      "Consulta con metodología integral: Historia clínica-nutricia-deportiva, signos vitales, medición en InBody 270 y plan alimenticio.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/paquete-de-3-consultas-de-nutricion",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Presión arterial, glucosa capilar, saturación de oxígeno, temperatura corporal, medición de composición corporal con InBody 270, evaluación básica del estado de nutrición.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1750 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1575 MXN",
      },
    ],
  },
  "paquete-familiar": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Paquete familiar consulta de nutrición",
    description:
      "Bienestar familiar: cuestionario de hábitos nutricios y deportivos, medición de InBody y plan de alimentación adaptado necesidades familiares.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/paquete-familiar",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "InBody 270, cuestionario de hábitos nutricios,historial deportivo.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1350 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1215 MXN",
      },
    ],
  },

  "paquete-pareja": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Paquete pareja consulta de nutrición",
    description:
      "Bienestar familiar: cuestionario de hábitos nutricios y deportivos, medición de InBody y plan de alimentación adaptado necesidades familiares.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/paquete-pareja",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "InBody 270, cuestionario de hábitos nutricios,historial deportivo.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1000 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "900 MXN",
      },
    ],
  },
  "paquete-vg70": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Paquete VG70",
    description:
      "Prueba VG70 en paquete, donde se analíza al paciente en su totalidad, se incluye una medición de la composición corporal por bioimpedancia, toma de signos vitales, reporte de resultados, videollamada de interpretación y recomendaciones personalizadas de acuerdo a los resultados.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/paquete-vg70",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 - 4 semanas",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "31 minutos sin haber ingerido alimentos, tomado agua, fumado, ni cepillado los dientes, para recolección de saliva.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Prueba de nutrición personalizada VG70, check up nutricio (cuestionario de hábitos, presión arterial, frecuencia cardiaca, glucosa capilar, medición en InBody).",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "5250 MXN",
      },
    ],
  },
  "prueba-de-intolerancia-al-gluten": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Prueba de intolerancia al gluten con envio",
    description:
      "Esta prueba está diseñada para detectar SNP que predisponen a los pacientes a la intolerancia al gluten.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/prueba-de-intolerancia-al-gluten",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos, bebidas, mascado chicle, fumado o usado higiene bucal en los últimos 30 minutos de su recolección de saliva.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3210 MXN",
      },
    ],
  },

  "riesgo-de-higado-graso-no-alcoholico": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "RIESGO DE HIGADO GRASO NO ALCOHOLICO",
    description:
      "Esta prueba esta diseñada para detectar SNP que predispone a las personas a la enfermedad de hígado graso no alcohólico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/riesgo-de-higado-graso-no-alcoholico",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos, bebidas, mascado chicle, fumado o usado higiene bucal en los últimos 30 minutos de su recolección de saliva.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Detección de la mutación I148M.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2250 MXN",
      },
    ],
  },
  "biopsia-de-higado-con-aguja-de-corte-(trucut)-guiada-por-ultrasonido": {
    "@context": "https://schema.org",
    "@type": "PathologyTest",
    name: "Biopsia de mama y ganglios con aguja de corte (trucut) guiada por ultrasonido",
    description:
      "Extracción de una pequeña muestra de tejido mamario o de ganglios para su posterior análisis patológico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/biopsia-de-higado-con-aguja-de-corte-(trucut)-guiada-por-ultrasonido",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El procedimiento tiene una duración promedio de 1 hora. Se requiere una valoración previa y entrega de resultados de tiempos de coagulación. Presentarse en ayuno para el procedimiento.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "11500 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "11500 MXN",
      },
    ],
  },

  "biopsia-de-mama-y-ganglios-con-aguja-de-corte-(trucut)-guiada-por-ultrasonido":
    {
      "@context": "https://schema.org",
      "@type": "PathologyTest",
      name: "Biopsia de mama y ganglios con aguja de corte (trucut) guiada por ultrasonido",
      description:
        "Extracción de una pequeña muestra de tejido mamario o de ganglios para su posterior análisis patológico.",
      recognizingAuthority: {
        "@type": "Organization",
        name: "Labopat",
        url: "https://www.labopat.mx/estudio/biopsia-de-higado-con-aguja-de-corte-(trucut)-guiada-por-ultrasonido",
      },
      additionalProperty: [
        {
          "@type": "PropertyValue",
          name: "Tiempo de entrega",
          value: "5 días hábiles",
        },
        {
          "@type": "PropertyValue",
          name: "Tipo de muestra",
          value: "Tejido fijado en formol",
        },
        {
          "@type": "PropertyValue",
          name: "Indicaciones",
          value: "El procedimiento tiene una duración promedio de 1 hora",
        },
        {
          "@type": "PropertyValue",
          name: "Precio en sucursal",
          value: "6000 MXN",
        },
        {
          "@type": "PropertyValue",
          name: "Precio en línea",
          value: "6000 MXN",
        },
      ],
    },

  "biopsia-de-tejidos-blandos-con-aguja-de-corte-(trucut)-guiada-por-ultrasonido":
    {
      "@context": "https://schema.org",
      "@type": "PathologyTest",
      name: "Biopsia de tejidos blandos con aguja de corte (trucut) guiada por ultrasonido",
      description:
        "Extracción de una pequeña muestra de tejido para su posterior análisis patológico. Aplica para biopsias de tejidos blandos, zona toráxica y cuello.",
      recognizingAuthority: {
        "@type": "Organization",
        name: "Labopat",
        url: "https://www.labopat.mx/estudio/biopsia-de-tejidos-blandos-con-aguja-de-corte-(trucut)-guiada-por-ultrasonido",
      },
      additionalProperty: [
        {
          "@type": "PropertyValue",
          name: "Tiempo de entrega",
          value: "5 días hábiles",
        },
        {
          "@type": "PropertyValue",
          name: "Tipo de muestra",
          value: "Tejido fijado en formol",
        },
        {
          "@type": "PropertyValue",
          name: "Indicaciones",
          value: "El procedimiento tiene una duración promedio de 1 hora",
        },
        {
          "@type": "PropertyValue",
          name: "Precio en sucursal",
          value: "5500 MXN",
        },
        {
          "@type": "PropertyValue",
          name: "Precio en línea",
          value: "5500 MXN",
        },
      ],
    },

  "estudio-histopatologico-de-baaf-de-tiroides-con-toma-de-muestra": {
    "@context": "https://schema.org",
    "@type": "PathologyTest",
    name: "Estudio Histopatológico de BAAF de tiroides con toma de muestra",
    description:
      "Estudio que consiste en el análisis de laminillas con material extendido del tejido muestreado para la detección de procesos neoplásico (benignos y malignos), condiciones benignas o inflamatorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-baaf-de-tiroides-con-toma-de-muestra",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Extendidol",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "5500 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "5500 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-tumor-de-rinon": {
    "@context": "https://schema.org",
    "@type": "PathologyTest",
    name: "Estudio histopatológico de resección de tumor de riñón",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la determinación del tipo de procesos neoplásico (malignos y benignos), evaluando sus características, células de origen, infiltración y bordes quirúrgicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-tumor-de-rinon",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "5500 MXN",
      },
    ],
  },

  "valoracion-prebiopsia": {
    "@context": "https://schema.org",
    "@type": "PathologyTest",
    name: "Valoración prebiopsia",
    description:
      "Valoración con médico radiólogo que permite evaluar al paciente previo a una biopsia.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/valoracion-prebiopsia",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Acudir a la consulta con todos los estudios y datos clínicos necesarios para la valoración.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "500 MXN",
      },
    ],
  },
  "biopsia-de-prostata-guiada-por-ultrasonido": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Biopsia de próstata guiada por ultrasonido",
    description:
      "Biopsia con aguja de corte guiada por ultrasonido (TRUCUT) para próstata. *Incluye tiempos de coagulación.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/biopsia-de-prostata-guiada-por-ultrasonido",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 a 7 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Tiempos de coagulación, ayuno de 8 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "12000 MXN",
      },
    ],
  },
  "doppler-testiculos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Doppler Testículos",
    description:
      "Permite valorar el flujo sanguíneo a los testículos, epidídimo y a los plexos pampiniformes.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/doppler-testiculos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 - 48 hrs",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Sin preparación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2300 MXN",
      },
    ],
  },
  elastografia: {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Elastografía",
    description:
      "Toma de imágenes médicas no invasiva que ayuda a determinar la rigidez de los órganos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/elastografia",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 - 48 hrs",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Ayuno 6 hrs.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3700 MXN",
      },
    ],
  },
  mastografia: {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Mastografía",
    description:
      "Busca detectar cambios o anomalías en el tejido de los senos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/mastografia",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 - 48 hrs",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "No se requiere ayuno. Venir depilada de axilas, con baño del día y no colocar desodorante y/o cremas en pecho y axilas.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Mujeres mayores de 40 a 69 años de edad. Mujeres mayores de 35 años con antecedentes familiares (madre, hermanas, tías con diagnóstico de cáncer de mama). Mujeres mayores de 35 años, con patología de mama. Si la paciente se palpa un nódulo en axila o mama y su médico considera que es sospechoso aunque sea mejor de 40 años se realiza la mastografía y ultrasonido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "880 MXN",
      },
    ],
  },

  "mastografia-unilateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Mastografía unilateral",
    description:
      "Busca detectar cambios o anomalías en el tejido de los senos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/mastografia-unilateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "No se requiere ayuno. Venir depilada de axilas, con baño del día y no colocar desodorante y/o cremas en pecho y axilas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "660 MXN",
      },
    ],
  },

  "radiografia-1-region": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Radiografía 1 Región",
    description:
      "Una radiografía es una prueba rápida e indolora que genera imágenes de las estructuras internas del cuerpo, en especial de los huesos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "radiografia-1-region",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24-48 hrs.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Sin preparación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "750 MXN",
      },
    ],
  },

  "radiografia-2-regiones": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Radiografía 2 Regiones",
    description:
      "Una radiografía es una prueba rápida e indolora que genera imágenes de las estructuras internas del cuerpo, en especial de los huesos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/radiografia-2-regiones",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24-48 hrs.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Sin preparación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
    ],
  },

  "ultrasonido-de-abdomen-completo": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido de abdomen completo",
    description:
      "Estudio especializado, útil para realizar una revisión general del estado de salud y descartar patologías de origen abdominal.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "ultrasonido-de-abdomen-completo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "6 horas de ayuno y llenar vejiga antes de acudir a la sucursal para el procedimiento.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1600 MXN",
      },
    ],
  },

  "ultrasonido-de-abdomen-con-prueba-de-boyden": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido de abdomen con prueba de Boyden",
    description:
      "Durante éste procedimiento es posible valorar la vesícula y las vías biliares, su estructura y su contractilidad con la presencia de cálculos. Este estudio se realiza en dos tiempos, el primero es con ayuno de 8 horas, y el segundo una hora después de la ingesta de alimentos ricos en grasa.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-de-abdomen-con-prueba-de-boyden",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para la primera parte del estudio acudir a la cita con 8 horas de ayuno, posteriormente consumir alimentos ricos en grasa y regresar para la segunda parte del estudio.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Duración del estudio: 30 minutos para la primera parte, 15 minutos para la segunda parte.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
    ],
  },

  "ultrasonido-de-cadera-infantil": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido de cadera infantil",
    description:
      "Se utiliza en niños para comprobar la presencia de displasia del desarrollo en la cadera.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-de-cadera-infantil",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Acudir a la cita con aseo del día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Duración del estudio: 30 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1500 MXN",
      },
    ],
  },

  "ultrasonido-de-cuello": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido de cuello",
    description:
      "Útil para evaluar la estructura del cuello, la glándula tiroides y ganglios linfáticos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-de-cuello",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Acudir a la cita con aseo del día, sin desodorante, crema ni perfumes.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Duración del estudio: 30 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "938 MXN",
      },
    ],
  },

  "ultrasonido-de-mama-bilateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido de mama bilateral",
    description:
      "Se utiliza para ayudar a identificar anormalidades en el tejido mamario.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-de-mama-bilateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Acudir a la cita sin desodorante en la zona de las axilas.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Duración del procedimiento: 1 hora.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "850 MXN",
      },
    ],
  },

  "ultrasonido-de-rinon": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido de riñón",
    description: "Utilizado para descartar alteraciones renales.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-de-rinon",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Acudir a la cita con aseo del día. No es necesario acudir a la cita en ayuno o con la vejiga llena.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Duración del procedimiento: 30 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "938 MXN",
      },
    ],
  },

  "ultrasonido-de-vias-urinarias": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido de vías urinarias",
    description:
      "Útil para descartar anormalidades del tracto urinario (renal y vesical).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-de-vias-urinarias",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Acudir a la cita con la vejiga llena.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Duración del procedimiento: 30 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
    ],
  },

  "ultrasonido-doppler-carotidas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido Doppler Carótidas",
    description:
      "Prueba con ultrasonido que muestra cómo fluye la sangre a través de las arterias carótidas.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-doppler-carotidas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Sin preparación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2500 MXN",
      },
    ],
  },

  "ultrasonido-doppler-de-pene": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido doppler de pene",
    description: "Permite el estudio de las diferentes estructuras del pene.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-doppler-de-pene",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Acudir a la cita con aseo del día. Dependiendo del objetivo del exámen, se puede solicitar la toma de Alprostadil.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2500 MXN",
      },
    ],
  },

  "ultrasonido-doppler-hepatico": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido doppler hepático",
    description: "Útil para evaluar el sistema venoso portal hepático.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-doppler-hepatico",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "6 horas de ayuno previo al estudio.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Duración del estudio: 1 hora.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2300 MXN",
      },
    ],
  },

  "ultrasonido-doppler-para-rinon-trasplantado": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido doppler para riñón trasplantado",
    description:
      "Útil para identificar la estructura renal y conocer el grado de vascularización.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-doppler-para-rinon-trasplantado",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Acudir a la cita con 6 horas de ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Duración del estudio: 1 hora.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2300 MXN",
      },
    ],
  },

  "ultrasonido-musculoesqueletico-de-1-region": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido musculoesquelético de 1 región",
    description:
      "Útil para evaluar la estructura del sistema musculoesquelético de una región específica. Proporciona imágenes de músculos, tendones, ligamentos, articulaciones y tejidos blandos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-musculoesqueletico-de-1-region",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Acudir a la cita con aseo del día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Duración del estudio: 40 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1500 MXN",
      },
    ],
  },

  "ultrasonido-pelvico-ginecologico": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido pélvico ginecológico",
    description:
      "Permite la visualización de alteraciones en los órganos y las estructuras pélvicas femeninas, que incluyen: útero, cuello uterino, vagina, trompas de falopio y ovarios.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-pelvico-ginecologico",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Acudir con aseo del día y vejiga llena (tomar 500 ml a 1 litro de agua 30 minutos previos a la cita).",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Duración del estudio: 30 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "938 MXN",
      },
    ],
  },

  "ultrasonido-pelvico-transvaginal": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido pélvico transvaginal",
    description:
      "Es un examen utilizado para ver el útero, los ovarios, las trompas, el cuello uterino y el área pélvica de la mujer a través de la vagina.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-pelvico-transvaginal",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Acudir a la cita con aseo del día y vejiga vacía.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Duración del estudio: 30 minutos.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "938 MXN",
      },
    ],
  },

  "ultrasonido-prostatico-transrectal-o-suprapubico": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido Prostático Transrectal O Suprapúbico",
    description:
      "Detectar afecciones de la próstata por medio de imágenes de la glándula prostática y tejidos circundantes en el hombre.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-prostatico-transrectal-o-suprapubico",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Suprapúbico llenar vejiga, transrectal hacerse una especie de enema, de preferencia.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "938 MXN",
      },
    ],
  },

  "ultrasonido-testicular": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido Testicular",
    description:
      "El ultrasonido testicular es un estudio de imagen que ayuda a descartar anomalías.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-testicular",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Sin preparación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
    ],
  },

  "ultrasonido-vesico-prostatico": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "Ultrasonido Vesico-Prostático",
    description:
      "Detectar afecciones de la próstata por medio de imágenes de la glándula prostática y tejidos circundantes en el hombre.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ultrasonido-vesico-prostatico",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "24 a 48 horas.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Llenar vejiga.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "938 MXN",
      },
    ],
  },
  "biopsia-liquida-axiona-liquid": {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Biopsia líquida Axiona LIQUID",
    description:
      "Axiona Liquid incluye el estudio de 50 genes por secuenciación de próxima generación (NGS) lo cual permite la detección de variantes relevantes. Este ensayo permite el análisis concurrente de ADN y ARN para detectar simultáneamente múltiples tipos de variantes, incluidos hotspots, variantes de un solo nucleótido (SNV), indels, variantes de número de copias (CNV) y fusiones.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/biopsia-liquida-axiona-liquid",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "15 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre entera.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "6 horas de ayuno previas a la recolección de sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "AKT1, AKT2, AKT3, ALK, AR, ARAF, BRAF, CD274, CDK4, CDKN2A, CHEK2, CTNNB1, EGFR, ERBB2, ERBB3, ERBB4, ESR1, FGFR1, FGFR2, FGFR3, FGFR4, FLT3, GNA11, GNAQ, GNAS, HRAS, IDH1, IDH2, KIT, KRAS, MAP2K1, MAP2K2, MET, MTOR, NRAS, NRG1, NTRK1, NTRK2, NTRK3, NUTM1, PDGFRA, PIK3CA, PTEN, RAF1, RET, ROS1, RSPO2, RSPO3, SMO, TP53.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "55000 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "55000 MXN",
      },
    ],
  },
  "biopsia-liquida-guardant-health-360": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Biopsia líquida Guardant Health 360",
    description:
      "Está prueba genética analiza alteraciones en 74 genes asociados con diferentes tipos de tumores sólidos, mediante la secuenciación (NGS) del ADN de una muestra de sangre completa tomada del paciente. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/biopsia-liquida-guardant-health-360",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 3 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "6 horas de ayuno previo. Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: AKT1, ALK, APC, AR, ARAF, ATM*, BRAF, BRCA1**, BRCA2**, CCND1, CDH1, CDK4, CDK6, CDK12*, CDKN2A, CTNNB1, EGFR, ERBB2, ESR1, FGFR1, FGFR2, FGFR3, GATA3, GNA11, GNAQ, HRAS, IDH1, IDH2, KIT, KRAS, MAP2K1, MAP2K2, MET, MLH1, MTOR, MYC, NF1, NFE2L2, NRAS, NTRK1, NTRK3, PDGFRA, PIK3CA, PTEN, RAF1, RET, zRHEB, ROS1, SMAD4, SMO, STK11, TERT^, TSC1, VHL.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "110000 MXN",
      },
    ],
  },
  microarreglos: {
    "@context": "https://schema.org",
    "@type": "BloodTest",
    name: "Microarreglos",
    description:
      "Esta prueba genética está diseñada para identificar anomalías cromosómicas numéricas, reordenamientos estructurales desequilibrados y cambios en el número de copias en todo el genoma, cubriendo regiones de importancia clínica conocida (síndromes de microduplicación/microdeleción reconocidos), regiones pericentroméricas y subteloméricas, y la estructura genómica. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/microarreglos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "6 horas de ayuno previo. Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Analito: CROMOSOMAS.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "15000 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "15000 MXN",
      },
    ],
  },
  nips: {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "NIPS",
    description:
      "Esta prueba genética analiza si un embarazo tiene un mayor riesgo de trastornos cromosómicos (13, 18, 21), mediante la secuenciación del ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/nips",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 3 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "6 horas de ayuno previo.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Analitos analizados: CROMOSOMAS 13, 18, 21.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "14000 MXN",
      },
    ],
  },
  "nutricion-personalizada-vitalgene-45": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Nutrición personalizada VitalGene 45",
    description:
      "Prueba genética para nutrición personalizada y condición física, analiza 45 variantes en 36 genes implicados en el metabolismo de nutrimentos,salud cardiometabólica, control de peso y composición corporal, intolerancia alimentaria, ejercicio y salud física.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/nutricion-personalizada-vitalgene-45",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "30 minutos sin haber ingerido alimentos, tomado agua, fumado, ni cepillado los dientes, para recolección de saliva.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "BCMO1, FUT2, GSTT1, CYP2R1, GC, COMT, MTHFR, MTHFD1, PEMT, SLC17A1, HFE, TMPRSS6, TFR2, TF, MCM6, HLA, ADORA2A, CYP1A2, TCF7L2, ACE, FADS1, LIPC, FTO, ADRB2, UCP1, APOA2, PPARy2, BDNF, CYP19A1, LEPR, ACTN3, NFIA-AS2, ADRB3, NRF2, GSTP1, PGC1a, WNT16, COL5A1.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "6200 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "6200 MXN",
      },
    ],
  },
  "panel-cancer-hereditario-axiona-gene": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel cáncer hereditario Axiona GENE",
    description:
      "Prueba genética para detectar alteraciones en 134 genes asociados con el riesgo de padecer alguno de los tipos de cáncer más comunes como de mama, ovario, gástrico, colorrectal, endometrio, próstata, páncreas, renal, piel, entre otros, mediante la secuenciación del ADN.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/nutricion-personalizada-vitalgene-45",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "20 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado, ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Metodología: Secuenciación de Nueva Generación (NGS). Genes analizados: AIP, BUB1, EPCAM, FANCM, MLH3, PHOX2B, RAD51D, SH2D1A, WAS, AKT1, BUB1B, ERCC2, FH, MRE11A, PIK3CA, RB1, SLX4, WRN, ALK, CACNA1D, ERCC3, FLCN, MSH2, PMS2, RECQL4, SMAD4, WT1, ANTXR1, CBL, ERCC4, GPC3, MSH6, POLD1, RET, SMARCB1, XPA, APC, CDC73, ERCC5, HNF1A, MSR1, POLE, RHBDF2, SMARCE1, XPC, ASCC1, CDH1, EXT1, HNF1B, MTAP, POLH, RNASEL, SPINK1, XRCC2, ATM, CDK4, EXT2, HOXB13, MUTYH, PPM1D, RNF168, SPRED1, ATR, CDKN1B, FANCA, KDR, MYH8, PRF1, RSPO1, STK11, AXIN2, CDKN2A, FANCB, KIT, NBN, PRKAR1A, RUNX1, SUFU, BAP1, CHEK2, FANCC, KLLN, NCOA4, PRSS1, SBDS, TERT, BARD1, CTHRC1, FANCD2, LIG4, NF1, PTCH1, SDHA, TGFBR1, BLM, CYLD, FANCE, MAX, NF2, PTCH2, SDHAF2, TMEM127, BMPR1A, DDB2, FANCF, MEN1, NTRK1, PTEN, SDHB, TP53, BRCA1, DICER1, FANCG, MET, PALB2, PTPN11, SDHC, TSC1, BRCA2, EGFR, FANCI, MITF, PALLD, RAD50, SDHD, TSC2, BRIP1, ELAC2, FANCL, MLH1, PDGFRB, RAD51C, SETBP1, VHL.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "21000 MXN",
      },
    ],
  },
  "panel-integral-de-trastornos-neuromusculares-(230-genes)": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel Integral de trastornos neuromusculares (230 genes)",
    description:
      "Está prueba genética analiza alteraciones en 230 genes asociados con enfermedades neuromusculares hereditarias como distrofias musculares, miopatías hereditarias, trastornos mitocondriales, síndromes miasténicos congénitos y rabdomiólisis, mediante técnicas de secuenciación de ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-integral-de-trastornos-neuromusculares-(230-genes)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo. Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: ABHD5, ACAD9, ACADM, ACADVL, ACTA1, ADSSL1, AGK, AGL, AGRN, AHCY, ALDOA, ALG14, ALG2, AMACR, AMPD1, ANO5, ATP2A1, ATP7B, B3GALNT2, B4GAT1, BAG3, BIN1, C1QBP, CACNA1S, CAPN3, CASQ1, CAV3, CCDC78, CFL2, CHAT, CHKB, CHRNA1, CHRNB1, CHRND, CHRNE, CLCN1, CNTN1, COL12A1, COL13A1, COL6A1, COL6A2, COL6A3, COLQ, COQ2, COQ4, COQ7, COQ8A, COQ9, COX15, COX20, COX6B1, CPT1A, CPT2, CRYAB, CTDP1, DAG1, DDC, DES, DGUOK, DMD, DNA2, DNAJB6, DNM2, DOK7, DPAGT1, DPM1, DPM2, DPM3, DYSF, EMD, ENO3, ETFA, ETFB, ETFDH, FBXL4, FDX2, FHL1, FKBP14, FKRP, FKTN, FLAD1, FLNC, GAA, GATM, GBE1, GFER, GFPT1, GMPPB, GNE, GOSR2, GYG1, GYS1, HACD1, HADH, HADHA, HADHB, HMBS, HNRNPA2B1, HNRNPDL, ISCU, ISPD, ITGA7, KBTBD13, KCNJ2, KLHL40, KLHL41, LAMA2, LAMP2, LARGE1, LDB3, LDHA, LMNA, LMOD3, LPIN1, MAN2B1, MAP3K20, MATR3, MEGF10, MGME1, MICU1, MPV17, MTM1, MUSK, MYH2, MYH3, MYH7, MYL2, MYO18B, MYOT, MYPN, NEB, OPA1, OPA3, ORAI1, PDSS1, PDSS2, PFKM, PGAM2, PGK1, PGM1, PHKA1, PHKB, PLEC, PNPLA2, PNPLA8, POGLUT1, POLG, POLG2, POMGNT1, POMGNT2, POMK, POMT1, POMT2, PREPL, PUS1, PYGM, PYROXD1, RAPSN, RBCK1, RNASEH1, RRM2B, RXYLT1, RYR1, SCN4A, SDHA, SELENON, SGCA, SGCB, SGCD, SGCG, SIL1, SLC16A1, SLC18A3, SLC22A5, SLC25A20, SLC25A3, SLC25A4, SLC25A42, SLC5A7, SMCHD1, SMN1, SMN2, SMPX, SPEG, SQSTM1, STAC3, STIM1, SUCLA2, SUCLG1, SYT2, TANGO2, TAZ, TCAP, TIA1, TK2, TNNT1, TNPO3, TOR1AIP1, TPM2, TPM3, TRAPPC11, TRIM32, TRMT5, TSFM, TTN, TWNK, TYMP, VAMP1, VCP, VMA21, YARS2, ATP1A2, ATP5D, ATP5E, CHCHD10, KLHL9, LAMB2, LIMS2, LRP4, MCM3AP, MTMR14, SLC25A32, SNAP25, SUN1, SUN2, SYNE1, SYNE2, TMEM43, TNNT3, TOP3A.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },

  "panel-para-arritmia-y-cardiomiopatia": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para arritmia y cardiomiopatía",
    description:
      "Está prueba genética analiza alteraciones en 168 genes asociados con las condiciones hereditarias de arritmia y cardiomiopatía, mediante técnicas de secuenciación del ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-para-arritmia-y-cardiomiopatia",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo.  Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: ABCC9, ACADVL, ACTC1, ACTN2, AGL, ALMS1, ALPK3, BAG3, BRAF, CACNA1C, CACNA1D, CALM1, CALM2, CALM3, CASQ2, CBL, CDH2, CPT2, CRYAB, CSRP3, DES, DMD, DNAJC19, DOLK, DSC2, DSG2, DSP, ELAC2, EMD, EYA4, FHL1, FKRP, FKTN, FLNC, GAA, GATA4, GATA5, GJA5, GLA, HCN4, HRAS, JUP, KCNE1, KCNH2, KCNJ2, KCNQ1, KRAS, LAMP2, LMNA, LZTR1, MAP2K1, MAP2K2, MRAS, MTO1, MYBPC3, MYH7, MYL2, MYL3, MYL4, MYLK3, NF1, NKX2-5, NRAS, PCCA, PCCB, PKP2, PLN, PPA2, PPCS, PPP1CB, PRKAG2, PTPN11, RAF1, RASA1, RBM20, RIT1, RYR2, SCN5A, SDHA, SGCD, SHOC2, SLC22A5, SOS1, SOS2, SPRED1, TAZ, TBX20, TCAP, TMEM43, TMEM70, TNNC1, TNNI3, TNNI3K, TNNT2, TPM1, TRDN, TRPM4, TTN, TTR, VCL, A2ML1, AKAP9, ANK2, ANKRD1, CACNA2D1, CACNB2, CALR3, CAV3, CHRM2, CTF1, CTNNA3, DTNA, FHL2, GATA6, GATAD1, GPD1L, HAND1, ILK, JPH2, KCNA5, KCND3, KCNE2, KCNE3, KCNE5, KCNJ5, KCNJ8, KCNK3, KIF20A, KLF10, LAMA4, LDB3, LRRC10, MAP3K8, MED12, MYH6, MYLK2, MYOM1, MYOZ2, MYPN, NEBL, NEXN, NPPA, PDLIM3, PLEKHM2, PRDM16, RANGRF, RASA2, RRAS, SCN10A, SCN1B, SCN2B, SCN3B, SCN4B, SLMAP, SNTA1, TMPO, TXNRD2, DEPDC5, KCNA1, KCNQ2, KCNQ3, KCNT1, PCDH19, PRRT2, SCN1A, SCN8A, SCN9A, SLC2A1.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },

  "panel-para-cancer-colorrectal": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para cáncer colorrectal",
    description:
      "Esta prueba genética analiza alteraciones en 30 genes asociados con una predisposición hereditaria al cáncer colorrectal, mediante la secuenciación del ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-para-cancer-colorrectal",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo.  Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: APC, AXIN2, BMPR1A, CDH1, CHEK2, EPCAM, GREM1, MLH1, MSH2, MSH3, MSH6, MUTYH, NTHL1, PMS2, POLD1, POLE, PTEN, SMAD4, STK11, TP53,ATM, BLM, BUB1B, CEP57, ENG, FLCN, GALNT12, MLH3, RNF43, RPS20.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },

  "panel-para-cancer-de-mama-y-ginecologico": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para cáncer de mama y ginecológico",
    description:
      "Prueba genética para detectar alteraciones en 36 genes que están asociados con la predisposición hereditaria a los cánceres de mama, ovario y endometrio/uterino, mediante la secuenciación del ADN de la muestra.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-para-cancer-de-mama-y-ginecologico",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado, ni cepillado los dientes, para recolección de saliva. 6 horas de ayuno previas a la recolección de sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "ATM, BARD1, BRCA1, BRCA2, BRIP1, CDH1, CHEK2, DICER1, EPCAM, MLH1, MSH2, MSH6, NF1, PALB2, PMS2, PTEN, RAD51C, RAD51D, SMARCA4, STK11, TP53, ABRAXAS1, AKT1, CDC73, FANCC, FANCM, MRE11, MUTYH, NBN, PIK3CA, POLD1, RECQL, RINT1, SDHB, SDHD, XRCC2.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "21000 MXN",
      },
    ],
  },

  "panel-para-desordenes-de-retina-hereditarios": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para desórdenes de retina hereditarios",
    description:
      "Está prueba genética analiza alteraciones en 330 genes asociados con diversos trastornos hereditarios de la retina, incluidos, entre otros, la retinitis pigmentaria (RP), la distrofia de conos y bastones y la amaurosis congénita de Leber; mediante técnicas de secuenciación del ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://labopat.mx/estudio/panel-para-desordenes-de-retina-hereditarios",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo.  Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: ABCA4, ABCC6, ABHD12, ACBD5, ACO2, ADAM9, ADAMTS18, ADAMTSL4, ADGRA3, ADGRV1, ADIPOR1, AGBL5, AHI1, AHR, AIPL1, ALMS1, ARHGEF18, ARL13B, ARL2BP, ARL3, ARL6, ARMC9, ARSG, ASRGL1, ATF6, ATOH7, B9D1, BBIP1, BBS1, BBS10, BBS12, BBS2, BBS4, BBS5, BBS7, BBS9, BEST1, C10ORF11, C12ORF65, C1QTNF5, C8ORF37, CA4, CABP4, CACNA1F, CACNA2D4, CAPN5, CC2D2A, CCT2, CDH23, CDH3, CDHR1, CEP164, CEP19, CEP250, CEP290, CEP41, CEP78, CEP83, CERKL, CFAP410, CHM, CIB2, CISD2, CLCC1, CLN2 (TPP1), CLN3, CLN5, CLN6, CLN8, CLRN1, CLUAP1, CNGA1, CNGA3, CNGB1, CNGB3, CNNM4, COL11A1, COL11A2, COL18A1, COL2A1, COL9A1, COL9A2, COL9A3, CPLANE1, CRB1, CRX, CSPP1, CTNNA1, CTSD, CWC27, CYP4V2, DHDDS, DHX32, DHX38, DNAJC17, DRAM2, DSCAML1, DTHD1, EFEMP1, ELOVL4, EMC1, ERCC6, EXOSC2, EYS, FAM161A, FBLN5, FLVCR1, FRMD7, FSCN2, FZD4, GDF6, GNAT1, GNAT2, GNB3, GNPTG, GNS, GPR143, GPR179, GPR45, GRM6, GRN, GUCA1A, GUCA1B, GUCY2D, HARS, HGSNAT, HK1, HMCN1, HMX1, IDH3A, IDH3B, IFT140, IFT172, IFT27, IFT43, IFT74, IFT80, IFT81, IFT88, IMPDH1, IMPG1, IMPG2, INPP5E, INVS, IQCB1, ITM2B, JAG1, KCNJ13, KCNV2, KIAA0586, KIAA1549, KIF11, KIF7, KIZ, KLHL7, LCA5, LRAT, LRIT3, LRP2, LRP5, LYST, LZTFL1, MAK, MAPKAPK3, MERTK, MFN2, MFRP, MFSD8, MIR204, MKKS, MKS1, MPDZ, MTPAP, MTTP, MYO7A, NAGLU, NBAS, NDP, NEK2, NEUROD1, NMNAT1, NPHP1, NPHP3, NPHP4, NR2E3, NR2F1, NRL, NYX, OAT, OCA2, OFD1, OPA1, OPA3, OPN1SW, OR2W3, OTX2, P3H2, PAX2, PAX6, PCARE, PCDH15, PCYT1A, PDE6A, PDE6B, PDE6C, PDE6D, PDE6G, PDE6H, PDZD7, PEX1, PEX10, PEX11B, PEX12, PEX13, PEX14, PEX16, PEX19, PEX2, PEX26, PEX3, PEX5, PEX6, PEX7, PHYH, PITPNM3, PLA2G5, PLK4, PNPLA6, POC1B, POC5, POMGNT1, PPT1, PRCD, PRDM13, PROM1, PRPF3, PRPF31, PRPF4, PRPF6, PRPF8, PRPH2, PRPS1, RAB28, RAX2, RBP1, RBP3, RBP4, RCBTB1, RD3, RDH11, RDH12, RDH5, REEP6, RGR, RGS9, RGS9BP, RHO, RIMS1, RLBP1, ROM1, RP1, RP1L1, RP2, RP9, RPE65, RPGR, RPGR (ORF15), RPGRIP1, RPGRIP1L, RS1, RTN4IP1, SAG, SAMD11, SCLT1, SDCCAG8, SEMA4A, SGSH, SIX6, SLC24A1, SLC24A5, SLC45A2, SLC7A14, SNRNP200, SPATA7, SPP2, TCTN1, TCTN2, TCTN3, TEAD1, TIMM8A, TIMP3, TMED7, TMEM107, TMEM126A, TMEM138, TMEM216, TMEM231, TMEM237, TMEM67, TOPORS, TRAF3IP1, TREX1, TRIM32, TRNT1, TRPM1, TSPAN12, TTC21B, TTC8, TTLL5, TTPA, TUB, TUBGCP4, TUBGCP6, TULP1, TYR, TYRP1, UNC119, USH1C, USH1G, USH2A, VCAN, VPS13B, WDPCP, WDR19, WDR34, WFS1, WHRN, ZNF408, ZNF423, ZNF513.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },

  "panel-para-desordenes-esqueleticos": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para desórdenes esqueléticos",
    description:
      "Esta prueba genética analiza alteraciones en 358 genes que están asociados con condiciones que afectan el sistema esquelético, estos son trastornos genéticamente heterogéneos caracterizados por un desarrollo o crecimiento anormal de huesos o cartílagos, mediante la secuenciación del ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-para-desordenes-esqueleticos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo.  Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: ACAN, ACP5, ACVR1, ADAMTS10, ADAMTS17, AFF4, AGA, AGPS, AIFM1, ALPL, AMER1, ANKH, ANO5, ARCN1, ARSB, ARSE, ASCC1, ASPM, ATR, ATRIP, B3GALT6, B3GAT3, B4GALT7, BGN, BMP1, BMP2, BMPER, BMPR1B, C2CD3, CA2, CANT1, CASR, CCDC8, CDC45, CDC6, CDK5RAP2, CDKN1C, CDT1, CENPJ, CEP120, CEP135, CEP152, CEP63, CEP97, CFAP410, CHST14, CHST3, CHUK, CLCN5, CLCN7, COG1, COL10A1, COL11A1, COL11A2, COL1A1, COL1A2, COL27A1, COL2A1, COL9A1, COL9A2, COL9A3, COMP, CREB3L1, CRIPT, CRTAP, CSF1R, CSGALNACT1, CSPP1, CTNS, CTSA, CTSK, CUL7, CWC27, CYP27B1, CYP2R1, DDR2, DDRGK1, DHCR24, DIP2C, DLL1, DLL3, DLX3, DMP1, DMRT2, DNA2, DNMT3A, DONSON, DVL1, DVL3, DYM, DYNC2H1, DYNC2LI1, EBP, EIF2AK3, ENPP1, ESCO2, EVC, EVC2, EXOC6B, EXOSC2, EXT1, EXT2, EXTL3, FAH, FAM111A, FAM20C, FAM46A, FAR1, FAT4, FBN1, FGF23, FGF9, FGFR1, FGFR2, FGFR3, FIG4, FKBP10, FLNA, FLNB, FN1, FTO, FUCA1, FZD2, GALNS, GALNT3, GDF5, GDF6, GHR, GHRHR, GHSR, GJA1, GLB1, GMNN, GNAS, GNE, GNPAT, GNPTAB, GNPTG, GNS, GORAB, GPC6, GPX4, GSC, GUSB, GZF1, HES7, HGSNAT, HPGD, HSPG2, HYAL1, IARS2, ICK, IDS, IDUA, IFITM5, IFT122, IFT140, IFT172, IFT43, IFT52, IFT57, IFT74, IFT80, IFT81, IGF1, IGF2, IHH, IMPAD1, INPPL1, INTU, JAG1, KAT6B, KIAA0586, KIAA0753, KIF22, KL, KMT2A, LARP7, LBR, LEMD3, LFNG, LIFR, LIG4, LMNA, LMX1B, LONP1, LOXL3, LRP4, LRP5, LRRK1, LTBP2, LTBP3, MAFB, MAN2B1, MANBA, MAP3K7, MATN3, MBTPS1, MBTPS2, MCM5, MCPH1, MEOX1, MESDC2, MESP2, MGP, MMP13, MMP14, MMP2, MMP9, MNX1, MSX2, MYH3, MYO18B, NAGLU, NANS, NBAS, NEK1, NEU1, NIN, NKX3-2, NOG, NOTCH2, NPPC, NPR2, NPR3, NSDHL, NSMCE2, NTRK1, NXN, OBSL1, OCRL, ORC1, ORC4, ORC6, OSTM1, P3H1, P4HB, PAM16, PAPSS2, PCGF2, PCNT, PCYT1A, PDE4D, PEX5, PEX7, PGM3, PHEX, PIK3C2A, PISD, PKDCC, PLK4, PLOD2, PLS3, POC1A, POLR1A, POP1, POR, PPIB, PPP3CA, PRKAR1A, PTDSS1, PTH1R, PTHLH, PTPN11, PYCR1, RAB33B, RBBP8, RECQL4, RIPPLY2, RMRP, RNU4ATAC, ROR2, RSPO2, RSPRY1, RTTN, RUNX2, SC5D, SEC24D, SERPINF1, SERPINH1, SETBP1, SFRP4, SGMS2, SGSH, SH3PXD2B, SLC17A5, SLC26A2, SLC29A3, SLC2A2, SLC34A1, SLC34A3, SLC35D1, SLC39A13, SLCO2A1, SLCO5A1, SMAD4, SMARCAL1, SNRPB, SNX10, SOX9, SP7, SPARC, SQSTM1, SRCAP, SUCO, SULF1, SUMF1, TAB2, TAPT1, TBCE, TBX15, TBX3, TBX5, TBX6, TBXAS1, TCIRG1, TCTEX1D2, TCTN3, TGFB1, TMEM165, TMEM38B, TNFRSF11A, TNFRSF11B, TNFSF11, TONSL, TRAF3IP1, TRAIP, TRAPPC2, TREM2, TRIM37, TRIP11, TRIP4, TRMT10A, TRPS1, TRPV4, TTC21B, TUBGCP4, TUBGCP6, TYROBP, UBE3B, VAC14, VDR, VPS33A, WDR19, WDR34, WDR35, WDR4, WDR60, WISP3, WNT1, WNT3, WNT3A, WNT5A, XRCC4, XYLT1, XYLT2, ZMPSTE24, ZNF687.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },

  "panel-para-deteccion-de-portadores-1-paciente": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para detección de portadores 1 paciente",
    description:
      "La prueba de detección de portadores es un tipo de prueba genética que analiza su ADN para proporcionar información específica sobre el riesgo de que su hijo pueda heredar ciertos trastornos genéticos, mediante la secuenciación del ADN de la muestra. Esta información le permite tomar decisiones reproductivas informadas. TOMA DE 1 SOLO PADRE DE FAMILIA. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-para-deteccion-de-portadores-1-paciente",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo.  Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: CFTR, SMN1, ABCB11, ABCC8, ABCD1, ACAD9, ACADM, ACADVL, ACAT1, ACOX1, ACSF3, ADA, ADAMTS2, ADGRG1, AGA, AGL, AGPS, AGXT, AIRE, ALDH3A2, ALDOB, ALG6, ALMS1, ALPL, AMT, AQP2, ARG1, ARSA, ARSB, ASL, ASNS, ASPA, ASS1, ATM, ATP6V1B1, ATP7A, ATP7B, ATRX, BBS1, BBS10, BBS12, BBS2, BCKDHA, BCKDHB, BCS1L, BLM, BSND, CAPN3, CBS, CDH23, CEP290, CERKL, CHM, CHRNE, CIITA, CLN3, CLN5, CLN6, CLN8, CLRN1, CNGB3, COL27A1, COL4A3, COL4A4, COL4A5, COL7A1, CPS1, CPT1A, CPT2, CRB1, CTNS, CTSK, CYBA, CYBB, CYP11B1, CYP11B2, CYP17A1, CYP19A1, CYP21A2, CYP27A1, DBT, DCLRE1C, DHCR7, DHDDS, DLD, DMD, DNAH5, DNAI1, DNAI2, DYSF, EDA, EIF2B5, ELP1, EMD, ERCC6, ERCC8, ESCO2, ETFA, ETFDH, ETHE1, EVC, EVC2, EYS, F9, FAH, FAM161A, FANCA, FANCC, FANCG, FH, FKRP, FKTN, FMR1, G6PC, GAA, GALC, GALK1, GALT, GAMT, GBA, GBE1, GCDH, GFM1, GJB1, GJB2, GLA, GLB1, GLDC, GLE1, GNE, GNPTAB, GNPTG, GNS, GRHPR, HADHA, HAX1, HBA1, HBA2, HBB, HEXA, HEXB, HGSNAT, HJV, HLCS, HMGCL, HOGA1, HPS1, HPS3, HSD17B4, HSD3B2, HYAL1, HYLS1, IDS, IDUA, IL2RG, IVD, KCNJ11, LAMA2, LAMA3, LAMB3, LAMC2, LCA5, LDLR, LDLRAP1, LHX3, LIFR, LIPA, LOXHD1, LPL, LRPPRC, MAN2B1, MCOLN1, MED17, MESP2, MFSD8, MKS1, MLC1, MMAA, MMAB, MMACHC, MMADHC, MPI, MPL, MPV17, MTHFR, MTM1, MTRR, MTTP, MUT, MYO7A, NAGLU, NAGS, NBN, NDRG1, NDUFAF5, NDUFS6, NEB, NPC1, NPC2, NPHS1, NPHS2, NR2E3, NTRK1, OAT, OPA3, OTC, PAH, PC, PCCA, PCCB, PCDH15, PDHA1, PDHB, PEX1, PEX10, PEX12, PEX2, PEX6, PEX7, PFKM, PHGDH, PKHD1, PMM2, POMGNT1, PPT1, PROP1, PRPS1, PSAP, PTS, PUS1, PYGM, RAB23, RAG2, RAPSN, RARS2, RDH12, RMRP, RPE65, RPGRIP1L, RS1, RTEL1, SACS, SAMHD1, SEPSECS, SGCA, SGCB, SGCG, SGSH, SLC12A3, SLC12A6, SLC17A5, SLC22A5, SLC25A13, SLC25A15, SLC26A2, SLC26A4, SLC35A3, SLC37A4, SLC39A4, SLC4A11, SLC6A8, SLC7A7, SMARCAL1, SMPD1, STAR, SUMF1, TAT, TCIRG1, TECPR2, TFR2, TGM1, TH, TMEM216, TPP1, TRMU, TSFM, TTPA, TYMP, USH1C, USH2A, VPS13A, VPS13B, VPS45, VRK1, VSX2, WNT10A, XPA, XPC, ZFYVE26, BTD, F11, F2, F5, G6PD, GP1BA, GP9, HFE, HGD, MCCC1, MCCC2, MEFV, SERPINA1.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "20500 MXN",
      },
    ],
  },

  "panel-para-deteccion-de-portadores-2-pacientes": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para detección de portadores 2 pacientes",
    description:
      "La prueba de detección de portadores es un tipo de prueba genética que analiza su ADN para proporcionar información específica sobre el riesgo de que su hijo pueda heredar ciertos trastornos genéticos, mediante la secuenciación del ADN de la muestra. Esta información le permite tomar decisiones reproductivas informadas. TOMA DE AMBOS PADRES DE FAMILIA.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-para-deteccion-de-portadores-2-pacientes",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado, ni cepillado los dientes, para recolección de saliva. 6 horas de ayuno previas a la recolección de sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "CFTR, SMN1, ABCB11, ABCC8, ABCD1, ACAD9, ACADM, ACADVL, ACAT1, ACOX1, ACSF3, ADA, ADAMTS2, ADGRG1, AGA, AGL, AGPS, AGXT, AIRE, ALDH3A2, ALDOB, ALG6, ALMS1, ALPL, AMT, AQP2, ARG1, ARSA, ARSB, ASL, ASNS, ASPA, ASS1, ATM, ATP6V1B1, ATP7A, ATP7B, ATRX, BBS1, BBS10, BBS12, BBS2, BCKDHA, BCKDHB, BCS1L, BLM, BSND, CAPN3, CBS, CDH23, CEP290, CERKL, CHM, CHRNE, CIITA, CLN3, CLN5, CLN6, CLN8, CLRN1, CNGB3, COL27A1, COL4A3, COL4A4, COL4A5, COL7A1, CPS1, CPT1A, CPT2, CRB1, CTNS, CTSK, CYBA, CYBB, CYP11B1, CYP11B2, CYP17A1, CYP19A1, CYP21A2, CYP27A1, DBT, DCLRE1C, DHCR7, DHDDS, DLD, DMD, DNAH5, DNAI1, DNAI2, DYSF, EDA, EIF2B5, ELP1, EMD, ERCC6, ERCC8, ESCO2, ETFA, ETFDH, ETHE1, EVC, EVC2, EYS, F9, FAH, FAM161A, FANCA, FANCC, FANCG, FH, FKRP, FKTN, FMR1, G6PC, GAA, GALC, GALK1, GALT, GAMT, GBA, GBE1, GCDH, GFM1, GJB1, GJB2, GLA, GLB1, GLDC, GLE1, GNE, GNPTAB, GNPTG, GNS, GRHPR, HADHA, HAX1, HBA1, HBA2, HBB, HEXA, HEXB, HGSNAT, HJV, HLCS, HMGCL, HOGA1, HPS1, HPS3, HSD17B4, HSD3B2, HYAL1, HYLS1, IDS, IDUA, IL2RG, IVD, KCNJ11, LAMA2, LAMA3, LAMB3, LAMC2, LCA5, LDLR, LDLRAP1, LHX3, LIFR, LIPA, LOXHD1, LPL, LRPPRC, MAN2B1, MCOLN1, MED17, MESP2, MFSD8, MKS1, MLC1, MMAA, MMAB, MMACHC, MMADHC, MPI, MPL, MPV17, MTHFR, MTM1, MTRR, MTTP, MUT, MYO7A, NAGLU, NAGS, NBN, NDRG1, NDUFAF5, NDUFS6, NEB, NPC1, NPC2, NPHS1, NPHS2, NR2E3, NTRK1, OAT, OPA3, OTC, PAH, PC, PCCA, PCCB, PCDH15, PDHA1, PDHB, PEX1, PEX10, PEX12, PEX2, PEX6, PEX7, PFKM, PHGDH, PKHD1, PMM2, POMGNT1, PPT1, PROP1, PRPS1, PSAP, PTS, PUS1, PYGM, RAB23, RAG2, RAPSN, RARS2, RDH12, RMRP, RPE65, RPGRIP1L, RS1, RTEL1, SACS, SAMHD1, SEPSECS, SGCA, SGCB, SGCG, SGSH, SLC12A3, SLC12A6, SLC17A5, SLC22A5, SLC25A13, SLC25A15, SLC26A2, SLC26A4, SLC35A3, SLC37A4, SLC39A4, SLC4A11, SLC6A8, SLC7A7, SMARCAL1, SMPD1, STAR, SUMF1, TAT, TCIRG1, TECPR2, TFR2, TGM1, TH, TMEM216, TPP1, TRMU, TSFM, TTPA, TYMP, USH1C, USH2A, VPS13A, VPS13B, VPS45, VRK1, VSX2, WNT10A, XPA, XPC, ZFYVE26, BTD, F11, F2, F5, G6PD, GP1BA, GP9, HFE, HGD, MCCC1, MCCC2, MEFV, SERPINA1.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "18000 MXN",
      },
    ],
  },

  "panel-para-distrofia-muscular": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para distrofia muscular",
    description:
      "Está prueba genética analiza alteraciones en 53 genes asociados con distrofias musculares hereditarias, un grupo heterogéneo de condiciones neuromusculares que se caracterizan por debilidad y desgaste debido a la disfunción muscular, mediante técnicas de secuenciación de ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-para-distrofia-muscular",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo.  Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: ANO5, B3GALNT2, B4GAT1, CAPN3, CAV3, CHKB, COL12A1, COL6A1, COL6A2, COL6A3, DAG1, DES, DMD, DNAJB6, DPM1, DPM2, DPM3, DYSF, EMD, FHL1, FKRP, FKTN, GAA, GMPPB, GOSR2, HNRNPDL, ISPD, ITGA7, LAMA2, LARGE1, LMNA, MYOT, PLEC, PNPLA2, POGLUT1, POMGNT1, POMGNT2, POMK, POMT1, POMT2, RXYLT1, SGCA, SGCB, SGCD, SGCG, SMCHD1, TCAP, TK2, TNPO3, TOR1AIP1, TRAPPC11, TRIM32, TTN, KBTBD13, LIMS2, SUN1, SUN2, SYNE1, SYNE2, TMEM43.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },

  "panel-para-enfermedad-renal-progresiva": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para enfermedad renal progresiva",
    description:
      "Está prueba genética analiza alteraciones en 195 genes asociados con trastornos renales progresivos como el síndrome de Alport, la glomeruloesclerosis focal y segmentaria y el síndrome nefrótico, mediante técnicas de secuenciación del ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-para-enfermedad-renal-progresiva",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo.  Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes anaizados:ACE, ACTB, ACTN4, ADAMTS13, AGT, AGTR1, AHI1, ALG8, ALG9, ALMS1, AMN, ANKS6, ANLN, APOL1, APRT, AQP2, ARHGAP24, ARHGDIA, ARL6, ATP6V0A4, ATP6V1B1, AVP, AVPR2, BBIP1, BBS1, BBS10, BBS12, BBS2, BBS4, BBS5, BBS7, BBS9, BICC1, BSND, CA2, CACNA1D, CACNA1H, CASR, CD151, CD2AP, CDKN1C, CEP164, CEP19, CEP290, CEP83, CEP89, CFHR5, CHRM3, CLCN5, CLCNKB, CLDN16, CLDN19, COL4A1, COL4A3, COL4A4, COL4A5, COL4A6, COQ2, COQ6, COQ8B, CPLANE1, CRB2, CTNS, CUBN, CYP24A1, DCDC2, DGKE, DHCR7, DICER1, DLC1, DNAJB11, DZIP1L, EGF, EMP2, EYA1, FAM20A, FAN1, FAT1, FN1, FOXI1, FOXP3, FREM1, GANAB, GATA3, GATM, GLA, GLIS2, GRHPR, GSN, HNF1A, HNF1B, HPRT1, HPSE2, HSD11B2, IFT122, IFT140, IFT172, IFT27, IFT43, INF2, INVS, IQCB1, ITGA3, ITGA6, ITGB4, JAG1, KANK2, KANK4, KAT6B, KCNJ1, KCNJ10, LAMA5, LAMB2, LCAT, LDHA, LMX1B, LPIN1, LRP4, LRP5, LYZ, LZTFL1, MAGED2, MAGI2, MAPKBP1, MEFV, MKKS, MYH9, MYO1E, NEK8, NOTCH2, NPHP1, NPHP3, NPHP4, NPHS1, NPHS2, NSDHL, NUP107, NUP133, NUP160, NUP205, NUP85, NUP93, OFD1, PAX2, PBX1, PDSS2, PHEX, PKD2, PKHD1, PLCE1, PODXL, PREPL, PTPRO, REN, RMND1, RPGRIP1L, SALL1, SALL4, SARS2, SDCCAG8, SEC61A1, SEMA3E, SGPL1, SIX1, SIX5, SLC12A1, SLC12A3, SLC22A12, SLC2A2, SLC2A9, SLC37A4, SLC41A1, SLC4A1, SLC4A4, SLC7A7, SMARCAL1, SYNPO, TBC1D8B, TMEM67, TNS2, TP63, TRIM32, TRPC6, TSC1, TSC2, TTC21B, TTC8, UMOD, WDPCP, WDR19, WDR73, WT1, XPNPEP3, XPO5, ZNF423.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "13000 MXN",
      },
    ],
  },
  "panel-para-epilepsia-(320-genes)": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para epilepsia (320 genes)",
    description:
      "Prueba genética para la detección de mutaciones en 320 genes asociados a causas sindrómicas y no sindrómicas de la epilepsia, una enfermedad neurológica común caracterizada por convulsiones recurrentes no provocadas, mediante técnicas de secuenciación del ADN de la muestra.Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https: //www.labopat.mx/estudio/panel-para-epilepsia-(320-genes)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo. Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: AARS, ABAT, ADAR, ADSL, ALDH5A1, ALDH7A1, ALG1, ALG12, ALG13, ALG6, AMACR, AMT, AP2M1, AP3B2, ARG1, ARHGEF9, ARSA, ARX, ASAH1, ASNS, ATAD1, ATP1A1, ATP1A2, ATP1A3, ATP6AP2, ATP7A, ATRX, BRAT1, C12ORF57, CACNA1A, CACNA1B, CACNA1E, CACNA2D2, CAD, CAMK2B, CARS2, CASK, CCDC88A, CDKL5, CHD2, CHRNA2, CHRNA4, CHRNB2, CLCN4, CLCN6, CLN2 (TPP1), CLN3, CLN5, CLN6, CLN8, CLTC, CNTN2, CNTNAP2, COG5, COL18A1, CSTB, CTNNB1, CTSD, CYFIP2, CYP27A1, DDC, DDX3X, DEAF1, DENND5A, DEPDC5, DHDDS, DHFR, DIAPH1, DMXL2, DNAJC5, DNM1, DNM1L, DOCK7, DYNC1H1, DYRK1A, ECHS1, EEF1A2, EHMT1, EMC1, EPM2A, FAR1, FARS2, FBXO11, FGF12, FLNA, FOLR1, FOXG1, FOXP1, FRRS1L, GABBR2, GABRA1, GABRA2, GABRB1, GABRB2, GABRB3, GABRG2, GAMT, GATAD2B, GATM, GCH1, GLDC, GLRA1, GLRB, GNAO1, GNB1, GOSR2, GPAA1, GPHN, GRIA3, GRIN1, GRIN2A, GRIN2B, GRIN2D, GTPBP3, HCN1, HDAC8, HEXA, HNRNPU, IER3IP1, IFIH1, IQSEC2, ITPA, KANSL1, KCNA1, KCNA2, KCNB1, KCNC1, KCND2, KCNH1, KCNH2, KCNH5, KCNJ10, KCNK4, KCNMA1, KCNQ2, KCNQ3, KCNQ5, KCNT1, KCTD7, KIF1A, KIF2A, KIF5A, KPNA7, LAMC3, LGI1, LIAS, MBD5, MDH2, MECP2, MEF2C, MFSD8, MICAL1, MOCS1, MOCS2, MTOR, NACC1, NAGLU, NECAP1, NEDD4L, NEXMIF, NGLY1, NHLRC1, NPC1, NPC2, NPRL3, NRXN1, NTRK2, NUS1, PACS1, PACS2, PAFAH1B1, PCDH19, PCLO, PEX10, PEX12, PEX13, PEX14, PEX16, PEX19, PEX2, PEX26, PEX3, PEX5, PEX6, PHGDH, PIGA, PIGB, PIGG, PIGN, PIGO, PIGP, PIGQ, PIGV, PIGW, PLAA, PLCB1, PNKD, PNKP, PNPO, PNPT1, POLG, PPP2CA, PPP2R1A, PPP2R5D, PPP3CA, PPT1, PRICKLE1, PRIMA1, PROSC, PRRT2, PSAP, PSAT1, PSPH, PTEN, PTPN23, PURA, QARS, QDPR, RAB11A, RAB11B, RAI1, RALA, RANBP2, RELN, RFT1, RHOBTB2, RNASEH2A, RNASEH2B, RNASEH2C, RNF13, ROGDI, RORB, RUSC2, SAMHD1, SATB2, SCARB2, SCN1A, SCN1B, SCN2A, SCN3A, SCN8A, SCN9A, SCP2, SERPINI1, SETBP1, SGCE, SGSH, SIK1, SLC12A5, SLC13A5, SLC19A3, SLC1A2, SLC25A12, SLC25A22, SLC2A1, SLC35A2, SLC6A1, SLC6A5, SLC6A8, SLC9A6, SMC1A, SNAP25, SNX27, SPATA5, SPTAN1, ST3GAL3, ST3GAL5, STAG2, STRADA, STX1B, STXBP1, STXBP2, SUMF1, SUOX, SURF1, SYN1, SYNGAP1, SYNJ1, SZT2, TANGO2, TBC1D24, TBCK, TBL1XR1, TCF4, TH, TK2, TPK1, TREX1, TRIM8, TSC1, TSC2, TSFM, TUBB2A, UBA5, UBE3A, UNC80, WDR45, WWOX, YWHAG, ZDHHC9, ZEB2, ZSWIM6, ARHGEF15, CACNA1H, CERS1, FASN, GABRD, GUF1, IDH3A, JMJD1C, LMNB2, MOCS3, PIK3AP1, PRDM8, PRICKLE2, RBFOX1, RBFOX3, SCN5A, SNIP1, TUBA8.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },
  "panel-para-feocromocitoma-y-paraganglioma-hereditario": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para feocromocitoma y paraganglioma hereditario",
    description:
      "Está prueba genética analiza alteraciones en 14 genes asociados con una predisposición hereditaria al síndrome de paraganglioma-feocromocitoma, mediante la secuenciación del ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https: //www.labopat.mx/estudio/panel-para-feocromocitoma-y-paraganglioma-hereditario",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes.Para recolección de sangre: 6 horas de ayuno previo.Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: MAX, NF1, RET, SDHA, SDHAF2, SDHB, SDHC, SDHD, TMEM127, VHL, EGLN1, FH, KIF1B, MEN1.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },
  "panel-para-glaucoma": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para glaucoma",
    description:
      "Está prueba genética analiza alteraciones en 27 genes asociados con el glaucoma, una afección que generalmente afecta ambos ojos, provoca una agudeza visual reducida y campos visuales restringidos, y conduce a la ceguera, si no se trata; mediante técnicas de secuenciación del ADN de la muestra.Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https: //www.labopat.mx/estudio/panel-para-glaucoma",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes.Para recolección de sangre: 6 horas de ayuno previo. Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: ASB10, ATOH7, BMP4, COL4A1, COL8A2, CYP1B1, EXO5, FOXC1, FOXE3, LMX1B, LTBP2, MAF, MFRP, MYOC, OPTN, PAX6, PIK3R1, PITX2, PITX3, PRPF8, PRSS56, PXDN, SH3PXD2B, SIX6, SLC4A4, TEK, WDR36.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },
  "panel-para-inmunodeficiencia": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para inmunodeficiencia",
    description:
      "Esta prueba genética analiza alteraciones en 474 genes que están asociados con trastornos hereditarios del sistema inmunitario, mediante la secuenciación del ADN de la muestra.Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https: //www.labopat.mx/estudio/panel-para-inmunodeficiencia",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes.Para recolección de sangre: 6 horas de ayuno previo.Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: ACD, ACP5, ACTB, ADA, ADA2, ADAM17, ADAR, ADGRE2, AICDA, AIRE, AK2, ALG6, ALPK1, ANGPT1, ANKZF1, AP3B1, AP3D1, ARHGEF1, ARPC1B, ASAH1, ATM, ATP6AP1, B2M, BACH2, BCL10, BCL11B, BLM, BLNK, BLOC1S3, BLOC1S6, BTK, C17ORF62, C1QA, C1QB, C1QC, C1S, C2, C3, C5, C6, C7, C8A, C8B, C9, CARD11, CARD14, CARD8, CARD9, CARMIL2, CASP10, CASP8, CBL, CCBE1, CD19, CD247, CD27, CD3D, CD3E, CD3G, CD40, CD40LG, CD46, CD55, CD59, CD79A, CD79B, CD81, CD8A, CDC42, CDCA7, CEBPE, CFB, CFD, CFH, CFI, CFP, CHD7, CIB1, CIITA, CLCN7, CLPB, COL7A1, COPA, CORO1A, CR2, CSF2RA, CSF2RB, CSF3R, CTC1, CTLA4, CTPS1, CTSC, CXCR2, CXCR4, CYBA, CYBB, CYP27A1, DBR1, DCLRE1C, DDX58, DEF6, DGAT1, DIAPH1, DKC1, DNAJC21, DNASE1L3, DNASE2, DNMT3B, DOCK2, DOCK8, DSG1, DTNBP1, DUOX2, EFL1, EIF2AK3, ELANE, EPG5, ERBIN, ERCC2, ERCC3, ERCC6L2, EXTL3, FADD, FANCA, FANCB, FANCE, FANCF, FANCI, FANCL, FAS, FASLG, FAT4, FCHO1, FERMT1, FERMT3, FNIP1, FOXI3, FOXN1, FOXP3, FPR1, G6PC, G6PC3, G6PD, GATA1, GATA2, GFI1, GINS1, GTF2E2, GTF2H5, GUCY2C, HAX1, HELLS, HMOX1, HPS1, HPS3, HPS4, HPS5, HPS6, HTRA2, HYOU1, ICOS, ICOSLG, IFIH1, IFNAR1, IFNAR2, IFNGR1, IFNGR2, IGLL1, IKBKB, IKZF1, IL10, IL10RA, IL10RB, IL12B, IL12RB1, IL12RB2, IL17F, IL17RA, IL17RC, IL18BP, IL1RN, IL21, IL21R, IL23R, IL2RA, IL2RB, IL2RG, IL36RN, IL6R, IL6ST, IL7R, IRAK4, IRF2BP2, IRF4, IRF7, IRF8, IRF9, ISG15, ITCH, ITGAM, ITGB2, ITK, JAGN1, JAK1, JAK3, KAT6A, KDM6A, KMT2A, KMT2D, LAMTOR2, LAT, LCK, LCT, LIG1, LIG4, LIPA, LPIN2, LRBA, LRRC8A, LYN, LYST, MAD2L2, MAGT1, MALT1, MAP3K14, MCM4, MEFV, MKL1, MOGS, MPLKIP, MS4A1, MSN, MTHFD1, MVK, MYD88, MYO5B, MYSM1, NBAS, NBN, NCF2, NCF4, NCKAP1L, NCSTN, NEUROG3, NFAT5, NFE2L2, NFKB1, NFKB2, NFKBIA, NHEJ1, NHP2, NLRC4, NLRP1, NLRP12, NLRP3, NOD2, NOP10, NSMCE3, OAS1, ORAI1, OSTM1, OTULIN, PARN, PAX1, PEPD, PGM3, PIK3CD, PIK3R1, PLCG2, PLVAP, PMM2, PNLIP, PNP, POLA1, POLD1, POLD2, POLE, POLE2, POLR3A, POLR3F, POMP, PRF1, PRKCD, PRKDC, PSENEN, PSMA3, PSMB4, PSMB8, PSMG2, PSTPIP1, PTPRC, RAB27A, RAC2, RAG1, RAG2, RANBP2, RASGRP1, RBCK1, REL, RELA, RELB, RFWD3, RFX5, RFXANK, RFXAP, RHOH, RIPK1, RMRP, RNASEH2A, RNASEH2B, RNASEH2C, RNF113A, RNF168, RNF31, RNU4ATAC, RORC, RPSA, RTEL1, SAMD9, SAMD9L, SAMHD1, SAR1B, SCO2, SEC61A1, SEMA3E, SERPING1, SGPL1, SH2D1A, SH3BP2, SH3KBP1, SI, SIAE, SKIV2L, SLC10A2, SLC26A3, SLC29A3, SLC35C1, SLC37A4, SLC39A7, SLC46A1, SLC51B, SLC5A1, SLC7A7, SLC9A3, SLX4, SMARCAL1, SMARCD2, SNX10, SP110, SPINK5, SPINT2, SPPL2A, SRP54, SRP72, STAT1, STAT2, STAT3, STAT4, STAT5B, STIM1, STK4, STN1, STX11, STX3, STXBP2, TAOK2, TAP1, TAP2, TAPBP, TAZ, TBX1, TCF3, TCIRG1, TCN2, TERC, TERT, TFRC, TGFB1, TGFBR1, TGFBR2, THBD, TICAM1, TIMM50, TINF2, TLR3, TLR7, TMC6, TMC8, TMEM173, TMPRSS15, TNFAIP3, TNFRSF11A, TNFRSF13B, TNFRSF13C, TNFRSF1A, TNFRSF4, TNFRSF6B, TNFRSF9, TNFSF11, TNFSF12, TONSL, TOP2B, TP63, TPP2, TRAF3, TRAF3IP2, TREX1, TRNT1, TTC37, TTC7A, TYK2, UNC13D, UNC45A, UNC93B1, UNG, USB1, VAV1, VPS13B, VPS45, WAS, WDR1, WIPF1, WNT2B, WRAP53, XIAP, ZAP70, ZBTB24, ZCCHC8, ZNF341, AK7, ARMC4, C11ORF70, CCDC103, CCDC114, CCDC151, CCDC39, CCDC40, CCDC65, CCNO, CEP164, CFAP298, CFTR, DNAAF1, DNAAF2, DNAAF3, DNAAF4, DNAAF5, DNAH1, DNAH11, DNAH5, DNAH8, DNAH9, DNAI1, DNAI2, DNAJB13, DNAL1, DRC1, GAS8, LRRC56, LRRC6, MCIDAS, NOTCH2, OFD1, PIH1D3, RPGR, RSPH1, RSPH3, RSPH4A, RSPH9, SPAG1, ZMYND10, MSH6, PMS2, PTEN.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },
  "panel-para-leucodistrofias-y-leucoencefalopatia-genetica": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para leucodistrofias y leucoencefalopatía genética",
    description:
      "Prueba genética que analiza alteraciones en 729 genes asociados con leucodistrofia y leucoencefalia genética, afecciones hereditarias que afectan la médula del sistema nervioso central, con o sin compromiso del sistema nervioso periférico, mediante la secuenciación del ADN de la muestra.Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https: //www.labopat.mx/estudio/panel-para-leucodistrofias-y-leucoencefalopatia-genetica",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo. Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: AARS, AARS2, ABAT, ABCA1, ABCD1, ABCD4, ABHD5, ACADS, ACBD5, ACER3, ACO2, ACOX1, ACP5, ACSF3, ACTA2, ACTB, ACY1, ADAR, ADGRG1, ADK, ADNP, ADSL, AGA, AHDC1, AHI1, AIFM1, AIMP1, AIMP2, ALDH18A1, ALDH3A2, ALDH5A1, ALDH6A1, ALG12, ALG13, ALG2, ALG6, ALG9, AMACR, AMPD2, AMT, ANK3, AP1S2, AP3B2, AP4B1, AP4E1, AP4M1, AP4S1, AP5Z1, APC2, APOPT1, ARCN1, ARFGEF2, ARHGAP31, ARHGEF9, ARNT2, ARSA, ARX, ASL, ASNS, ASPA, ASS1, ASXL1, ASXL2, ATP13A2, ATP5A1, ATP6AP2, ATP6V1A, ATP7A, ATP7B, ATP8A2, ATPAF2, ATRN, ATRX, AUH, B3GALNT2, B4GALNT1, BCAP31, BCAT2, BCKDHA, BCKDHB, BCL11B, BCS1L, BICD2, BMP4, BOLA3, BPTF, BRAT1, BTD, C12ORF57, C12ORF65, C19ORF12, C2CD3, CACNA1A, CACNA1E, CARS2, CBS, CC2D2A, CCDC88A, CDC42, CDKL5, CEP290, CHMP1A, CLCN2, CLCN4, CLCN7, CLN2 (TPP1), CLN3, CLN5, CLN6, CLN8, CLP1, CLPP, CNNM2, CNOT1, CNTNAP1, CNTNAP2, COA7, COASY, COG7, COL18A1, COL3A1, COL4A1, COL4A2, COLGALT1, COQ2, COQ6, COQ7, COQ8A, COQ9, COX10, COX14, COX15, COX20, COX6B1, COX7B, COX8A, CPLANE1, CPLX1, CPS1, CRAT, CREBBP, CRIPT, CRLF1, CSF1R, CSPP1, CTBP1, CTC1, CTDP1, CTNS, CTSA, CTSD, CUL4B, CYB5R3, CYFIP2, CYP27A1, CYP2U1, CYP7B1, D2HGDH, DAG1, DARS, DARS2, DBT, DCAF17, DCX, DDC, DDHD1, DDHD2, DDOST, DDX3X, DEAF1, DEGS1, DGUOK, DHCR24, DHFR, DHX37, DLD, DLL4, DMXL2, DNM1L, DNM2, DOCK6, DOCK7, DOLK, DONSON, DPAGT1, DPM1, DPM2, DPM3, DPYS, DYRK1A, EARS2, EDNRB, EHMT1, EIF2AK1, EIF2AK2, EIF2B1, EIF2B2, EIF2B3, EIF2B4, EIF2B5, ELOVL1, ELOVL4, ENTPD1, EOGT, EPG5, EPRS, ERCC1, ERCC2, ERCC3, ERCC6, ERCC8, ETFA, ETFB, ETFDH, ETHE1, EXOSC2, EXOSC3, EXOSC8, EXOSC9, FA2H, FAM126A, FAR1, FARS2, FARSB, FASTKD2, FBXL4, FDX2, FGFRL1, FH, FIG4, FKRP, FKTN, FLVCR2, FOLR1, FOXC1, FOXG1, FOXRED1, FUCA1, FUK, GAA, GABBR2, GABRA1, GABRB1, GABRB2, GABRB3, GALC, GALT, GAN, GATAD2B, GCDH, GDAP1, GFAP, GFM1, GFM2, GJA1, GJB1, GJC2, GLA, GLB1, GLDC, GLRX5, GLUL, GLYCTK, GM2A, GMNN, GNAO1, GNS, GOT2, GPHN, GRIN1, GRM7, GTF2H5, GTPBP2, HACE1, HCN1, HEPACAM, HERC1, HEXA, HEXB, HIBCH, HIKESHI, HK1, HLCS, HMGCL, HNRNPU, HSD17B10, HSD17B4, HSPD1, IARS, IARS2, IBA57, IDH2, IDS, IDUA, IER3IP1, IFIH1, INPP5E, IREB2, ISCA1, ISCA2, ITPA, ITPR1, IVD, JAM3, KARS, KAT6B, KATNB1, KCNJ10, KCNJ2, KCNMA1, KCNT1, KCTD7, KDM1A, KIAA0556, KIAA0586, KIAA0753, KIDINS220, KIF1A, KIF1C, KLHL7, KMT2E, L2HGDH, LAGE3, LAMA1, LAMA2, LAMB1, LARGE1, LARS2, LETM1, LIAS, LIPT1, LIPT2, LONP1, LRPPRC, LYRM7, MAG, MAGEL2, MAN2B1, MANBA, MARS2, MAST1, MAT1A, MCCC1, MCCC2, MCOLN1, MDH2, MECP2, MED17, MED25, MEF2C, MFSD2A, MFSD8, MGP, MICU1, MKS1, MLC1, MLYCD, MMACHC, MMADHC, MOCS1, MOCS2, MOGS, MORC2, MPLKIP, MPV17, MPZ, MRPL12, MRPL44, MRPS16, MRPS22, MRPS34, MSTO1, MTFMT, MTHFR, MTHFS, MTO1, MTOR, MTR, MTRR, MUT, NACC1, NADK2, NAGA, NAGLU, NAGS, NANS, NARS2, NAXD, NAXE, NDRG1, NDUFA1, NDUFA10, NDUFA11, NDUFA12, NDUFA13, NDUFA2, NDUFA4, NDUFA6, NDUFA9, NDUFAF1, NDUFAF2, NDUFAF3, NDUFAF4, NDUFAF5, NDUFAF6, NDUFB10, NDUFB11, NDUFB3, NDUFB8, NDUFB9, NDUFS1, NDUFS2, NDUFS3, NDUFS4, NDUFS6, NDUFS7, NDUFS8, NDUFV1, NDUFV2, NEK1, NFE2L2, NFU1, NGLY1, NKX6-2, NOTCH1, NPC1, NPC2, NPHP1, NRXN1, NSUN3, NT5C2, NTRK2, NUBPL, NUP62, OAT, OCRL, OPA1, OPA3, OSGEP, OTC, PACS1, PAFAH1B1, PAH, PANK2, PARS2, PAX1, PC, PCCA, PCCB, PCDH12, PCGF2, PDGFRB, PDHA1, PDHB, PDHX, PDP1, PET100, PEX1, PEX10, PEX11B, PEX12, PEX13, PEX14, PEX16, PEX19, PEX2, PEX26, PEX3, PEX5, PEX6, PEX7, PGAP1, PGK1, PHGDH, PHYH, PIGA, PIGB, PIGG, PIGL, PIGM, PIGN, PIGP, PIGQ, PIGT, PIGU, PIGV, PIK3C2A, PIK3R2, PLA2G6, PLAA, PLEKHG2, PLP1, PMM2, PMP22, PNKP, PNPT1, POLG, POLG2, POLR1A, POLR1C, POLR3A, POLR3B, POMGNT1, POMK, POMT1, POMT2, PPP1R15B, PPP2R1A, PPP3CA, PPT1, PRF1, PRKDC, PRODH, PROSC, PRPS1, PRUNE1, PSAP, PSAT1, PSPH, PTEN, PTPN23, PURA, PUS3, PYCR2, QARS, QRSL1, RAB11B, RAB3GAP1, RAB3GAP2, RARS, RARS2, RBPJ, REPS1, RERE, RHOBTB2, RIN2, RMND1, RNASEH2A, RNASEH2B, RNASEH2C, RNASET2, RPGRIP1L, RPIA, RPS6KC1, RRM2B, RTTN, RXYLT1, SAMD9L, SAMHD1, SCN3A, SCO1, SCO2, SDHA, SDHAF1, SDHB, SDHD, SEPSECS, SERAC1, SETBP1, SGSH, SH3TC2, SHOC2, SHPK, SLC12A2, SLC12A5, SLC12A6, SLC13A3, SLC13A5, SLC16A2, SLC17A5, SLC19A3, SLC1A2, SLC1A3, SLC1A4, SLC25A1, SLC25A12, SLC25A15, SLC25A19, SLC25A22, SLC25A4, SLC25A42, SLC25A46, SLC2A1, SLC30A10, SLC33A1, SLC35A2, SLC39A14, SLC39A8, SLC46A1, SLC6A19, SLC6A8, SLC6A9, SLC9A1, SLC9A6, SMC1A, SNAP29, SNIP1, SNORD118, SNRPB, SNX14, SOD1, SON, SOX10, SOX2, SPART, SPAST, SPATA5, SPG11, SPG7, SPTAN1, SQSTM1, SRD5A3, SSR4, ST3GAL5, STAG2, STAMBP, STAT1, STAT2, STN1, STRADA, STX11, STXBP1, STXBP2, SUCLA2, SUCLG1, SUMF1, SUOX, SURF1, SYNE1, SYNJ1, TACO1, TAF2, TANGO2, TARS2, TBC1D24, TBCD, TBCE, TBCK, TBX1, TCF4, TCTN2, TIMM50, TIMMDC1, TM4SF20, TMEM106B, TMEM126B, TMEM165, TMEM216, TMEM67, TMEM70, TMTC3, TOE1, TP53RK, TPI1, TPK1, TRAPPC11, TRAPPC9, TREX1, TRMT10A, TRMT5, TSC1, TSC2, TSEN54, TTC19, TUBA1A, TUBA8, TUBB2A, TUBB2B, TUBB3, TUBB4A, TUBG1, TUFM, TWNK, TXN2, TYMP, UBA5, UBE2A, UBE3A, UFM1, UNC13D, UPB1, USP7, VARS2, VPS11, VPS13D, VPS33A, WARS2, WDR45, WDR73, WHSC1, WWOX, YARS, YME1L1, ZEB2, ZFYVE26, ZIC1, ZNF335, ALDH7A1, APP, CHMP2B, CP, CTSF, DNAJC5, DNMT1, FTL, GBE1, GRN, HTRA1, KIAA1161, KIF5A, LMNB1, MAPT, NOTCH3, PDGFB, PDGFRB, PDYN, PHAX, PINK1, PRNP, PSEN1, RNF216, SCP2, SLC20A2, TREM2, TYROBP, VCP, VPS13A, XK, XPR1.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },
  "panel-para-macrocefalia-y-sobrecrecimiento": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para macrocefalia y sobrecrecimiento",
    description:
      "Está prueba genética analiza alteraciones en 26 genes asociados con los síndromes de sobrecrecimiento y macrocefalia, que se caracterizan por un sobrecrecimiento extremo (> 2 desviaciones estándar) en peso y/o longitud, mediante técnicas de secuenciación del ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https: //www.labopat.mx/estudio/panel-para-macrocefalia-y-sobrecrecimiento",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo.  Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: AKT2, AKT3, CDKN1C, CUL4B, DIS3L2, DNMT3A, EZH2, GLI3, GPC3, KPTN, MED12, MTOR, NF1, NFIX, NPR2, NSD1, PHF6, PIK3R2, PTEN, SETD2, SPRED1, DICER1, EED, PDGFRB, RNF125, UPF3B.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },
  "panel-para-neuropatias-(111-genes)": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para neuropatias (111 genes)",
    description:
      "Está prueba genética analiza alteraciones en 111 genes asociados con diversas neuropatías hereditarias incluidas, entre otras, la enfermedad de Charcot-Marie-Tooth, la neuropatía motora distal hereditaria y la neuropatía autonómica sensorial hereditaria, mediante técnicas de secuenciación del ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https: //www.labopat.mx/estudio/panel-para-neuropatias-(111-genes)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo.  Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: AARS, AIFM1, APOA1, ASAH1, ATL1, ATL3, ATP1A1, ATP7A, BAG3, BICD2, BSCL2, CHCHD10, COX6A1, CYP27A1, CYP7B1, DCTN1, DHTKD1, DNAJB2, DNM2, DNMT1, DRP2, DST, DYNC1H1, EGR2, ELP1, EXOSC9, FBLN5, FBXO38, FGD4, FIG4, GAN, GARS, GDAP1, GJB1, GLA, GNB4, GSN, HARS, HEXA, HINT1, HMBS, HSPB1, HSPB8, IGHMBP2, INF2, KIF1A, KIF5A, LITAF, LMNA, LRSAM1, MARS, MCM3AP, MED25, MFN2, MME, MORC2, MPZ, MTMR2, NDRG1, NEFH, NEFL, NGF, NTRK1, PDK3, PLEKHG5, PMP2, PMP22, POLG, POLG2, PRDM12, PRPS1, PRX, RAB7A, REEP1, RETREG1, SBF1, SBF2, SCN11A, SCN9A, SEPT9, SH3TC2, SIGMAR1, SLC12A6, SLC25A46, SLC52A2, SLC52A3, SLC5A7, SMN1, SMN2, SPG11, SPTLC1, SPTLC2, SURF1, TFG, TRIM2, TRPV4, TTR, UBA1, VAPB, VRK1, WNK1, YARS, ARHGEF10, CCT5, HSPB3, LAS1L, MICAL1, SCN10A, SGPL1, SLC25A21, SLC52A1.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },
  "panel-para-trastornos-relacionados-al-hierro": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel para trastornos relacionados al Hierro",
    description:
      "Está prueba genética analiza alteraciones en 27 genes asociados con los trastornos hereditarios del metabolismo y el transporte del hierro (se caracterizan por la acumulación de hierro dentro del cuerpo), incluidos, entre otros, la hemocromatosis hereditaria, la anemia sideroblástica congénita, la protoporfiria eritropoyética y otras anemias hereditarias que implican una sobrecarga de hierro, mediante técnicas de secuenciación del ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https: //www.labopat.mx/estudio/panel-para-trastornos-relacionados-al-hierro",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo.  Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: ABCB7, ALAS2, ATP4A, ATP7B, CP, FECH, FTH1, FTL, GLRX5, HAMP, HFE, HJV, LARS2, NDUFB11, PUS1, SLC11A2, SLC19A2, SLC25A38, SLC40A1, SLC46A1, STEAP3, TF, TFR2, TFRC, TMPRSS6, TRNT1, YARS2.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "14000 MXN",
      },
    ],
  },
  "panel-trastornos-mieloides-axiona-heme": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Panel trastornos mieloides Axiona HEME",
    description:
      "Prueba genética para detectar alteraciones en 45 genes y más de 700 fusiones génicas asociados con trastornos mieloides como AML, MDS, MPN, CMML y JMML, mediante la secuenciación del ADN de la muestra.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/panel-trastornos-mieloides-axiona-heme",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "15 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Sangre o aspirado de médula ósea.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "6 horas de ayuno previas a la recolección de sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "ASXL1, KIT, SMC1A, TET2, MYH11, ABL1, KRAS, BCOR, TP53, NTRK3, BRAF, MPL, CALR, ZRSR, NUP214, CBL, MYD88, CEBPA, FGFR1, PDGFRA, CSF3R, NPM1, ETV6, FGFR2, NUP88, DNMT3A, PPM1D, EZH2, FUS, PDGFRB, FLT3, SETBP1B, IKZF1, HMGA2, RAR, GATA2, SF3B1, NF1, JAK2, RBM15, HRAS, SRSF2, PHF6, KMT2A, TRIM27, DDX41, U2AF1, PRPF8, MECOM, TCF3, ANKRD26, WT1, RB1, MET, TFE3, IDH1, NRAS, RUNX1, MLLT10, BAALC, IDH2, PTPN11, SH2B3, MLLT3, MYC, JAK2, SMC3, STAG2, MYBL1, SMC1A, PUM1, EIF2B1, FBXW2, PSMB2, WT1",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "50000 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "50000 MXN",
      },
    ],
  },
  "prueba-de-exoma": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Prueba de exoma",
    description:
      "Es un análisis personalizado del exoma humano basado en una combinación de la presentación clínica del paciente y las variantes encontradas dentro de su exoma, mediante la secuenciación del ADN de la muestra. Metodología: Secuenciación de última generación (NGS).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https: //www.labopat.mx/estudio/prueba-de-exoma",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva o sangre.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Para recolección de saliva: 45 minutos sin haber ingerido alimentos, 2 horas sin haber tomado agua, fumado ni cepillado los dientes. Para recolección de sangre: 6 horas de ayuno previo. Nota: Estudio disponible únicamente para pago en sucursal. El precio indicado es un aproximado y puede variar según el tipo de cambio al día.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Analito: EXOMA",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "33500 MXN",
      },
    ],
  },
  "prueba-para-nutricion-personalizada-vg-70": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Prueba para nutrición personalizada VG 70 con envio",
    description:
      "Prueba genética para nutrición personalizada y condición física (Versión completa), analiza 70 variantes en 63 genes implicados en el metabolismo de nutrimentos,salud cardiometabólica, control de peso y composición corporal, intolerancia alimentaria, ejercicio y salud física, incluye apartado de genetic insights y modalidades de interpretación. *La prueba incluye una sesión de interpretación de resultados personalizada (30-40 min).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https: //www.labopat.mx/estudio/prueba-para-nutricion-personalizada-vg-70",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 a 4 semanas.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Saliva.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Se requiere que el paciente no haya ingerido alimentos, bebidas, mascado chicle, fumado o usado higiene bucal en los últimos 30 minutos de recolección de saliva.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "BCMO1, FUT2, GSTT1, CYP2R1, GC, COMT, MTHFR, MTHFD1, PEMT, SLC17A1, HFE, TMPRSS6, TFR2, TF, MCM6, HLA, ADORA2A, CYP1A2, TCF7L2, ACE, FADS1, LIPC, FTO, ADRB2, UCP1, APOA2, PPARy2, BDNF, CYP19A1, LEPR, ACTN3, NFIA-AS2, ADRB3, NRF2, GSTP1, PGC1a, WNT16, COL5A1.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "6250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "6250 MXN",
      },
    ],
  },
  "secuenciacion-tumoral-axiona-solid": {
    "@context": "https://schema.org",
    "@type": "GeneticTest",
    name: "Secuenciación tumoral Axiona SOLID",
    description:
      "El panel para tumores sólidos de Axiona incluye el estudio de 50 genes por secuenciación de próxima generación (NGS) lo cual permite la detección de variantes relevantes para tumores sólidos en estos biomarcadores. Este ensayo permite el análisis concurrente de ADN y ARN para detectar simultáneamente múltiples tipos de variantes, incluidos hotspots, variantes de un solo nucleótido (SNV), indels, variantes de número de copias (CNV) y fusiones.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/secuenciacion-tumoral-axiona-solid",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "15 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Tejido tumoral fijado en formalina y embebido en parafina (FFPE).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "SEntregar bloque de parafina en buenas condiciones (no derretido, tejido no expuesto, etc.). La muestra debe cumplir con las siguientes caracretísticas: -Mínimo 30% de celularidad -Sin necrosis y sin mucina -El tejido debe estar preservado sin cambios por autolisis -Volumen mínimo de 2.0 – 2.5 cm3.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value:
          "Genes analizados: AKT1, AKT2, AKT3, ALK, AR, ARAF, BRAF, CD274, CDK4, CDKN2A, CHEK2, CTNNB1, EGFR, ERBB2, ERBB3, ERBB4, ESR1, FGFR1, FGFR2, FGFR3, FGFR4, FLT3, GNA11, GNAQ, GNAS, HRAS, IDH1, IDH2, KIT, KRAS, MAP2K1, MAP2K2, MET, MTOR, NRAS, NRG1, NTRK1, NTRK2, NTRK3, NUTM1, PDGFRA, PIK3CA, PTEN, RAF1, RET, ROS1, RSPO2, RSPO3, SMO, TP53.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "38000 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "38000 MXN",
      },
    ],
  },
  "rx-abdomen-de-pie-y-decubito": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ABDOMEN DE PIE Y DECUBITO",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-abdomen-de-pie-y-decubito",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-abdomen-una-posicion": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ABDOMEN UNA POSICIÓN",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-abdomen-una-posicion",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-antebrazo-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ANTEBRAZO ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-antebrazo-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-antebrazo-anteroposterior-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ANTEBRAZO ANTEROPOSTERIOR COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-antebrazo-anteroposterior-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },

  "rx-antebrazo-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ANTEBRAZO ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-antebrazo-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },

  "rx-antebrazo-anteroposterior-y-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ANTEBRAZO ANTEROPOSTERIOR Y OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-antebrazo-anteroposterior-y-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-antebrazo-comparativos-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ANTEBRAZO COMPARATIVOS ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-antebrazo-comparativos-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-antebrazo-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ANTEBRAZO LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-antebrazo-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-antebrazo-lateral-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ANTEBRAZO LATERAL COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-antebrazo-lateral-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },

  "rx-ap-axial-de-rodillas-para-escotadura-intercondilea": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX AP AXIAL DE RODILLAS PARA ESCOTADURA INTERCONDILEA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-ap-axial-de-rodillas-para-escotadura-intercondilea",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-articulacion-sacro-iliacas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ARTICULACIÓN SACRO-ILÍACAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-articulacion-sacro-iliacas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-cadera-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CADERA ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-cadera-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-cadera-anteroposterior-y-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CADERA ANTEROPOSTERIOR Y OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-cadera-anteroposterior-y-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },

  "rx-cadera-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CADERA OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-cadera-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-calcaneo-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CALCANEO ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-calcaneo-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-calcaneo-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CALCANEO ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-calcaneo-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },

  "rx-calcaneo-anteroposterior-y-lateral-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CALCANEO ANTEROPOSTERIOR Y LATERAL COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-calcaneo-anteroposterior-y-lateral-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },

  "rx-calcaneo-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CALCANEO LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-calcaneo-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-clavicula-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CLAVÍCULA ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-clavicula-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-clavicula-anteroposterior-y-oblicuas-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CLAVÍCULA ANTEROPOSTERIOR Y OBLICUAS COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-clavicula-anteroposterior-y-oblicuas-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-clavicula-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CLAVÍCULA OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-clavicula-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-codo-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CODO ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-codo-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-codo-anteroposterior-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CODO ANTEROPOSTERIOR COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-codo-anteroposterior-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-codo-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CODO ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-codo-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-codo-anteroposterior-y-lateral-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CODO ANTEROPOSTERIOR Y LATERAL COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-codo-anteroposterior-y-lateral-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-codo-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CODO LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-codo-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-columna-cervical-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA CERVICAL ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-cervical-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-columna-cervical-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA CERVICAL ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-cervical-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-columna-cervical-anteroposterior,-lateral-y-dinamicas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA CERVICAL ANTEROPOSTERIOR, LATERAL Y DINÁMICAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-cervical-anteroposterior,-lateral-y-dinamicas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-columna-cervical-anteroposterior,-lateral-y-oblicuas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA CERVICAL ANTEROPOSTERIOR, LATERAL Y OBLICUAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-cervical-anteroposterior,-lateral-y-oblicuas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-columna-cervical-anteroposterior,-lateral,-oblicuas-y-dinamicas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA CERVICAL ANTEROPOSTERIOR, LATERAL, OBLICUAS Y DINÁMICAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-cervical-anteroposterior,-lateral,-oblicuas-y-dinamicas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3150 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "2854 MXN",
      },
    ],
  },

  "rx-columna-cervical-dinamicas-(flexion-y-extension)": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA CERVICAL DINAMICAS (FLEXIÓN Y EXTENSIÓN)",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-cervical-dinamicas-(flexion-y-extension)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-columna-cervical-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA CERVICAL LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-cervical-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-columna-cervical-oblicuas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA CERVICAL OBLICUAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-cervical-oblicuas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-columna-dorsal-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA DORSAL ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-dorsal-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-columna-dorsal-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA DORSAL ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-dorsal-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-columna-dorsal-anteroposterior-y-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA DORSAL ANTEROPOSTERIOR Y OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-dorsal-anteroposterior-y-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-columna-dorsal-anteroposterior,-lateral-y-oblicuas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA DORSAL ANTEROPOSTERIOR, LATERAL Y OBLICUAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-dorsal-anteroposterior,-lateral-y-oblicuas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-columna-dorsal-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA DORSAL LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-dorsal-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-columna-dorsal-oblicuas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA DORSAL OBLICUAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-dorsal-oblicuas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-columna-lumbo-sacra-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA LUMBO-SACRA ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-lumbo-sacra-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-columna-lumbo-sacra-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA LUMBO-SACRA ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-lumbo-sacra-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-columna-lumbo-sacra-anteroposterior,-lateral-y-oblicuas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA LUMBO-SACRA ANTEROPOSTERIOR, LATERAL Y OBLICUAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-lumbo-sacra-anteroposterior,-lateral-y-oblicuas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-columna-lumbo-sacra-anteroposterior,-lateral,-oblicuas-y-dinamicas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA LUMBO-SACRA ANTEROPOSTERIOR, LATERAL, OBLICUAS Y DINÁMICAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-lumbo-sacra-anteroposterior,-lateral,-oblicuas-y-dinamicas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3150 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "2845 MXN",
      },
    ],
  },
  "rx-columna-lumbo-sacra-dinamicas-flexion-y-extension": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA LUMBO-SACRA DINAMICAS FLEXIÓN Y EXTENSIÓN",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-lumbo-sacra-dinamicas-flexion-y-extension",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-columna-lumbo-sacra-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA LUMBO-SACRA LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-lumbo-sacra-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-columna-lumbo-sacra-oblicuas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA LUMBO-SACRA OBLICUAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-lumbo-sacra-oblicuas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-columna-sacrocoxigea-anteroposterior-(1-coxis)": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA SACROCOXÍGEA ANTEROPOSTERIOR (1 COXIS)",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-sacrocoxigea-anteroposterior-(1-coxis)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-columna-sacrocoxigea-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA SACROCOXÍGEA ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-sacrocoxigea-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-columna-sacrocoxigea-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX COLUMNA SACROCOXÍGEA LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-columna-sacrocoxigea-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-craneo-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CRÁNEO ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-craneo-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-craneo-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CRÁNEO ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-craneo-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-craneo-anteroposterior,-lateral,-towne": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CRÁNEO ANTEROPOSTERIOR, LATERAL, TOWNE",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-craneo-anteroposterior,-lateral,-towne",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-craneo-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CRÁNEO LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-craneo-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-craneo-submento-vertex": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX CRÁNEO SUBMENTO VERTEX",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-craneo-submento-vertex",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-dedo-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX DEDO ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-dedo-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-dedo-anteroposterior,-latral-y-oblicuo": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX DEDO ANTEROPOSTERIOR, LATRAL Y OBLICUO",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-dedo-anteroposterior,-latral-y-oblicuo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-dedo-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX DEDO LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-dedo-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-dedo-oblicuo": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX DEDO OBLICUO",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-dedo-oblicuo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-dedo-posteroanterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX DEDO POSTEROANTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-dedo-posteroanterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-edad-osea-(mano,-codo,-cadera-y-rodilla)": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX EDAD OSEA (MANO, CODO, CADERA Y RODILLA)",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-edad-osea-(mano,-codo,-cadera-y-rodilla)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-edad-osea-(mano,-codo,-cadera,-rodilla-y-pie)": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX EDAD OSEA (MANO, CODO, CADERA, RODILLA Y PIE)",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-edad-osea-(mano,-codo,-cadera,-rodilla-y-pie)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2500 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "2250 MXN",
      },
    ],
  },
  "rx-edad-osea-(mano,-codo,-cadera)": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX EDAD OSEA (MANO, CODO, CADERA)",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-edad-osea-(mano,-codo,-cadera)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-edad-osea-(rodilla-y-pie)": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX EDAD OSEA (RODILLA Y PIE)",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-edad-osea-(rodilla-y-pie)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },

  "rx-edad-osea-mano": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX EDAD OSEA MANO",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-edad-osea-mano",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-escapula-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ESCÁPULA ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-escapula-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-escapula-anteroposterior-y-en-y-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ESCÁPULA ANTEROPOSTERIOR Y EN Y COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-escapula-anteroposterior-y-en-y-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-escapula-anteroposterior-y-en-y-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ESCÁPULA ANTEROPOSTERIOR Y EN Y COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-escapula-anteroposterior-y-en-y-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-escapula-en-y": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ESCÁPULA EN Y",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-escapula-en-y",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-esternon-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ESTERNÓN ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-esternon-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-esternon-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ESTERNÓN ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-esternon-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-esternon-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX ESTERNÓN LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-esternon-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-femur-anteposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX FÉMUR ANTEPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-femur-anteposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-femur-anteroposterior-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX FÉMUR ANTEROPOSTERIOR COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-femur-anteroposterior-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-femur-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX FÉMUR ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-femur-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-femur-anteroposterior-y-lateral-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX FÉMUR ANTEROPOSTERIOR Y LATERAL COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-femur-anteroposterior-y-lateral-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-femur-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX FÉMUR LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-femur-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-hombro-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HOMBRO ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-hombro-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-hombro-anteroposterior-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HOMBRO ANTEROPOSTERIOR COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-hombro-anteroposterior-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-hombro-anteroposterior-verdadera": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HOMBRO ANTEROPOSTERIOR VERDADERA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-hombro-anteroposterior-verdadera",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-hombro-anteroposterior-y-lateral-transtoracica": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HOMBRO ANTEROPOSTERIOR Y LATERAL TRANSTORACICA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-hombro-anteroposterior-y-lateral-transtoracica",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-hombro-anteroposterior-y-lateral-transtoracica-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HOMBRO ANTEROPOSTERIOR Y LATERAL TRANSTORACICA COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-hombro-anteroposterior-y-lateral-transtoracica-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-hombro-lateral-transtoracica": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HOMBRO LATERAL TRANSTORACICA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-hombro-lateral-transtoracica",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-hombro-lateral-transtoracica-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HOMBRO LATERAL TRANSTORACICA COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-hombro-lateral-transtoracica-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-humero-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HÚMERO ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-humero-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-humero-anteroposterior-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HÚMERO ANTEROPOSTERIOR COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-humero-anteroposterior-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-humero-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HÚMERO ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-humero-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-humero-anteroposterior-y-lateral-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HÚMERO ANTEROPOSTERIOR Y LATERAL COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-humero-anteroposterior-y-lateral-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },
  "rx-humero-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HÚMERO LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-humero-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-humero-lateral-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX HÚMERO LATERAL COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-humero-lateral-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-mano-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MANO LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-mano-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-mano-lateral-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MANO LATERAL COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-mano-lateral-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-mano-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MANO OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-mano-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-mano-posteroanterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MANO POSTEROANTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-mano-posteroanterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-mano-posteroanterior-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MANO POSTEROANTERIOR COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/https://www.labopat.mx/estudio/rx-mano-posteroanterior-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-mano-posteroanterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MANO POSTEROANTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-mano-posteroanterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-mano-posteroanterior-y-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MANO POSTEROANTERIOR Y OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-mano-posteroanterior-y-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-mano-posteroanterior,-lateral-y-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MANO POSTEROANTERIOR, LATERAL Y OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-mano-posteroanterior,-lateral-y-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-mano-posteroanterior,-lateral-y-oblicua-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MANO POSTEROANTERIOR, LATERAL Y OBLICUA COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-mano-posteroanterior,-lateral-y-oblicua-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-manos-posteroanterior-y-lateral-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MANOS POSTEROANTERIOR Y LATERAL COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-manos-posteroanterior-y-lateral-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-manos-posteroanterior-y-oblicuas-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MANOS POSTEROANTERIOR Y OBLICUAS COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-manos-posteroanterior-y-oblicuas-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-medicion-de-miembros-inferiores": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MEDICIÓN DE MIEMBROS INFERIORES",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-medicion-de-miembros-inferiores",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-muneca-anteroposterior-y-lateral-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MUÑECA ANTEROPOSTERIOR Y LATERAL COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-muneca-anteroposterior-y-lateral-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-muneca-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MUÑECA LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-muneca-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-muneca-lateral-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MUÑECA LATERAL COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-muneca-lateral-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-muneca-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MUÑECA OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-muneca-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-muneca-posteroanterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MUÑECA POSTEROANTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-muneca-posteroanterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-muneca-posteroanterior-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MUÑECA POSTEROANTERIOR COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-muneca-posteroanterior-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-muneca-posteroanterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MUÑECA POSTEROANTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-muneca-posteroanterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-muneca-posteroanterior-y-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX MUÑECA POSTEROANTERIOR Y OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-muneca-posteroanterior-y-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-pelvis-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PELVIS ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pelvis-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-pelvis-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PELVIS ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pelvis-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-pelvis-anteroposterior-y-lowenstein-(rana)": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PELVIS ANTEROPOSTERIOR Y LOWENSTEIN (RANA)",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pelvis-anteroposterior-y-lowenstein-(rana)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-pelvis-anteroposterior-y-oblicuas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PELVIS ANTEROPOSTERIOR Y OBLICUAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pelvis-anteroposterior-y-oblicuas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-pelvis-anteroposterior,-lateral-y-oblicuas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PELVIS ANTEROPOSTERIOR, LATERAL Y OBLICUAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pelvis-anteroposterior,-lateral-y-oblicuas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },

  "rx-pelvis-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PELVIS LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pelvis-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-pelvis-lowenstein-(rana)": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PELVIS LOWENSTEIN (RANA)",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pelvis-lowenstein-(rana)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-pelvis-von-rosen": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PELVIS VON ROSEN",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pelvis-von-rosen",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-perfilograma": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PERFILOGRAMA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-perfilograma",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-perfilograma-y-waters": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PERFILOGRAMA Y WATERS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-perfilograma-y-waters",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-pie-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIE ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pie-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-pie-anteroposterior-,lateral-y-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIE ANTEROPOSTERIOR ,LATERAL Y OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pie-anteroposterior-,lateral-y-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-pie-anteroposterior-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIE ANTEROPOSTERIOR COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pie-anteroposterior-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-pie-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIE ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pie-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-pie-anteroposterior-y-lateral-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIE ANTEROPOSTERIOR Y LATERAL COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pie-anteroposterior-y-lateral-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-pie-anteroposterior-y-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIE ANTEROPOSTERIOR Y OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pie-anteroposterior-y-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-pie-anteroposterior-y-oblicuas-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIE ANTEROPOSTERIOR Y OBLICUAS COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pie-anteroposterior-y-oblicuas-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-pie-anteroposterior,-lateral-y-oblicua-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIE ANTEROPOSTERIOR, LATERAL Y OBLICUA COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pie-anteroposterior,-lateral-y-oblicua-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2500 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "2250 MXN",
      },
    ],
  },

  "rx-pie-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIE LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pie-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-pie-lateral-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIE LATERAL COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pie-lateral-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-pie-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIE OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pie-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-pie-sesamoideos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIE SESAMOIDEOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pie-sesamoideos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-pierna-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIERNA ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pierna-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-pierna-anteroposterior-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIERNA ANTEROPOSTERIOR COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pierna-anteroposterior-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-pierna-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIERNA ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pierna-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },

  "rx-pierna-anteroposterior-y-lateral-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIERNA ANTEROPOSTERIOR Y LATERAL COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pierna-anteroposterior-y-lateral-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },

  "rx-pierna-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX PIERNA LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-pierna-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-rodilla-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX RODILLA ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-rodilla-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-rodilla-anteroposterior-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX RODILLA ANTEROPOSTERIOR COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-rodilla-anteroposterior-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-rodilla-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX RODILLA ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-rodilla-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-rodilla-anteroposterior-y-lateral-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX RODILLA ANTEROPOSTERIOR Y LATERAL COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-rodilla-anteroposterior-y-lateral-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1900 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1720 MXN",
      },
    ],
  },

  "rx-rodilla-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX RODILLA LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-rodilla-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-rodilla-lateral-comparativas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX RODILLA LATERAL COMPARATIVAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-rodilla-lateral-comparativas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-rodilla-merchan-comparativas-(45%20)": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX RODILLA MERCHAN COMPARATIVAS (45°)",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-rodilla-merchan-comparativas-(45%20)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-rodillas-tangencial": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX RODILLAS TANGENCIAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-rodillas-tangencial",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-rodillas-tangencial-(30,-60-y-90-grados)": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX RODILLAS TANGENCIAL (30, 60 Y 90 GRADOS)",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-rodillas-tangencial-(30,-60-y-90-grados)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-senos-paranasales-waters": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX SENOS PARANASALES WATERS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-senos-paranasales-waters",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-senos-paranasales-waters-y-caldwell": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX SENOS PARANASALES WATERS Y CALDWELL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-senos-paranasales-waters-y-caldwell",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },

  "rx-senos-paranasales-waters,-caldwell-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX SENOS PARANASALES WATERS, CALDWELL Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-senos-paranasales-waters,-caldwell-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-serie-metastasica": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX SERIE METASTÁSICA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-serie-metastasica",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "4700 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "4235 MXN",
      },
    ],
  },
  "rx-serie-osea-displasias": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX SERIE OSEA DISPLASIAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-serie-osea-displasias",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "4700 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "4235 MXN",
      },
    ],
  },
  "rx-serie-osea-metabolica": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX SERIE ÓSEA METABÓLICA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-serie-osea-metabolica",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3150 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "2845 MXN",
      },
    ],
  },
  "rx-serie-osea-reumatica": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX SERIE OSEA REUMÁTICA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-serie-osea-reumatica",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3070 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "2765 MXN",
      },
    ],
  },
  "rx-tele-de-torax-posteroanterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX TELE DE TÓRAX POSTEROANTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-tele-de-torax-posteroanterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },

  "rx-tele-de-torax-posteroanterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX TELE DE TÓRAX POSTEROANTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-tele-de-torax-posteroanterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-tobillo-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX TOBILLO ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-tobillo-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-tobillo-anteroposterior-y-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX TOBILLO ANTEROPOSTERIOR Y LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-tobillo-anteroposterior-y-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-tobillo-anteroposterior-y-lateral-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX TOBILLO ANTEROPOSTERIOR Y LATERAL COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-tobillo-anteroposterior-y-lateral-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-tobillo-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX TOBILLO LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-tobillo-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-tobillo-lateral-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX TOBILLO LATERAL COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-tobillo-lateral-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "950 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "860 MXN",
      },
    ],
  },
  "rx-tobillos-anteroposterior-comparativos": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX TOBILLOS ANTEROPOSTERIOR COMPARATIVOS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-tobillos-anteroposterior-comparativos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-torax-lateral": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX TÓRAX LATERAL",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-torax-lateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-torax-oseo-anteroposterior": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX TÓRAX ÓSEO ANTEROPOSTERIOR",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-torax-oseo-anteroposterior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "rx-torax-oseo-anteroposterior-y-oblicuas": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX TÓRAX ÓSEO ANTEROPOSTERIOR Y OBLICUAS",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-torax-oseo-anteroposterior-y-oblicuas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1250 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "1125 MXN",
      },
    ],
  },
  "rx-torax-oseo-oblicua": {
    "@context": "https://schema.org",
    "@type": "ImagingTest",
    name: "RX TÓRAX ÓSEO OBLICUA",
    description: "Imagen tomada por medio de Rayos X para diagnóstico médico.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/rx-torax-oseo-oblicua",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value:
          "Para las tomas de lunes a viernes antes de las 17:00 hrs, los resultados se entregarán el mismo día. Tomas después de las 17:00 hrs al siguiente día. Sábados de 7 a 12 pm mismo día, después de las 12 hrs, los resultados se entregarán al siguiente día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Rayos X.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Retirar objetos de metal.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "570 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "515 MXN",
      },
    ],
  },
  "biopsia-de-endocardio-miocardio-(c)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Biopsia de endocardio-miocardio (C)",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/biopsia-de-endocardio-miocardio-(c)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "citologia-cervico-vaginal-(extendido-en-laminilla)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología cervico vaginal (extendido en laminilla)",
    description: "Evaluación microscópica para detección oportuna de CaCu.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-cervico-vaginal-(extendido-en-laminilla)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Laminilla con extendido exudado cervical previamente fijada en alcohol o solución fijadora en spray.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Tinción técnica de papanicolaou.",
      },
      {
        "@type": "PropertyValue",
        name: "Información",
        value: "Laminilla teñida con técnica de papanicolaou.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "212 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "190.80 MXN",
      },
    ],
  },

  "citologia-cervicovaginal-en-base-liquida-(papanicolaou)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología cervicovaginal en base líquida (papanicolaou)",
    description:
      "Evaluación microscópica del extendido celular en búsqueda intensionada de procesos inflamatorios, infecciosos, tumorales benignos y malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-cervicovaginal-en-base-liquida-(papanicolaou)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 a 3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Laminilla teñida con técnica de papanicolaou.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar muestra con orden médica que contenga: edad, sexo, datos ginecologicos y pequeño resumen clínico.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "400.50 MXN",
      },
    ],
  },

  "citologia-cervicovaginal-en-base-liquida-con-toma-de-muestra-(papanicolaou)":
    {
      "@context": "https://schema.org",
      "@type": "MedicalTest",
      name: "Citología cervicovaginal en base líquida con toma de muestra (papanicolaou)",
      description:
        "Evaluación microscópica para detección oportuna de carcinoma de cuello uterino y descarte de enfermedades infecciosas",
      recognizingAuthority: {
        "@type": "Organization",
        name: "Labopat",
        url: "https://www.labopat.mx/estudio/citologia-cervicovaginal-en-base-liquida-con-toma-de-muestra-(papanicolaou)",
      },
      additionalProperty: [
        {
          "@type": "PropertyValue",
          name: "Tiempo de entrega",
          value: "2 días hábiles.",
        },
        {
          "@type": "PropertyValue",
          name: "Tipo de muestra",
          value: "Laminilla de monocapa teñida con técnica de papanicolaou.",
        },
        {
          "@type": "PropertyValue",
          name: "Indicaciones",
          value:
            "No haber tenido relaciones sexuales las 48 horas anteriores No estar en el período menstrual No haberse realizado duchas vaginales en el lapso de 48 horas antes. No haberse aplicado ningún tratamiento médico vaginal (óvulos o cremas), durante las últimas 48 horas. Vial, proceso en sistema monocapa y tinción técnica de papanicoalou.",
        },
        {
          "@type": "PropertyValue",
          name: "Precio en sucursal",
          value: "689 MXN",
        },
        {
          "@type": "PropertyValue",
          name: "Precio en línea",
          value: "620.10 MXN",
        },
      ],
    },

  "citologia-de-cepillado-de-esofago": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de cepillado de esófago",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-cepillado-de-esofago",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Laminilla fijada en alcohol 96%.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "400 MXN",
      },
    ],
  },

  "citologia-de-cepillado-de-via-biliar": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de cepillado de vía biliar",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-cepillado-de-via-biliar",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Laminilla fijada en alcohol 96%.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "400 MXN",
      },
    ],
  },

  "citologia-de-cepillado-endocervical": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de cepillado endocervical",
    description:
      "Evaluación microscópica del extendido celular en búsqueda intensionada de procesos inflamatorios, infecciosos, tumorales benignos y malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-cepillado-endocervical",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Laminilla con extendido cepillado endocervical previamente fijada en alcohol o solución fijadora en spray; y/o vial con solución fijadora.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "400.50 MXN",
      },
    ],
  },

  "citologia-de-cepillado-y-lavado-bronquial": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de cepillado y lavado bronquial",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-cepillado-y-lavado-bronquial",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Líquido en vaso recolector esteril (125 ml) con solución fijadora y laminilla.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Entregar muestras en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "400.50 MXN",
      },
    ],
  },

  "citologia-de-descarga-de-pezon-bilateral": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de descarga de pezón bilateral",
    description:
      "Evaluación microscópica del extendido celular en búsqueda intencionada de procesos inflamatorios, infecciosos, tumorales benignos y malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-descarga-de-pezon-bilateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Laminilla con extendido exudado descarga pezón previamente fijada en alcohol al 96%.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value: "Entregar muestras en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "650 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en línea",
        value: "585 MXN",
      },
    ],
  },

  "citologia-de-descarga-de-pezon-bilateral-con-toma": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de descarga de pezón bilateral con toma",
    description:
      "Evaluación microscópica del extendido celular en búsqueda intencionada de procesos inflamatorios, infecciosos, tumorales benignos y malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://labopat.mx/estudio/citologia-de-descarga-de-pezon-bilateral-con-toma",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Con baño del día. No colocar talco, cremas y/o loción. No drenar la secreción un día antes.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "850 MXN",
      },
    ],
  },

  "citologia-de-descarga-de-pezon-unilateral": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de descarga de pezón unilateral",
    description:
      "Evaluación microscópica del extendido celular en búsqueda intencionada de procesos inflamatorios, infecciosos, tumorales benignos y malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-descarga-de-pezon-unilateral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Laminilla con extendido exudado descarga pezón previamente fijada en alcohol o solución fijadora en spray.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "400.50 MXN",
      },
    ],
  },

  "citologia-de-descarga-de-pezon-unilateral-con-toma": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de descarga de pezón unilateral con toma",
    description:
      "Evaluación microscópica del extendido celular en búsqueda intencionada de procesos inflamatorios, infecciosos, tumorales benignos y malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-descarga-de-pezon-unilateral-con-toma",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Con baño del día. No colocar talco, cremas y/o loción. No drenar la secreción un día antes.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "450 MXN",
      },
    ],
  },

  "citologia-de-expectoracion": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de expectoración",
    description:
      "Evaluación microscópica del extendido celular o monocapa en búsqueda intencionada de procesos inflamatorios, infecciosos, tumorales benignos y malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-expectoracion",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Líquido en vaso recolector esteril (125 ml) con solución fijadora.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Evitar consumir alimentos o bebidas una hora antes de la toma de muestra. Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "450 MXN",
      },
    ],
  },

  "citologia-de-expectoracion-(2-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de expectoración (2 muestras)",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-expectoracion-(2-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días después de recibida la última muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Líquido en vaso recolector esteril (125 ml) con solución fijadora (Se reciben 2 muestras en dos días consecutivos).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Evitar consumir alimentos o bebidas 1 hora antes de la toma de muestra. Recolectar 2 muestras en 2 días consecutivos.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "835 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "751.50 MXN",
      },
    ],
  },

  "citologia-de-expectoracion-(3-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de expectoración (3 muestras)",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-expectoracion-(3-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días después de recibida la última muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "líquido en vaso recolector esteril (125 ml) con solución fijadora (Se reciben 3 muestras en tres días consecutivos).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Evitar consumir alimentos o bebidas 1 hora antes de la toma de muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1280 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1152 MXN",
      },
    ],
  },

  "citologia-de-liquido-celfalorraquideo": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de líquido celfalorraquídeo",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-liquido-celfalorraquideo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Líquido fijado en alcohol 96%.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "400 MXN",
      },
    ],
  },

  "citologia-de-liquido-de-ascitis": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de líquido de ascitis",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-liquido-de-ascitis",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Líquido de ascitis fijado en alcohol 96%.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "400 MXN",
      },
    ],
  },
  "citologia-de-liquido-pericardico": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de líquido pericárdico",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-liquido-pericardico",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Líquido de pericardio fijado en alcohol 96%.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "400 MXN",
      },
    ],
  },
  "citologia-de-liquido-pleural": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de líquido pleural",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-liquido-pleural",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Líquido pleural fijado en alcohol 96%.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "400 MXN",
      },
    ],
  },
  "citologia-de-liquido-sinovial": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de líquido sinovial",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-liquido-sinovial",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2-3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Líquido fijado en alcohol 96%.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "400 MXN",
      },
    ],
  },
  "citologia-de-orina": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de orina",
    description:
      "Evaluación microscópica del extendido celular en búsqueda intencionada de procesos inflamatorios, infecciosos, tumorales benignos y malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-orina",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Orina en vaso recolector estéril (125 ml) con solución fijadora.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Recolectar una muestra a chorro medio de la primera orina de la mañana en un contenedor estéril.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "400 MXN",
      },
    ],
  },
  "citologia-de-uretra": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología de uretra",
    description:
      "Evaluación microscópica del extendido celular en búsqueda intencionada de procesos inflamatorios, infecciosos, tumorales benignos y malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-de-uretra",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Laminilla o monocapa teñida con hematoxilina-eosina.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar la muestra en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "400.50 MXN",
      },
    ],
  },
  "citologia-en-impronta-de-piel-y-mucosas": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología en impronta de piel y mucosas",
    description:
      "Evaluación microscópica del extendido celular en búsqueda intensionada de procesos inflamatorios e infecciosos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-en-impronta-de-piel-y-mucosas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Laminilla teñida con H-E y tinciones especiales.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "No colocar cremas o médicamentos tópicos en la zona que se desea tomar la muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "400.50 MXN",
      },
    ],
  },
  "citologia-para-morfologia-eritrocitaria": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología para morfología eritrocitaria",
    description: "Evaluación microscópica en fresco búsqueda de eritrocitos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-para-morfologia-eritrocitaria",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "Un día hábil.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Orina en vaso recolector esteril (125 ml) en fresco (sin fijador).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Toma de muestra, en vaso recolector, de la primera orina de la mañana, chorro medio para posterior centrifugación, o en horarios establecidos según los requerimientos del médico tratante.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "445 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "400.50 MXN",
      },
    ],
  },
  "citologia-seriada-de-orina-(2-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología seriada de orina (2 muestras)",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-seriada-de-orina-(2-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días despues de recibida la última muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Orina en vaso recolector esteril (125 ml) con solución fijadora.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Recolectar una muestra a chorro medio de la primera orina de la mañana en un contenedor estéril, durante 2 días consecutivos. Entregar las muestras en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "835 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "751.50 MXN",
      },
    ],
  },

  "citologia-seriada-de-orina-(3-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología seriada de orina (3 muestras)",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-seriada-de-orina-(3-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días después de recibida la última muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Orina en vaso recolector esteril (125 ml) con solución fijadora. (Se recibe 3 muestras en tres días consecutivos).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Recolectar una muestra a chorro medio de la primera orina de la mañana en un contenedor estéril, durante 3 días consecutivos. Entregar las muestras en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1280 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1152 MXN",
      },
    ],
  },

  "citologia-seriada-de-orina-(4-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología seriada de orina (4 muestras)",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-seriada-de-orina-(4-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días después de recibida la última muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Orina en vaso recolector esteril (125 ml) con solución fijadora. (Se recibe 4 muestras en cuatro días consecutivos).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Recolectar una muestra a chorro medio de la primera orina de la mañana en un contenedor estéril, durante 4 días consecutivos. Entregar las muestras en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1670 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1503 MXN",
      },
    ],
  },

  "citologia-seriada-de-orina-(5-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Citología seriada de orina (5 muestras)",
    description:
      "Evaluación microscópica y detección de procesos infecciosos, inflamatorios y neoplásicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/citologia-seriada-de-orina-(5-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días después de recibida la última muestra.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value:
          "Orina en vaso recolector esteril (125 ml) con solución fijadora. (Se recibe 5 muestras en cinco días consecutivos).",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Recolectar una muestra a chorro medio de la primera orina de la mañana en un contenedor estéril, durante 5 días consecutivos. Entregar las muestras en la recepción de la sucursal seleccionada.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1948 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1753.20 MXN",
      },
    ],
  },

  ehp_bx_cavidadoral: {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "EHP_BX_CAVIDADORAL",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/ehp_bx_cavidadoral",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido de cavidad oral.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-de-biopsia-de-mama-por-aspirado-con-aguja-fina-(baaf)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio de biopsia de mama por aspirado con aguja fina (BAAF)",
    description:
      "Estudio que consiste en tanto la valoración de calidad del material obtenido y el análisis microscópico del mismo para detección de procesos inflamatorios, infecciosos y neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-de-biopsia-de-mama-por-aspirado-con-aguja-fina-(baaf)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-de-biopsia-de-tiroides-por-aspirado-con-aguja-fina-(baaf)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio de biopsia de tiroides por aspirado con aguja fina (BAAF)",
    description:
      "Estudio que consiste en tanto la valoración de calidad del material obtenido y el análisis microscópico del mismo para detección de procesos inflamatorios, infecciosos y neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-de-biopsia-de-tiroides-por-aspirado-con-aguja-fina-(baaf)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-autopsia-de-feto": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de autopsia de feto",
    description:
      "Estudio que consiste en el análisis macroscópico de la anatomía humana en búsqueda de malformaciones y estadificación de edad gestacional. El estudio microscópico consiste en evaluación de cortes histológicos para determinar procesos infecciosos, cambios por hipoxia o traumáticos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-autopsia-de-feto",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "30 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3896 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "3506.40 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-amputacion-de-miembro-inferior": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de amputación de miembro inferior",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infecciosos, obstructivos vasculares y procesos neoplásico (malignos) para determinar sus características, células de origen, infiltración y bordes quirúrgicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-amputacion-de-miembro-inferior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "8 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-amputacion-de-miembro-superior": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de amputación de miembro superior",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infecciosos, obstructivos vasculares y procesos neoplásico (malignos) para determinar sus características, células de origen, infiltración y bordes quirúrgicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-amputacion-de-miembro-superior",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "8 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-autopsia-de-feto": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de autopsia de feto",
    description:
      "Estudio que consiste en el análisis macroscópico de la anatomía humana en búsqueda de malformaciones y estadificación de edad gestacional. El estudio microscópico consiste en la evaluación de cortes histológicos para determinar procesos infecciosos, cambios por hipoxia o traumáticos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-autopsia-de-feto",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "30 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3896 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "3506.40 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-baaf-de-mama": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de BAAF de mama",
    description:
      "Estudio que consiste en el análisis de laminillas con material extendido del tejido muestreado para la detección de procesos neoplásico (benignos y malignos), condiciones benignas o inflamatorias.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-baaf-de-mama",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Extendido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-ano-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de ano (B)",
    description:
      "Estudio que consiste en el análisis microscópico del muestreo del tejido para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-ano-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-bronquios": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de bronquios",
    description:
      "Estudio que consiste en el análisis microscópico de tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-bronquios",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-colon-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de colon (B)",
    description:
      "Estudio que consiste en el análisis microscópico del muestreo del tejido de colon para detección de procesos inflamatorios, obstructivos, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-colon-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-colon-y-recto-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de colon y recto (B)",
    description:
      "Estudio que consisten en el análisis microscópico del muestreo del tejido para detección de procesos inflamatorios, obstructivos, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-colon-y-recto-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-conjuntiva-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de conjuntiva (B)",
    description:
      "Estudio que consiste en el análisis microscópico del muestreo del tejido de mucosa para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-conjuntiva-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-cripta-anal": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de cripta anal",
    description:
      "Estudio que consiste en el análisis microscópico del muestreo del tejido de cripta anal para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-cripta-anal",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones:  -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-cuello-uterino-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de cuello uterino (B)",
    description:
      "Estudio especializado que identifica alteraciones estructurales, bioquímicas y funcionales en la celularidad del tejido.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-cuello-uterino-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido de cérvix.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Realizar una biopsia dirigida por colposcopia fijada en formol. Entregar en frasco tipo coprológico.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-duodeno-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de duodeno (B)",
    description:
      "Estudio que consiste en el análisis microscópico del muestreo del tejido de duodeno para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-duodeno-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones:  -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-endometrio-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de endometrio (B)",
    description:
      "Evaluación microscópica del tejido endometrial, en búsqueda de procesos infecciosos, cambios hormonales y tumorales benignos y/o malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-endometrio-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones:  -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-epiplon": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de epiplón",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-epiplon",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-esofago": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de esófago",
    description:
      "Evaluación microscópica de mucosa de esófago, en búsqueda de procesos infecciosos, inflamatorios y tumorales benignos y/o malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-esofago",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-esofago-2-muestras-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de esófago 2 muestras (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de la zona para la detección de procesos inflamatorios, infecciosos o neoplásicos, benignos y malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-esofago-2-muestras-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones:  -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-faringe": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de faringe",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-faringe",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-ganglio-linfatico-(c)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de ganglio linfático (C)",
    description:
      "Estudio que consiste en el análisis microscópico del tejido de para la detección de procesos inflamatorios, infecciosos o neoplásicos. Generalmente requiere estudios adicionales como inmunohistoquímica.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-ganglio-linfatico-(c)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido de glanglio linfático.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },
  "estudio-histopatologico-de-biopsia-de-glandula-mamaria": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de glándula mamaria",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos neoplásicos principalmente (benignos y malignos), así como inflamatorios e infecciosos. Puede requerir estudios adicionales como inmunohistoquímica.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-glandula-mamaria",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-glandula-salival": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de glándula salival",
    description:
      "Evaluación microscópica del tejido de glándula salival, en busqueda de procesos infecciosos, inflamatorios y tumorales benignos y/o malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-glandula-salival",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Entregar muestra rotulada en vaso recolector estéril (125 ml). Debe incluir orden médica, datos generales del paciente, información clínica y tipo de muestra con localización.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-glandula-suprarrenal": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de glándula suprarrenal",
    description:
      "Estudio que consiste en el análisis microscópico del tejido muestreado para la detección de procesos infecciosos y procesos neoplásico (malignos y benignos) para determinar sus caraterísticas, células de origen, infiltración.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-glandula-suprarrenal",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-glandulas-de-la-vulva-(a)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de glándulas de la vulva (A)",
    description:
      "Evaluación microscópica del tejido de glándulas de la vulva, en busqueda de procesos infecciosos, inflamatorios y tumorales benignos y/o malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-glandulas-de-la-vulva-(a)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-glandulas-de-la-vulva-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de glándulas de la vulva (B)",
    description:
      "Evaluación microscópica del tejido de glándulas de la vulva, en búsqueda de procesos infecciosos, inflamatorios y tumorales benignos y/o malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-glandulas-de-la-vulva-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación. En caso de que la muestra esté en bloques de parafina y/o laminillas no exponga a altas temperaturas.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-grasa-periumbilical-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de grasa periumbilical (B)",
    description:
      "Estudio que consiste en el análisis microscópico del tejido de grasa periumbilical para detección de amiloide.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-grasa-periumbilical-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-higado": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de hígado",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-higado",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-hueso": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de hueso",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-hueso",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-ileon-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de íleon (B)",
    description:
      "Estudio que consisten en el análisis microscópico del muestreo del tejido para detección de procesos inflamatorios, obstructivos, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-ileon-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-ileon-y-colon-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de íleon y colon (B)",
    description:
      "Estudio que consiste en el análisis microscópico del muestreo del tejido de mucosa de íleon y colon para detección de procesos inflamatorios, obstructivos, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-ileon-y-colon-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-intestino-delgado-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de intestino delgado (B)",
    description:
      "Estudio que consiste en el análisis microscópico del muestreo del tejido para detección de procesos inflamatorios, obstructivos, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-intestino-delgado-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-laringe": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de laringe",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-laringe",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-mediastino": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de mediastino",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-mediastino",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-medula-osea": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de médula ósea",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos neoplásicos (primarios o metastásicos) principalemente, así como inflamatorios e infecciosos. Puede requerir estudos adicionales como inmunohistoquímica.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-medula-osea",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-menisco-(a)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de menisco (A)",
    description:
      "Evaluación microscópica del tejido, en busqueda de procesos infecciosos, inflamatorios y tumorales benignos y/o malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-menisco-(a)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          " El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1085 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "976.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-miocardio": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de miocardio",
    description:
      "Estudio microscópico que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-miocardio",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-musculo": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de músculo",
    description:
      "Estudio microscópico que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-musculo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "6 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-nervio-periferico": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de nervio periférico",
    description:
      "Estudio que consiste en el análisis microscópico de nervio periférico para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-nervio-periferico",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "6 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-oido": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de oído",
    description:
      "Estudio que consisten en el análisis microscópico de tejido de oido, para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-oido",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-oreja-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de oreja (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de pabellón auricular para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-oreja-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-ovario-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de ovario (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de ovario para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-ovario-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-pancreas-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de páncreas (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de ovario para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-pancreas-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones:-El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-pene-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de pene (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de pene para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-pene-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "496 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "446 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-pericardio": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de pericardio",
    description:
      "Estudio microscópico que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-pericardio",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-peritoneo-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de peritoneo (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de peritoneo para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-peritoneo-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen.-Debe estar completamente inmerso en formol amortiguado al 10%.-No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-pezon-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de pezón (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de piel de pezón para detección de procesos inflamatorios o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-pezon-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-piel-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de piel (B)",
    description:
      "Estudio especializado que identifica alteraciones estructurales, bioquímicas y funcionales en la celularidad del tejido.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-piel-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido de piel.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "Realizar una biopsia incisional o exisional fijada en formol. Entregar en frasco tipo coprológico.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-pulmon": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de pulmón",
    description:
      "Estudio microscópico que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos, malignos o metastásicos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-pulmon",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-retroperitoneo": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de retroperitoneo",
    description:
      "Estudio que consiste en el análisis microscópico del tejido de la zona para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-retroperitoneo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-rinon": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de riñón",
    description:
      "Estudio microscópico que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos). Así como para valoraciones derivadas de trasplante renal. Puede requerir estudios adicionales como inmunofluorescencia o inmunohistoquímica.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-rinon",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-sistema-nervioso-central": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de sistema nervioso central",
    description:
      "Estudio microscópico que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos, malignos o metastásicos). Generalmente requiere estudios adicionales como de inmunohistoquímica.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-sistema-nervioso-central",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-tejidos-blandos": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de tejidos blandos",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-tejidos-blandos",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-tejidos-de-articulacion-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de tejidos de articulación (B)",
    description:
      "Evaluación microscópica del tejido de articulaciones, en búsqueda de procesos infecciosos, inflamatorios y tumorales benignos y malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-tejidos-de-articulacion-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-tejidos-de-cavidad-nasal-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de tejidos de cavidad nasal (B)",
    description:
      "Estudio que consiste en el análisis microscópico del muestreo del tejido de cavidad nasal para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-tejidos-de-cavidad-nasal-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-testiculo-(c)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de testículo (C)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de tésticulo, para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos). También permite el estudio para fertilidad.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-testiculo-(c)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-tiroides-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de tiroides (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de tiroides para detección de procesos inflamatorios y neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-tiroides-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-tumor-de-cuello-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de tumor de cuello (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de tumor de cuello para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-tumor-de-cuello-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen.-Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-ureter-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de ureter (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de ureter para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-ureter-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-uretra-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de uretra (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de uretra para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-uretra-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-valvula-ileocecal": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de válvula ileocecal",
    description:
      "Estudio que consiste en el aálisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-valvula-ileocecal",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-vejiga": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de vejiga",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-vejiga",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-via-biliar-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de vía biliar (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de vía biliar para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-via-biliar-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-de-yeyuno-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia de yeyuno (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de yeyuno para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-de-yeyuno-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%.-No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-endoscopica": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia endoscópica",
    description:
      "Evaluación microscópica de mucosa de estómago, en busqueda de procesos infecciosos, inflamatorios y tumorales benignos y/o malignos. Muestras de estómago, colón, esófago.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-endoscopica",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen.-Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-endoscopica-(2-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia endoscópica (2 muestras)",
    description:
      "Estudio que consisten en el análisis microscópico del muestreo del tejido de biopsias gástricas para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos). Muestras de estómago, colón, esófago.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-endoscopica-(2-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%.-No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-endoscopica-(3-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia endoscópica (3 muestras)",
    description:
      "Estudio que consiste en en análisis microscópico del tejido del órgano para la detección de procesos inflamatorios, infecciosos y neoplásicos (benignos y malignos). Muestras de estómago, colón, esófago.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-endoscopica-(3-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-endoscopica-(4-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia endoscópica (4 muestras)",
    description:
      "Estudio que consiste en el análisis microscópico del tejido muestreado para la detección de procesos infecciosos, inflamatorios y neoplasias (benignos y malignos). Muestras de estómago, colón, esófago.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-endoscopica-(4-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-endoscopica-(mas-de-5-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia endoscópica (más de 5 muestras)",
    description:
      "Estudio que consiste en el análisis microscópico del muestreo del tejido de biopsias gástricas para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos). Muestras de estómago, colón, esófago.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-endoscopica-(mas-de-5-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3896 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "3506.40 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-pleura-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia pleura (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de pleura para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-pleura-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-transrectal-de-prostata": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia transrectal de próstata",
    description:
      "Estudio que consiste en el análisis microscópico del tejido principalmente para la detección de procesos neoplásicos malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-transrectal-de-prostata",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-transuretral-de-prostata": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia transuretral de próstata",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos neoplásicos malignos principalmente y benignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-transuretral-de-prostata",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsia-vagina-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsia vagina (B)",
    description:
      "Evaluación microscópica de mucosa de vagina, en búsqueda de procesos infecciosos, inflamatorios y tumorales benignos y/o malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsia-vagina-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsias-de-colon-(mapeo)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsias de colon (mapeo)",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsias-de-colon-(mapeo)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsias-de-esofago-(3-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsias de esófago (3 muestras)",
    description:
      "Estudio que consiste en el análisis microscópico del tejido muestreado para la detección de procesos infecciosos, inflamatorios, cambios asociados a reflujo esofago-gástrico y neoplasias (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsias-de-esofago-(3-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsias-de-esofago-(4-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsias de esófago (4 muestras)",
    description:
      "Estudio que consiste en en el análisis microscópico del muestreo del tejido de biopsias de esófago para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsias-de-esofago-(4-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsias-de-esofago-(mas-de-5-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsias de esófago (más de 5 muestras)",
    description:
      "Estudio que consiste en el análisis microscópico del muestreo del tejido de biopsias de esófago para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsias-de-esofago-(mas-de-5-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "3896 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "3506.40 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsias-endoscopicas-(5-8-muestras)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsias endoscópicas (5-8 muestras)",
    description:
      "Estudio que consiste en el análisis microscópico del tejido muestreado para la detección de procesos infecciosos, inflamatorios y neoplasias (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsias-endoscopicas-(5-8-muestras)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-biopsias-transrectales-de-prostata-(mapeo)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de biopsias transrectales de próstata (mapeo)",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de neoplasias malignas principalmente, además de procesos inflamatorios o infecciosos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-biopsias-transrectales-de-prostata-(mapeo)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-calculos-o-litos-biliares-o-renales-(a)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de cálculos o litos biliares o renales (A)",
    description:
      "Evaluación macroscópica de las características de los litos incluyendo color, forma y tamaño. Se realizan extendidos para evaluación microscópica y determinar origen de los litos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-calculos-o-litos-biliares-o-renales-(a)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "2 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1085 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "976.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-casos-de-revision-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de casos de revisión (B)",
    description:
      "Estudio que consiste en la valoración de calidad de bloques de parafina y laminillas, así como el análisis microscópico de los tejidos en éstos para la detección de procesos inflamatorios, infecciosos o neoplásicos, benignos y malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-casos-de-revision-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-mama-(trucut)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio Histopatológico de mama (TRUCUT)",
    description:
      "Estudio que consiste en el análisis microscópico del tejido para la detección de procesos neoplásicos principalemte (benignos y malignos), así como inflamatorios e infecciosos. Puede requerir estudios adicionales como inmunohistoquímica.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-mama-(trucut)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-nodulectomia-bilateral-de-mama": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de nodulectomía bilateral de mama",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección tipo de proceso neoplásico (malignos y benignos) para determinar sus características, células de origen, infiltración y bordes quirúrgicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-nodulectomia-bilateral-de-mama",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-placenta-(c)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de placenta (C)",
    description:
      "Evaluación micro y macroscópica de la placenta que aporta datos significativos para el diagnóstico etiológico del parto prematuro, crecimiento intra útero retardado y muerte fetal; así como la busqueda de procesos infeciosos, inflamatorios y tumorales.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-placenta-(c)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-polipo-rectal-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de pólipo rectal (B)",
    description:
      "Estudio que consiste en el análisis microscópico de pólipo rectal para detección de procesos inflamatorios y neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-polipo-rectal-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-producto-de-enucleacion-ocular-ojo": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de producto de enucleación ocular/ojo",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del órgano para la detección de malformaciones, procesos inflamatorios, traumáticos, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-producto-de-enucleacion-ocular-ojo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-producto-de-nodulectomia-de-mama": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de producto de nodulectomía de mama",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del espécimen para la detección, clasificación e identificación de factores pronósticos de neoplasias malignas y benignas, principalmente. Puede requerir estudios adicionales como de inmunohistoquímica.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-producto-de-nodulectomia-de-mama",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-quiste-de-ovario-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de quiste de ovario (B)",
    description:
      "Estudio que consiste en el análisis microscópico de quiste de ovario para detección de procesos neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-quiste-de-ovario-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen.-Debe estar completamente inmerso en formol amortiguado al 10%.-No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-bilateral-de-mama": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección bilateral de mama",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infecciosos y procesos neoplásico (malignos y benignos) para determinar sus características, células de origen, infiltración y bordes quirúrgicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-bilateral-de-mama",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-bilateral-de-ovario": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección bilateral de ovario",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico de los especímenes para la detección de procesos inflamatorios, infecciosos o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-bilateral-de-ovario",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-amigdalas-palatinas-o-adenoides": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de amígdalas palatinas o adenoides",
    description:
      "Evaluación microscópica de amigdala palatina, en busqueda de procesos, infecciosos, inflamatorios y tumorales benignos y/o malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-amigdalas-palatinas-o-adenoides",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-apendice-cecal-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de apéndice cecal (B)",
    description:
      "Evaluación microscópica de apéndice cecal, en búsqueda de infecciosos, inflamatorios y tumorales benignos y/o malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-apendice-cecal-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: " Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-bazo": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de bazo",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos inflamatorios, traumáticos, infecciosos y neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-bazo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-capsula-de-quiste-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de cápsula de quiste (B)",
    description:
      "Estudio que consiste en el análisis microscópico de resección de cápsula de quiste para detección de procesos neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-capsula-de-quiste-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-colon": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de colon",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infecciosos, inflamatorios y procesos neoplásico (malignos y benignos) para determinar sus características, células de origen, infiltración y bordes quirúgicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-colon",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-colon-y-recto": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de colon y recto",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infecciosos, inflamatorios y procesos neoplásico (malignos y benignos) para determinar sus características, células de origen, infiltración y bordes quirúgicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "estudio-histopatologico-de-reseccion-de-colon-y-recto",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-conductos-deferentes-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de conductos deferentes (B)",
    description:
      "Evaluación microscópica de conductos deferentes, después de vasectomía o en búsqueda de procesos, infecciosos, inflamatorios y tumorales benignos y/o malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-conductos-deferentes-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-cono-cervical": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de cono cervical",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos inflamatorios, infecciosos y neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-cono-cervical",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-disco-intervertebral-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de cono cervical",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos inflamatorios, infecciosos y neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-disco-intervertebral-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-duodeno": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de duodeno",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos inflamatorios, traumáticos, infecciosos, malformaciones y neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-duodeno",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-embarazo-ectopico-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de embarazo ectópico (B)",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico de tejido de embarazo ectópico para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-embarazo-ectopico-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-epiplon": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de epiplón",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infeccioso y neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-epiplon",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-esofago": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de esófago",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infecciosos, inflamatorios y procesos neoplásico (malignos y benignos) para determinar sus características, células de origen, infiltración y bordes quirúrgicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-esofago",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-estomago": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de estómago",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infecciosos, inflamatorios y procesos neoplásico (malignos y benignos) para determinar sus características, células de origen, infiltración y bordes quirúrgicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-estomago",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-ganglio-cervical": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de ganglio cervical",
    description:
      "Estudio que consisten en el análisis microscópico de tejido de ganglio cervical, para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-ganglio-cervical",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-ganglios-linfaticos-(cadena-ganglionar)":
    {
      "@context": "https://schema.org",
      "@type": "MedicalTest",
      name: "Estudio histopatológico de resección de ganglios linfáticos (cadena ganglionar)",
      description:
        "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos inflamatorios, infecciosos y neoplásicos (benignos y malignos) primarios o secundarios.",
      recognizingAuthority: {
        "@type": "Organization",
        name: "Labopat",
        url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-ganglios-linfaticos-(cadena-ganglionar)",
      },
      additionalProperty: [
        {
          "@type": "PropertyValue",
          name: "Tiempo de entrega",
          value: "4 días hábiles.",
        },
        {
          "@type": "PropertyValue",
          name: "Tipo de muestra",
          value: "Tejido.",
        },
        {
          "@type": "PropertyValue",
          name: "Precio en sucursal",
          value: "2265 MXN",
        },
        {
          "@type": "PropertyValue",
          name: "Pago en línea",
          value: "2038.50 MXN",
        },
      ],
    },

  "estudio-histopatologico-de-reseccion-de-glandula-lagrimal-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de glándula lagrimal (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de glándula lagrimal para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-glandula-lagrimal-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-glandula-paratiroides-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de glándula paratiroides (B)",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido para la detección de procesos inflamatorios, infecciosos y neoplásicos, benignos y malignosT.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-glandula-paratiroides-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-glandula-salival-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de glándula salival (B)",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico de tejido de glándula salival para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-glandula-salival-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-glandula-suprarrenal": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de glándula suprarrenal",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infecciosos, inflamatorios y procesos neoplásico (malignos y benignos) para determinar sus características, células de origen e infiltración.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-glandula-suprarrenal",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-hemorroides-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de hemorroides (B)",
    description:
      "Evaluación microscópica de resección de hemorroides, en búsqueda de procesos infecciosos, inflamatorios y tumorales benignos y/o malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-hemorroides-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-higado-con-o-sin-tumor": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de hígado con o sin tumor",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos inflamatorios, infecciosos y neoplásicos (benignos y malignos) primarios o secundarios.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-higado-con-o-sin-tumor",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-hueso-con-o-sin-tumor": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de hueso con o sin tumor",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos inflamatorios, infecciosos y neoplásicos (benignos y malignos) primarios o secundarios.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-hueso-con-o-sin-tumor",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "7 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-ileon-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de íleon (B)",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico de tejido de íleon para detección de procesos obstructivos, inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-ileon-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-ileon-y-colon": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de íleon y colon",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infecciosos, inflamatorios y procesos neoplásico (malignos y benignos) para determinar sus características, células de origen, infiltración y bordes quirúrgicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-ileon-y-colon",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-intestino-delgado": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de intestino delgado",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos inflamatorios, traumáticos, infecciosos, malformaciones y neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-intestino-delgado",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-leiomiomas-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de leiomiomas (B)",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico de tejido de leiomiomas para detección de neoplasia (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-leiomiomas-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-lesion-paratesticular-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de lesión paratesticular (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de lesión paratesticular para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-lesion-paratesticular-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-lipoma-(a)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de lipoma (A)",
    description:
      "Evaluación microscópica de lipoma, en búsqueda de proceso benigno o maligno.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-lipoma-(a)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen.-Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1085 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "976.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-ovario-(c)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de ovario (C)",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico de tejido de ovario, para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-ovario-(c)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-pabellon-auricular-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de pabellón auricular (B)",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico de tejido de pabellón auricular para detección de procesos inflamatorios, infecciones o neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-pabellon-auricular-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen.-Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-pancreas": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de páncreas",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infecciosos y procesos neoplásico (malignos y benignos) para determinar sus características, células de origen, infiltración y bordes quirúrgicos",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-pancreas",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-polipo-endocervical-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de pólipo endocervical (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de pólipo endocervical para detección de procesos neoplásicos (benignos y malignos)",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-polipo-endocervical-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-polipo-gastrico-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de pólipo gástrico (B)",
    description:
      "Evaluación microscópica de pólipo gástrico, en búsqueda de procesos infecciosos, inflamatorios y tumorales benignos, malignos y evaluación de los márgenes de resección.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-polipo-gastrico-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-prostata": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de próstata",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos inflamatorios y neoplásicos (benignos y malignos)",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-prostata",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "5 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-pulmon": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de pulmón",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infecciosos, inflamatorios y procesos neoplásico (malignos y benignos) para determinar sus características, células de origen, infiltración y bordes quirúrgicos",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-pulmon",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-quiste-de-epididimo-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de quiste de epidídimo (B)",
    description:
      "Estudio que consiste en el análisis microscópico de tejido de quiste epidídimo para detección de procesos neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-quiste-de-epididimo-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-quiste-sinovial-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de quiste sinovial (B)",
    description:
      "Evaluación microscópica de quiste sinovial, en búsqueda de procesos infecciosos, inflamatorios, hiperplásicos y tumorales benignos y/o malignos y evaluación de los márgenes de resección.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-quiste-sinovial-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-retroperitoneo-con-y-sin-tumor": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de retroperitoneo con y sin tumor",
    description:
      "Estudio que consiste en el análisis microscópico para la detección y clasificación de neoplasias benignas y malignas principalmente. Generalmente requiere esudios adicionales de inmunohistoquímica.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-retroperitoneo-con-y-sin-tumor",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-rinon": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de riñón",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos infecciosos, inflamatorios y procesos neoplásico (malignos y benignos) para determinar sus características, células de origen, infiltración y bordes quirúrgicos",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-rinon",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2694 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2424.60 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-saco-herniario-(b)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de saco herniario (B)",
    description:
      "Evaluación macroscópica y microscópica de saco herniario para descartar presencia de tejidos benignos y descartar malignidad.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-saco-herniario-(b)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Indicaciones",
        value:
          "El espécimen debe entregarse en la sucursal seleccionada, cumpliendo las siguientes condiciones: -El contenedor debe incluir nombre del paciente, sexo, fecha de nacimiento y espécimen. -Debe estar completamente inmerso en formol amortiguado al 10%. -No debe exponerse a altas temperaturas y no necesita refrigeración ni congelación.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1725 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "1552.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-testiculo": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de testículo",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos inflamatorios, traumáticos, infecciosos, reproductivos y neoplásicos (benignos y malignos).",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-testiculo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-trompas-de-falopio-(a)": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de trompas de falopio (A)",
    description:
      "Evaluación microscópica de trompas de falopio, en busqueda de procesos infecciosos, inflamatorios y tumorales benignos, premaligno y/o malignos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-trompas-de-falopio-(a)",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "3 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido fijado en formol.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "1085 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "976.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-tumor-de-ano": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de tumor de ano",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos neoplásicos (benignos y malignos). Determinar sus características, células de origen, infiltración y bordes quirúrgicos.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-tumor-de-ano",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },

  "estudio-histopatologico-de-reseccion-de-tumor-de-bazo": {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Estudio histopatológico de resección de tumor de bazo",
    description:
      "Estudio que consiste en el análisis macroscópico y microscópico del tejido muestreado para la detección de procesos neoplásicos (benignos y malignos). Determinar sus características, células de origen e infiltración.",
    recognizingAuthority: {
      "@type": "Organization",
      name: "Labopat",
      url: "https://www.labopat.mx/estudio/estudio-histopatologico-de-reseccion-de-tumor-de-bazo",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Tiempo de entrega",
        value: "4 días hábiles.",
      },
      {
        "@type": "PropertyValue",
        name: "Tipo de muestra",
        value: "Tejido.",
      },
      {
        "@type": "PropertyValue",
        name: "Precio en sucursal",
        value: "2265 MXN",
      },
      {
        "@type": "PropertyValue",
        name: "Pago en línea",
        value: "2038.50 MXN",
      },
    ],
  },
};
